{
    "ops.inbox.subject_assignment": "Assignment confirmed",
    "ops.inbox.subject_offer": "Assignment offer",
    "ops.inbox.subject_referral": "Referral qualified",
    "ops.inbox.subject_ironing_accepted": "Ironing accepted",
    "ops.inbox.subject_ironing_completed": "Ironing completed",
    "ops.inbox.subject_payment": "Payment failure",
    "ops.inbox.subject_grace_first": "First reminder · household members",
    "ops.inbox.subject_grace_second": "Second reminder · household members",
    "ops.inbox.subject_seat": "Invitation to add a member",
    "ops.inbox.subject_grace_refused": "Unregistered laundry refused",
    "ops.inbox.subject_swap": "Worker change request",
    "ops.inbox.subject_cancelled": "Visit cancelled",
    "ops.inbox.description": "Notification processing records, not a conversation or proof of receipt.",
    "ops.inbox.scope": "Togo · {count} rows shown, up to {limit} · availability order · Lomé time (UTC).",
    "ops.inbox.refresh": "Refresh",
    "ops.inbox.retry": "Try again",
    "ops.inbox.refresh_error": "Could not refresh: the rows shown are from the last successful load.",
    "ops.inbox.error": "Unable to load notifications.",
    "ops.inbox.empty": "No notifications in this list.",
    "ops.inbox.loading": "Loading notifications…",
    "ops.inbox.template": "Template / message",
    "ops.inbox.recipient": "Recipient",
    "ops.inbox.channel": "Channel",
    "ops.inbox.status": "Processing",
    "ops.inbox.available": "Available from",
    "ops.inbox.evidence": "A recorded send proves neither receipt nor reading. Local simulations are identified separately.",
    "ops.inbox.attempts": "Attempts: {count}",
    "ops.inbox.status_pending": "Pending",
    "ops.inbox.status_failed": "Failed",
    "ops.inbox.status_quiet": "Not sent · quiet hours",
    "ops.inbox.status_in_app": "Available in app",
    "ops.inbox.status_local": "Local simulation",
    "ops.inbox.status_sent": "Send recorded",
    "ops.inbox.channel_in_app": "In app",
    "ops.inbox.channel_push": "Push",
    "ops.inbox.channel_sms": "SMS",
    "ops.inbox.channel_whatsapp": "WhatsApp",
    "ops.inbox.role_subscriber": "Subscriber",
    "ops.inbox.role_worker": "Worker",
    "ops.inbox.role_operator": "Operator",
    "app.demo_banner": "Demo mode · sample data",
    "common.action.back": "Back",
    "common.loading": "Loading…",
    "common.navigation.main": "Main navigation",
    "error.gps.body": "Make sure location is enabled. Step outside if needed.",
    "error.gps.title": "Can't find GPS.",
    "error.network.body": "You can keep going. Everything is saved. We'll sync as soon as we can.",
    "error.network.title": "No connection.",
    "error.permission.camera.cta": "Open settings",
    "error.permission.camera.title": "Camera access denied.",
    "error.retry.cta": "Try again",
    "error.server.body": "Try again in a minute. If it sticks, call the office.",
    "error.server.title": "Small problem on our end.",
    "marketing.availability.body": "Wherever you are in the city, a verified laundress can come to you.",
    "marketing.availability.head": "Washed, throughout Lomé.",
    "marketing.seo.coverage.body": "Washed serves every neighbourhood in Lomé. Sign up with your number and neighbourhood, and the Washed team will get back to you.",
    "marketing.seo.coverage.faq.answer": "All of them, in every municipality of the city. Just give your neighbourhood when you sign up.",
    "marketing.seo.coverage.short": "Washed serves every neighbourhood in Lomé.",
    "marketing.seo.zones.link": "See the neighbourhoods we serve in Lomé",
    "marketing.seo.workers.assignments": "Joining the list does not guarantee immediate assignments: they depend on demand from nearby households and on operational capacity.",
    "marketing.zones.title": "In-home laundry in every neighbourhood of Lomé",
    "marketing.zones.intro": "Washed serves all of Lomé. This page lists the city’s main neighbourhoods and municipalities to help you find yours.",
    "marketing.zones.list.intro": "The names below are grouped by municipality to help people in Lomé find their neighbourhood.",
    "marketing.zones.list.name": "Lomé neighbourhoods served by Washed",
    "marketing.zones.note.title": "Is your neighbourhood missing from the list?",
    "marketing.zones.note.body": "If it is in Lomé, it is served. Just mention it when you sign up.",
    "marketing.closing.eyebrow": "The invitation",
    "marketing.closing.fine": "Your contact details stay private. You can leave the list at any time.",
    "marketing.closing.form.loading": "Sending…",
    "marketing.closing.form.placeholder.email": "your@email.com (optional)",
    "marketing.closing.form.placeholder.phone": "+228 90 12 34 56",
    "marketing.closing.form.placeholder.quartier": "Your neighbourhood (optional)",
    "marketing.closing.form.submit": "Join the list",
    "marketing.closing.form.success": "Spot #{position} held. See you soon.",
    "marketing.closing.h2": "Sign up and Washed will get back to you.",
    "marketing.closing.invitation": "Leave your number and neighbourhood. Signing up is free and does not commit you to a subscription.",
    "marketing.closing.lead": "Across Lomé, in every neighbourhood.",
    "marketing.compare.avec.h3": "A visit you can plan around.",
    "marketing.compare.avec.item1": "One or two visits a month, on your chosen day and time window.",
    "marketing.compare.avec.item2": "Your regular laundress returns, unless she is unavailable.",
    "marketing.compare.avec.item3": "A vetted laundress: identity, references and an interview.",
    "marketing.compare.avec.item4": "Pay through Mixx by Yas or Flooz, with a receipt in the app.",
    "marketing.compare.avec.item5": "Pause free of charge for up to 2 months a year. Cancel anytime.",
    "marketing.compare.avec.tag": "With Washed",
    "marketing.compare.head.body": "Your laundry stays at home. What changes is how you plan the next wash.",
    "marketing.compare.head.title": "The same laundry. Less to arrange.",
    "marketing.compare.sans.h3": "It all falls to you.",
    "marketing.compare.sans.item1": "Finding someone available for each wash.",
    "marketing.compare.sans.item2": "Getting in touch again and arranging a time.",
    "marketing.compare.sans.item3": "Explaining your routine whenever someone new comes.",
    "marketing.compare.sans.item4": "Handling payment directly, sometimes without a written record.",
    "marketing.compare.sans.item5": "Finding a solution yourself if the visit falls through.",
    "marketing.compare.sans.tag": "Without Washed",
    "marketing.consent.label": "I accept the <a href=\"/terms\">terms</a> and <a href=\"/privacy\">privacy policy</a>.",
    "marketing.footer.col.mentions.h5": "Notices",
    "marketing.footer.col.mentions.link1": "Privacy",
    "marketing.footer.col.mentions.link2": "Terms",
    "marketing.footer.col.mentions.link3": "Data deletion",
    "marketing.footer.col.mentions.link4": "Site map",
    "marketing.footer.col.service.h5": "The service",
    "marketing.footer.col.service.link1": "How it works",
    "marketing.footer.col.service.link2": "Pricing",
    "marketing.footer.col.service.link3": "Coverage",
    "marketing.footer.col.service.link4": "Guarantees",
    "marketing.footer.col.washed.h5": "Washed",
    "marketing.footer.col.washed.link1": "Become a laundress",
    "marketing.footer.col.washed.link2": "Founder",
    "marketing.footer.col.washed.link3": "Press",
    "marketing.footer.col.washed.link4": "contact@washedafrica.com",
    "marketing.footer.colophon": "The platform connecting Lomé households with verified independent laundresses. Monthly subscription, payment via Mixx by Yas & Flooz. The soap, the water, and the basin stay yours.",
    "marketing.footer.composed": "Set in Geist & Cormorant Garamond",
    "marketing.footer.copyright": "© 2026 Washed SAS · All rights reserved",
    "marketing.form.error.challenge": "The anti-bot check didn't go through. Please try again.",
    "marketing.form.error.consent": "Tick the box to accept the terms.",
    "marketing.form.error.email": "This email address doesn't look right.",
    "marketing.form.error.network": "No connection. Check your network and try again.",
    "marketing.form.error.phone": "This number looks incomplete. E.g. 90 12 34 56.",
    "marketing.form.error.server": "Something went wrong on our side. Try again in a moment.",
    "marketing.form.hint.phone": "E.g. 90 12 34 56 — we add the +228.",
    "marketing.form.label.email": "Email (optional)",
    "marketing.form.label.name": "Your first name",
    "marketing.form.label.phone": "Phone number",
    "marketing.form.label.quartier": "Neighbourhood (optional)",
    "marketing.form.verifying": "Checking…",
    "marketing.hero.eyebrow": "Lomé · every neighbourhood",
    "marketing.hero.form.error": "Check your number and try again.",
    "marketing.hero.form.loading": "Sending…",
    "marketing.hero.form.placeholder.email": "your@email.com (optional)",
    "marketing.hero.form.placeholder.phone": "+228 90 12 34 56",
    "marketing.hero.form.placeholder.quartier": "Your neighbourhood (optional)",
    "marketing.hero.form.submit": "Join the list",
    "marketing.hero.form.success": "You’re #{position} on the list. Washed will get back to you.",
    "marketing.hero.headline.line1": "Laundry, done.",
    "marketing.hero.headline.line2": "Without you.",
    "marketing.hero.label.akouvi": "Akouvi visits Tuesday morning",
    "marketing.hero.label.payment": "Mixx by Yas payment confirmed",
    "marketing.hero.subhead": "A trained laundress, in your home. Your water, your soap. One or two visits a month, making room for everything else.",
    "marketing.hero.trust": "Verified laundresses · Mixx by Yas & Flooz · Cancel anytime",
    "marketing.lettre.body.p1": "Life moves fast. Weekends are short. Spending Sunday afternoons hand-washing clothes isn't a real option for my generation.",
    "marketing.lettre.body.p2": "In Lomé, the model that's always worked is a laundress in your home. She uses your water and your soap. It isn't always the cheapest. Not everyone can afford it. And there's reliability. You never know if she'll show up. If she'll be on time. If she'll be back next month. Washed brings a cheaper service, with the same quality. Or better.",
    "marketing.lettre.body.p3": "Washed keeps that model. A trained laundress visits your home once or twice a month. She uses your water and your soap. You pay your subscription on the platform. Never to the laundress directly. I built this for every African who wants to buy back their time. Young people. Businesswomen. Anyone who doesn't want to spend their weekends on this kind of chore.",
    "marketing.lettre.eyebrow": "A note from the founder",
    "marketing.lettre.h2": "To buy back time. At the lowest price.",
    "marketing.lettre.signature.name": "Ryan T.",
    "marketing.lettre.signature.title": "Founder. Washed",
    "marketing.lettre.who": "From Ryan T.",
    "marketing.marketplace.body": "Washed isn't a laundromat. It's the platform that connects you with a trusted, vetted independent washerwoman — and handles the scheduling and payment, securely.",
    "marketing.marketplace.tagline": "You keep your laveuse, month after month.",
    "marketing.nav.lang_aria": "Change language",
    "marketing.nav.quartiers": "Coverage",
    "marketing.nav.service": "Service",
    "marketing.nav.skip": "Skip to content",
    "marketing.nav.tarif": "Pricing",
    "marketing.nav.waitlist": "Sign up",
    "marketing.nav.worker": "Become a laundress",
    "marketing.phone.cta.book": "Book a visit",
    "marketing.service.act1.body": "One or two visits a month. A day and time window that suit you. Pay for your subscription through Mixx by Yas or Flooz.",
    "marketing.service.act1.day": "Make a plan",
    "marketing.service.act1.meta_label": "Your choice",
    "marketing.service.act1.meta_value": "1 or 2 visits / month",
    "marketing.service.act1.title": "Choose your rhythm.",
    "marketing.service.act2.body": "Your laundry, water, soap and a basin. The wash happens at home, with the things you already use.",
    "marketing.service.act2.day": "Get ready",
    "marketing.service.act2.meta_label": "What to have ready",
    "marketing.service.act2.meta_value": "Water · soap · basin",
    "marketing.service.act2.title": "Set out the essentials.",
    "marketing.service.act3.body": "A vetted laundress comes to wash on-site. Your regular laundress returns by default; if she is unavailable, Washed arranges a replacement.",
    "marketing.service.act3.day": "The visit",
    "marketing.service.act3.meta_label": "Continuity",
    "marketing.service.act3.meta_value": "A relationship that grows",
    "marketing.service.act3.title": "She takes it from here.",
    "marketing.service.head": "A rhythm for your laundry. More room for your day.",
    "marketing.service.subhead": "From choosing your plan to welcoming your laundress, here is how it works.",
    "marketing.stats.2.desc": "One or two scheduled visits a month, same laundress each time. She knows your home.",
    "marketing.stats.2.label": "The rhythm",
    "marketing.stats.2.unit": "visits / month",
    "marketing.stats.3.desc": "Mobile money only. Mixx by Yas or Flooz. Through the platform, never hand-to-hand.",
    "marketing.stats.3.label": "The payment",
    "marketing.stats.3.unit": "mobile money",
    "marketing.worker.bullet1": "Before the first visits: identity verification, references and an in-person interview.",
    "marketing.worker.bullet2": "Compensation and any bonuses are defined in advance and paid through the platform.",
    "marketing.worker.bullet3": "You work in clients’ homes with their water, their soap, their basin, the work you already know.",
    "marketing.worker.bullet4": "Visits are grouped by area and time window to reduce unnecessary travel.",
    "marketing.worker.bullet5": "When capacity allows, the same laundress returns to the same households to build trust.",
    "marketing.worker.card.eyebrow": "Apply · 2026 season",
    "marketing.worker.card.h3": "«I want to become a Washed laundress.»",
    "marketing.worker.card.loading": "Sending…",
    "marketing.worker.card.placeholder.email": "your@email.com (optional)",
    "marketing.worker.card.placeholder.name": "Your first name",
    "marketing.worker.card.placeholder.phone": "Your number · +228 …",
    "marketing.worker.card.placeholder.quartier": "Your neighbourhood",
    "marketing.worker.card.submit": "Send my application",
    "marketing.worker.card.success": "Application received. We will be in touch within 7 days.",
    "marketing.worker.eyebrow": "Become a laundress",
    "marketing.worker.h2": "Skilled work. Recognised and respected.",
    "marketing.worker.lede": "The service rests on the skill of independent laundresses. Washed organises visits, sets compensation in advance and supports the relationship with each household.",
    "ops.audit.cta_filter": "Filter",
    "ops.audit.current_filter": "Current filter",
    "ops.audit.description": "Log of available audit actions.",
    "ops.audit.event.matching": "Matching",
    "ops.audit.event.privacy": "Privacy",
    "ops.audit.event.refund": "Refund",
    "ops.audit.filter": "Filter",
    "ops.audit.filter_all": "All",
    "ops.audit.immutable": "Immutable history",
    "ops.audit.title": "Audit",
    "ops.audit.detail.back": "Back to the log →",
    "ops.audit.detail.load_error": "Couldn’t load this event.",
    "ops.audit.detail.missing_id": "Missing event ID.",
    "ops.audit.detail.not_found": "Event not found.",
    "ops.brand": "Washed Operator Console",
    "ops.console.brand": "washed",
    "ops.console.command_palette.close": "Close palette",
    "ops.console.command_palette.empty": "No results. Try “visits”, “washerwoman Ama”, “refund”…",
    "ops.console.command_palette.hint_dismiss": "Esc",
    "ops.console.command_palette.hint_navigate": "Arrows",
    "ops.console.command_palette.hint_open": "Enter",
    "ops.console.command_palette.open": "Open command palette",
    "ops.console.command_palette.placeholder": "Type a command or a search…",
    "ops.console.drawer.close": "Close drawer",
    "ops.console.drawer.empty": "Select a row to view details on the right.",
    "ops.console.idle.continue": "Stay signed in",
    "ops.console.idle.signout": "Sign out now",
    "ops.console.idle.warn_body": "No activity for 28 minutes. Click or press a key to stay signed in.",
    "ops.console.idle.warn_title": "You will be signed out soon",
    "ops.console.offline_banner.body": "Writes (assign, refund, pause) are unavailable until the network is back.",
    "ops.console.offline_banner.title": "Office offline",
    "ops.console.placeholder.body": "This screen is part of the operator console under construction. The real component arrives in Sprint {sprint}.",
    "ops.console.placeholder.kicker": "BUILDING · SPRINT {sprint}",
    "ops.console.boundary.failed": "This page could not be shown.",
    "ops.console.boundary.keep": "Reload to continue. The console will ask you to sign in again.",
    "ops.console.boundary.reload": "Reload",
    "ops.console.boundary.updated": "The console was updated while this tab was open.",
    "ops.console.sidebar.collapse": "Collapse menu",
    "ops.console.sidebar.expand": "Expand menu",
    "ops.console.skip_to_main": "Skip to main content",
    "ops.console.subtitle": "Desktop console · Lomé",
    "ops.console.topbar.notifications": "Notifications",
    "ops.console.topbar.operator_menu": "Operator menu",
    "ops.console.topbar.search_placeholder": "Search subscriber, washerwoman, visit…",
    "ops.console.topbar.settings": "Settings",
    "ops.console.topbar.shortcut_hint": "⌘ K",
    "ops.console.topbar.signout": "Sign out",
    "ops.dashboard.assign": "Assign",
    "ops.dashboard.description": "Priority view of the day and the execution chain.",
    "ops.dashboard.drawer_eta": "Time slot",
    "ops.dashboard.drawer_status": "Status",
    "ops.dashboard.drawer_subscriber": "Subscriber",
    "ops.dashboard.drawer_title": "Row details",
    "ops.dashboard.drawer_worker": "Washerwoman",
    "ops.dashboard.metrics": "Metrics",
    "ops.dashboard.notifications_due": "notifications due",
    "ops.dashboard.open": "Open",
    "ops.dashboard.open_route": "Open scheduling",
    "ops.dashboard.readiness": "Service readiness",
    "ops.dashboard.risks": "risks",
    "ops.dashboard.shortcut.matching_desc": "Run a priority matching.",
    "ops.dashboard.shortcut.routing": "Routing",
    "ops.dashboard.shortcut.routing_desc": "Adjust route load.",
    "ops.dashboard.shortcuts": "Shortcuts",
    "ops.dashboard.tabs.all": "All",
    "ops.dashboard.tabs.modified": "Modified",
    "ops.dashboard.tabs.risk": "Risk",
    "ops.dashboard.tabs.unassigned": "Unassigned",
    "ops.dashboard.title": "Dashboard",
    "ops.disputes.badge_open": "open",
    "ops.disputes.cta_escalate": "Escalate",
    "ops.disputes.cta_resolve": "Resolve",
    "ops.disputes.description": "Handling of incoming disputes.",
    "ops.disputes.escalated": "Escalated",
    "ops.disputes.evidence": "Evidence",
    "ops.disputes.evidence_value": "No evidence",
    "ops.disputes.list_label": "Dispute list",
    "ops.disputes.resolved": "Resolved",
    "ops.disputes.title": "Disputes",
    "ops.drawer.label": "Side panel",
    "ops.economy.active_subs": "Active subscriptions",
    "ops.economy.badge_alarm": "Alarm",
    "ops.economy.badge_ok": "OK",
    "ops.economy.churn_hint": "Actives × monthly churn (70% annual retention).",
    "ops.economy.churn_replacement": "Churn replacement (estimated)",
    "ops.economy.duration_column_avg": "Average duration (min)",
    "ops.economy.duration_column_month": "Month",
    "ops.economy.duration_column_visits": "Visits",
    "ops.economy.duration_empty": "No measured visit.",
    "ops.economy.duration_hint": "Last 6 months — rainy-season early warning.",
    "ops.economy.duration_title": "Average visit duration",
    "ops.economy.error": "Couldn’t load the metrics.",
    "ops.economy.family_mix": "Family-plan share",
    "ops.economy.family_mix_hint": "FE + FC share of active subscriptions — alarm below the threshold.",
    "ops.economy.gross_adds": "New subscriptions this month",
    "ops.economy.link": "Economy & levers",
    "ops.economy.momo_trigger": "MoMo fee negotiation",
    "ops.economy.momo_trigger_hint": "Trigger: {count} active subscriptions.",
    "ops.economy.momo_volume": "MoMo volume this month",
    "ops.economy.repassage_dispatcher": "Dedicated-dispatch threshold",
    "ops.economy.repassage_jobs": "Ironing jobs this month",
    "ops.economy.repassage_recalibration": "Fee recalibration threshold",
    "ops.economy.subtitle": "Levers, thresholds and triggers — computed from live data.",
    "ops.economy.threshold_label": "Threshold",
    "ops.economy.threshold_reached": "Threshold reached",
    "ops.economy.threshold_watching": "Watching",
    "ops.economy.title": "Economy",
    "ops.economy.unavailable": "Unavailable",
    "ops.economy.workers_smig": "Washerwomen below minimum wage (this month)",
    "ops.economy.workers_smig_hint": "Month-to-date pay below {amount}.",
    "ops.error.session_expired": "Session expired. Sign in again to continue.",
    "ops.extrawash.confirm_cta": "Confirm & assign",
    "ops.extrawash.decline_cta": "Decline",
    "ops.extrawash.decline_reason_label": "Decline reason",
    "ops.extrawash.empty": "No pending requests",
    "ops.extrawash.error.cycle_limit": "This household already has a confirmed extra wash this cycle.",
    "ops.extrawash.error.date_out_of_window": "This date can no longer be booked (tomorrow to day +14). Decline the request.",
    "ops.extrawash.error.slot_taken": "This washer already has a visit in that slot. Choose another.",
    "ops.extrawash.status_confirmed": "Confirmed",
    "ops.extrawash.status_declined": "Declined",
    "ops.extrawash.status_expired": "Expired",
    "ops.extrawash.status_requested": "Requested",
    "ops.fairuse.open_reviews": "Open reviews",
    "ops.feedback.audit_filtered": "Audit filter applied.",
    "ops.feedback.blocklist_added": "Restriction added.",
    "ops.feedback.dispute_escalated": "Dispute escalated.",
    "ops.feedback.dispute_resolved": "Dispute resolved.",
    "ops.feedback.forced_update_toggled": "Force mode toggled.",
    "ops.feedback.login_otp_sent": "OTP code sent.",
    "ops.feedback.login_verified": "Sign-in verified.",
    "ops.feedback.matching_accepted": "Matching accepted.",
    "ops.feedback.matching_rejected": "Matching rejected.",
    "ops.feedback.notifications_delivered": "Notifications sent.",
    "ops.feedback.payment_retry_queued": "Payment retry queued.",
    "ops.feedback.payout_batch_started": "Payout batch started.",
    "ops.feedback.payout_retry_queued": "Payout retry scheduled.",
    "ops.feedback.readiness_checked": "Readiness check completed.",
    "ops.feedback.refund_issued": "Refund issued.",
    "ops.feedback.report_exported": "Report exported.",
    "ops.feedback.route_plan_approved": "Route plan approved.",
    "ops.feedback.route_plan_risk_acknowledged": "Risk acknowledged.",
    "ops.feedback.subscriber_privacy_handled": "Subscriber privacy handled.",
    "ops.feedback.worker_privacy_handled": "Washerwoman privacy handled.",
    "ops.flags.action_disable": "Disable",
    "ops.flags.action_enable": "Enable",
    "ops.flags.audience_all": "Everyone",
    "ops.flags.audience_beta": "Beta",
    "ops.flags.column.action": "Action",
    "ops.flags.column.audience": "Audience",
    "ops.flags.column.flag": "Flag",
    "ops.flags.column.state": "State",
    "ops.flags.column.updated": "Updated",
    "ops.flags.confirm_apply": "Confirm",
    "ops.flags.confirm_cancel": "Cancel",
    "ops.flags.confirm_disable": "Disable “{flag}” for all clients?",
    "ops.flags.confirm_enable": "Enable “{flag}” for all clients?",
    "ops.flags.empty": "No flags configured.",
    "ops.flags.error": "Couldn’t load the flags.",
    "ops.flags.link": "Feature flags",
    "ops.flags.state_off": "Disabled",
    "ops.flags.state_on": "Enabled",
    "ops.flags.subtitle": "Activation by configuration — no deploy, no app update.",
    "ops.flags.title": "Feature flags",
    "ops.flags.toggle_error": "The change wasn’t saved. Try again.",
    "ops.header.command_palette": "Command palette",
    "ops.kpi.disputes.open": "Open disputes",
    "ops.kpi.payments.exceptions": "Payment exceptions",
    "ops.kpi.privacy.pending": "Privacy pending",
    "ops.kpi.queue.pending": "Queue pending",
    "ops.kpi.routes.overload": "Routes at risk",
    "ops.kpi.sos.open": "Open SOS",
    "ops.kpi.visits.risk": "Visits at risk",
    "ops.liveops.description": "Real-time mapping of interventions.",
    "ops.liveops.drawer_alert_desc": "Operational alert",
    "ops.liveops.drawer_alert_title": "Alert",
    "ops.liveops.drawer_desc": "Real-time feed of interventions.",
    "ops.liveops.drawer_support": "Support",
    "ops.liveops.drawer_support_detail": "Operational support available 24/7.",
    "ops.liveops.drawer_title": "Live ops",
    "ops.liveops.kpi.at_risk": "At risk",
    "ops.liveops.kpi.finished": "Finished",
    "ops.liveops.kpi.in_progress": "In progress",
    "ops.liveops.kpi.unsolved": "Unresolved",
    "ops.liveops.kpi.upcoming": "Upcoming",
    "ops.liveops.map.detail.address": "Address",
    "ops.liveops.map.detail.close": "Close visit details",
    "ops.liveops.map.detail.payment": "Payment",
    "ops.liveops.map.detail.payment_unavailable": "See Payments",
    "ops.liveops.map.detail.status": "Status",
    "ops.liveops.map.detail.subscriber": "Subscriber",
    "ops.liveops.map.detail.title": "Visit details",
    "ops.liveops.map.detail.window": "Time slot",
    "ops.liveops.map.detail.worker": "Washerwoman",
    "ops.liveops.map.detail.worker_unassigned": "Unassigned",
    "ops.liveops.title": "Live tracking",
    "ops.login.badge": "Operator sign-in",
    "ops.login.cta_send": "Send code",
    "ops.login.cta_verify": "Verify",
    "ops.login.description": "Access the operations workstation after verification.",
    "ops.login.otp_label": "OTP code",
    "ops.login.phone_label": "Operator number",
    "ops.login.title": "Operator sign-in",
    "ops.matching.auto.awaiting": "Auto · awaiting acceptance",
    "ops.matching.auto.awaiting_detail": "{worker}, expires in {minutes} min",
    "ops.matching.auto.awaiting_detail_expired": "{worker}, offer expired",
    "ops.matching.auto.due_in": "Due in {minutes} min",
    "ops.matching.auto.fresh": "Auto · finding a washerwoman",
    "ops.matching.auto.needs_review": "Needs review · manual assignment",
    "ops.matching.auto.offered_count": "{count} washerwomen offered",
    "ops.matching.auto.overdue": "Past due",
    "ops.matching.auto.override": "Force another washerwoman",
    "ops.matching.auto.why": "Why this washerwoman",
    "ops.matching.candidates.title": "Candidates — sorted by proximity & load",
    "ops.matching.cta_accept": "Accept",
    "ops.matching.cta_propose": "Propose",
    "ops.matching.cta_reject": "Reject",
    "ops.matching.cta_send": "Send proposal",
    "ops.matching.current": "Active matching",
    "ops.matching.current_detail": "Current matching details",
    "ops.matching.current_title": "Assignment in progress",
    "ops.matching.decision_log": "Decision log",
    "ops.matching.decision_log_body": "Decision recorded for audit.",
    "ops.matching.description": "Controlled matching of requests to available washerwomen.",
    "ops.matching.drawer_desc": "Matching details",
    "ops.matching.drawer_stat_candidates": "Active candidates",
    "ops.matching.drawer_stat_score": "Average score",
    "ops.matching.drawer_stat_wait": "Wait time",
    "ops.matching.drawer_title": "Matching",
    "ops.matching.empty": "No pending requests.",
    "ops.matching.lane.all": "All ({count})",
    "ops.matching.lane.needs_review": "Needs review ({count})",
    "ops.matching.lane.needs_review_empty": "No assignments to review.",
    "ops.matching.queue.label": "Matching queue",
    "ops.matching.queue.title": "{count} waiting",
    "ops.matching.reason.continuity": "Usual washerwoman",
    "ops.matching.reason.proximity": "{km} km away",
    "ops.matching.reason.rating": "Rating {rating}/5",
    "ops.matching.reason.workload": "Load {remaining}/{max} free",
    "ops.matching.score.label": "Score",
    "ops.matching.sla.warning": "SLA {hours}h{minutes}",
    "ops.matching.status.accepted": "Accepted",
    "ops.matching.status.almost_full": "LOAD ALMOST FULL",
    "ops.matching.status.full": "FULL",
    "ops.matching.status.pending": "Pending",
    "ops.matching.status.rejected": "Rejected",
    "ops.matching.tabs.assigned": "Assigned",
    "ops.matching.tabs.pending": "Pending",
    "ops.matching.tabs.rejected": "Rejected",
    "ops.matching.title": "Matching",
    "ops.matching.visits": "visits",
    "ops.metrics.updated": "Updated",
    "ops.nav.audit": "Audit",
    "ops.nav.dashboard": "Dashboard",
    "ops.nav.disputes": "Disputes",
    "ops.nav.group.finance": "Finance",
    "ops.nav.group.org": "Organization",
    "ops.nav.group.people": "Profiles",
    "ops.nav.group.today": "Today",
    "ops.nav.live_ops": "Live ops",
    "ops.nav.matching": "Matching",
    "ops.nav.notifications": "Notifications",
    "ops.nav.payments": "Payments",
    "ops.nav.planning": "Planning",
    "ops.nav.profiles": "Profiles",
    "ops.nav.reports": "Reports",
    "ops.nav.settings": "Settings",
    "ops.navigation.aria": "Operator navigation",
    "ops.notification.title.assignment": "Assignment notification",
    "ops.notification.title.reminder": "Reminder",
    "ops.notification.title.token": "Token alert",
    "ops.notifications.cta_deliver": "Deliver",
    "ops.notifications.delivered": "Delivered",
    "ops.notifications.description": "Tracking of outbound sends to subscribers and partners.",
    "ops.notifications.due": "To deliver",
    "ops.notifications.failed": "Failed",
    "ops.notifications.failed_devices": "Devices in error",
    "ops.notifications.queue_title": "Notification queues",
    "ops.notifications.sent": "Sent",
    "ops.notifications.title": "Notifications",
    "ops.payments.batch": "Batch",
    "ops.payments.batch_description": "Current batch summary",
    "ops.payments.batch_pending": "Batch pending",
    "ops.payments.batch_started": "Batch started",
    "ops.payments.cta.refund": "Refund",
    "ops.payments.cta.retry": "Retry",
    "ops.payments.cta.start": "Start",
    "ops.payments.description": "Retries, refunds, and payout batches.",
    "ops.payments.exceptions": "exceptions",
    "ops.payments.failed": "failures",
    "ops.payments.failed_retry": "Retry failure",
    "ops.payments.manual_retry": "Manual retry",
    "ops.payments.payouts": "Payments",
    "ops.payments.refunds": "Refunds",
    "ops.payments.refunds_issued": "Refunds issued",
    "ops.payments.retry_queued": "Retries queued",
    "ops.payments.title": "Payments",
    "ops.payout.unavailable.back": "Back to payments",
    "ops.payout.unavailable.body": "Payout batches cannot be started from this console yet. Worker amounts, recipients, and retry outcomes need to be verified before this action is enabled.",
    "ops.payout_error.preview_stale": "The amount or the number changed since you looked: here is the new amount.",
    "ops.payout_error.duplicate_transaction": "This transaction number is already recorded: a transfer is recorded only once.",
    "ops.payout_error.exceeds_due": "That is more than what is due: check what you sent.",
    "ops.payout_error.month_not_closed": "The month has not ended: pay an advance instead.",
    "ops.payout_error.no_destination": "No payment number: she adds it in the app (Payment).",
    "ops.payout_error.outcome_unresolved": "An earlier payment has an unknown outcome: settle it first (Washer pay).",
    "ops.payout_error.in_flight": "A payment is already in progress for this month.",
    "ops.payout_error.amount_mismatch": "The amount does not match the expected payment.",
    "ops.payout_error.idempotency_conflict": "This submission was already processed with other values.",
    "ops.payout_error.transaction_required": "The transaction number is required.",
    "ops.payout_error.invalid_amount": "Invalid amount.",
    "ops.payout_error.invalid_idempotency_key": "Invalid submission: reload the page, then try again.",
    "ops.payout_error.paid_in_future": "The transfer date cannot be in the future.",
    "ops.payout_error.provider_unavailable": "The payment service is unavailable: nothing was sent. Try again later.",
    "ops.payout_error.advance_not_open": "This advance request is no longer open: it was already paid or declined.",
    "ops.payout_error.advance_not_found": "Advance request not found.",
    "ops.payout_error.advance_payout_in_progress": "A payment for this advance is in progress or awaits a supervisor: it cannot be declined now.",
    "ops.payout_error.reason_required": "Say what the payment service shows (at least 5 characters).",
    "ops.payout_error.not_voidable": "Only a paid payment can be voided.",
    "ops.payout_error.not_resolvable": "This payment cannot be settled this way: “paid” needs the transaction number, and only an unknown or stuck outcome is settled here.",
    "ops.payout_error.not_found": "Payment not found.",
    "ops.payout_error.worker_not_found": "Washer not found.",
    "ops.payout_error.invalid_month": "Invalid month: use the YYYY-MM format.",
    "ops.payout_error.access_required": "This action needs finance access.",
    "ops.payout_error.invalid_request": "Incomplete or invalid request: check the fields.",
    "ops.payout_error.supervisor_required": "Only a supervisor can settle this payment.",
    "ops.access_error.capability_required": "This action is for administrators only.",
    "ops.access_error.operator_not_found": "No operator in this country matches.",
    "ops.access_error.assignment_not_found": "This role is no longer active.",
    "ops.access_error.assignment_already_active": "This role is already active.",
    "ops.access_error.last_administrator": "The last administrator cannot be revoked: appoint another one first.",
    "ops.access_error.self_change": "You cannot change your own access: another administrator does it.",
    "ops.access_error.invalid_request": "Invalid request: pick a known role and give a reason (at most 1,000 characters).",
    "ops.access_error.unavailable": "Access cannot be changed right now: try again.",
    "ops.planfit.confirm_resolve": "Confirm",
    "ops.planfit.empty": "No open reviews",
    "ops.planfit.kicker": "TRIAGE",
    "ops.planfit.link": "Plan-fit review",
    "ops.planfit.notes_label": "Notes",
    "ops.planfit.resolution.abuse_recorded": "Abuse recorded",
    "ops.planfit.resolution.no_action": "No action",
    "ops.planfit.resolution.plan_updated": "Plan updated",
    "ops.planfit.resolution.recommended_upgrade": "Recommend a plan",
    "ops.planfit.resolve_cta": "Save",
    "ops.planfit.title": "Plan-fit review",
    "ops.planfit.trigger.household_size_mismatch": "Household size",
    "ops.planfit.trigger.persistent_exceptional_volume": "Repeated exceptional volume",
    "ops.planfit.trigger.third_party_laundry": "Third-party laundry",
    "ops.planfit.trigger.commercial_use": "Commercial use",
    "ops.planfit.trigger.exceptional_volume": "Exceptional volume",
    "ops.planfit.classification.label": "Classification",
    "ops.planfit.classification.false_alarm": "False alarm",
    "ops.planfit.classification.other_policy_misuse": "Other policy misuse",
    "ops.privacy.handled": "Handled",
    "ops.profiles.active": "Active",
    "ops.profiles.blocklist": "Blocklist",
    "ops.profiles.cs": "Support",
    "ops.profiles.cta_block": "Add restriction",
    "ops.profiles.cta_subscriber_privacy": "Process subscription",
    "ops.profiles.cta_worker_privacy": "Process washerwoman",
    "ops.profiles.description": "Profile management",
    "ops.profiles.privacy_title": "Privacy",
    "ops.profiles.safety_flags": "Safety",
    "ops.profiles.subscriber_desc": "Subscriber profile",
    "ops.profiles.subscriber_privacy": "Privacy request",
    "ops.profiles.subscriber_title": "Subscriber",
    "ops.profiles.title": "Profiles",
    "ops.profiles.worker_desc": "Washerwoman profile",
    "ops.profiles.worker_flags": "Alerts",
    "ops.readiness.ready": "Ready",
    "ops.ready.manual": "Manual mode",
    "ops.ready.mode": "Mode",
    "ops.referral.action.clear": "Clear",
    "ops.referral.action.reject": "Reject",
    "ops.referral.column.action": "Action",
    "ops.referral.column.reason": "Flag reason",
    "ops.referral.column.referee": "Referee",
    "ops.referral.column.referrer": "Referrer",
    "ops.referral.column.status": "Status",
    "ops.referral.empty": "No referrals to review.",
    "ops.referral.error.load": "Couldn’t load referrals.",
    "ops.referral.error.resolve": "The server rejected the decision.",
    "ops.referral.metrics.active_referrers": "Active referrers",
    "ops.referral.metrics.active_referrers_hint": "A growth plateau triggers the paid flip.",
    "ops.referral.metrics.empty": "No referrals yet.",
    "ops.referral.metrics.error": "Couldn’t load the metrics.",
    "ops.referral.metrics.family_mix": "Family-plan share",
    "ops.referral.metrics.family_mix_hint": "Reaching the threshold triggers the paid flip.",
    "ops.referral.metrics.family_mix_trigger": "Trigger threshold",
    "ops.referral.metrics.link": "Referral metrics",
    "ops.referral.metrics.qualified_rate": "Qualified rate",
    "ops.referral.metrics.referred_total": "Referred subscribers",
    "ops.referral.metrics.status_flagged": "Flagged",
    "ops.referral.metrics.status_pending": "Pending",
    "ops.referral.metrics.status_qualified": "Qualified",
    "ops.referral.metrics.status_rejected": "Rejected",
    "ops.referral.metrics.status_rewarded": "Rewarded",
    "ops.referral.metrics.subtitle": "Paid-flip trigger watch.",
    "ops.referral.metrics.title": "Referral metrics",
    "ops.referral.metrics.total": "Total referrals",
    "ops.referral.metrics.trigger_reached": "Threshold reached",
    "ops.referral.metrics.trigger_watching": "Watching",
    "ops.referral.reason.unknown": "Reason not specified.",
    "ops.referral.reason.velocity_cap": "Invitation cap exceeded for the period.",
    "ops.referral.resolve.cancel": "Cancel",
    "ops.referral.resolve.confirm": "Confirm decision",
    "ops.referral.resolve.confirm_clear": "Clear this referral?",
    "ops.referral.resolve.confirm_reject": "Reject this referral? This decision is final.",
    "ops.referral.resolve.notes_label": "Decision note",
    "ops.referral.resolved.cleared": "Referral cleared.",
    "ops.referral.resolved.rejected": "Referral rejected.",
    "ops.referral.status.flagged": "To review",
    "ops.referral.title": "Flagged referrals",
    "ops.repassage.action_cancel": "Cancel",
    "ops.repassage.action_decline": "Decline",
    "ops.repassage.action_offer": "Offer to a student",
    "ops.repassage.action_payout": "Record payout",
    "ops.repassage.jobs_tab": "Requests",
    "ops.repassage.payout_method_auto": "Automatic payout",
    "ops.repassage.payout_method_manual": "Manual transfer",
    "ops.repassage.payout_reference": "Transfer reference",
    "ops.repassage.roster_add": "Add a student",
    "ops.repassage.roster_momo": "Mobile Money provider",
    "ops.repassage.roster_name": "Full name",
    "ops.repassage.roster_neighborhood": "Neighborhood",
    "ops.repassage.roster_phone": "Phone",
    "ops.repassage.roster_status.active": "Active",
    "ops.repassage.roster_status.pending": "Pending",
    "ops.repassage.roster_status.suspended": "Suspended",
    "ops.repassage.roster_status.trained": "Trained",
    "ops.repassage.roster_tab": "Students",
    "ops.repassage.sms_failed": "SMS failed — retry",
    "ops.repassage.title": "Repassage — student jobs",
    "ops.reports.card.active_subscribers": "Active subscribers",
    "ops.reports.card.payout_readiness": "Payout readiness",
    "ops.reports.card.recovery_sla": "Recovery SLA",
    "ops.reports.card.visit_completion": "Completion rate",
    "ops.reports.cta_export": "Export",
    "ops.reports.description": "Analytical reading and operational export.",
    "ops.reports.export.title": "Export",
    "ops.reports.exported_desc": "Export complete",
    "ops.reports.kpi": "KPI",
    "ops.reports.latest_export": "Latest export",
    "ops.reports.not_exported": "Not yet exported",
    "ops.reports.read_from_data": "Data refreshed",
    "ops.reports.title": "Reports",
    "ops.route_planning.approved": "Approved",
    "ops.route_planning.cta_acknowledge": "Acknowledge",
    "ops.route_planning.cta_approve": "Approve",
    "ops.route_planning.description": "Adjust the daily plan.",
    "ops.route_planning.title": "Planning",
    "ops.route.auth.o_00.kicker": "AUTHENTICATION · O-00",
    "ops.route.auth.o_00.title": "Splash",
    "ops.route.auth.o_01_e1.kicker": "SIGN IN",
    "ops.route.auth.o_01_e1.title": "Too many attempts",
    "ops.route.auth.o_01_e2.kicker": "SIGN IN · 2FA",
    "ops.route.auth.o_01_e2.title": "Incorrect code",
    "ops.route.auth.o_01_e3.kicker": "SIGN IN",
    "ops.route.auth.o_01_e3.title": "Access blocked",
    "ops.route.auth.o_01_r.kicker": "RESET",
    "ops.route.auth.o_01_r.title": "Reset access",
    "ops.route.auth.o_01.kicker": "DESKTOP CONSOLE",
    "ops.route.auth.o_01.title": "Sign in",
    "ops.route.dashboard.o_02_0.kicker": "TODAY · O-02.0",
    "ops.route.dashboard.o_02_0.title": "Dashboard · night state",
    "ops.route.dashboard.o_02.kicker": "TODAY · O-02",
    "ops.route.dashboard.o_02.title": "Dashboard",
    "ops.route.dashboard.o_04_0.kicker": "TODAY · O-04.0",
    "ops.route.dashboard.o_04_0.title": "Notifications empty",
    "ops.route.dashboard.o_04.kicker": "NOTIFICATIONS · O-04",
    "ops.route.dashboard.o_04.title": "Notifications inbox",
    "ops.route.dashboard.o_16_d.kicker": "TODAY · O-16.D",
    "ops.route.dashboard.o_16_d.title": "Audit event detail",
    "ops.route.dashboard.o_16.kicker": "TODAY · O-16",
    "ops.route.dashboard.o_16.title": "Audit log",
    "ops.route.finances.o_13_0.kicker": "FINANCES · O-13.0",
    "ops.route.finances.o_13_0.title": "Payments empty",
    "ops.route.finances.o_13_s_c.kicker": "FINANCES · O-13.S.C",
    "ops.route.finances.o_13_s_c.title": "Suspension applied",
    "ops.route.finances.o_13_s.kicker": "FINANCES · O-13.S",
    "ops.route.finances.o_13_s.title": "Suspend a worker",
    "ops.route.finances.o_13_x_c.kicker": "FINANCES · O-13.X.C",
    "ops.route.finances.o_13_x_c.title": "Payouts unavailable",
    "ops.route.finances.o_13_x.kicker": "FINANCES · O-13.X",
    "ops.route.finances.o_13_x.title": "Payouts unavailable",
    "ops.route.finances.o_13.kicker": "FINANCES · O-13",
    "ops.route.finances.o_13.title": "Payments",
    "ops.route.finances.o_17_c.kicker": "FINANCES · O-17.C",
    "ops.route.finances.o_17_c.title": "Bulk operation applied",
    "ops.route.finances.o_17.kicker": "FINANCES · O-17",
    "ops.route.finances.o_17.title": "Bulk operations",
    "ops.route.finances.o_18.kicker": "FINANCES · O-18",
    "ops.route.finances.o_18.title": "Exports & reports",
    "ops.route.live.o_05.kicker": "LIVE OPS · O-05",
    "ops.route.live.o_05.title": "Live Ops",
    "ops.route.live.o_06.kicker": "LIVE OPS · O-06",
    "ops.route.live.o_06.title": "Live visit drawer",
    "ops.route.live.o_21_0.kicker": "LIVE OPS · O-21.0",
    "ops.route.live.o_21_0.title": "SOS · no active incident",
    "ops.route.live.o_21_r.kicker": "LIVE OPS · O-21.R",
    "ops.route.live.o_21_r.title": "SOS resolution report",
    "ops.route.live.o_21.kicker": "LIVE OPS · O-21",
    "ops.route.live.o_21.title": "Incoming SOS",
    "ops.route.profiles.o_07.kicker": "360° PROFILES · O-07",
    "ops.route.profiles.o_07.title": "Subscriber list",
    "ops.route.profiles.o_08_e.kicker": "360° PROFILES · O-08.E",
    "ops.route.profiles.o_08_e.title": "Edit subscriber",
    "ops.route.profiles.o_08_p.kicker": "360° PROFILES · O-08.P",
    "ops.route.profiles.o_08_p.title": "Change subscriber plan",
    "ops.route.profiles.o_08.kicker": "360° PROFILES · O-08",
    "ops.route.profiles.o_08.title": "360° subscriber profile",
    "ops.route.profiles.o_09.kicker": "360° PROFILES · O-09",
    "ops.route.profiles.o_09.title": "Washerwomen list",
    "ops.route.profiles.o_10_e.kicker": "360° PROFILES · O-10.E",
    "ops.route.profiles.o_10_e.title": "Edit washerwoman",
    "ops.worker_edit.loading": "Loading worker profile…",
    "ops.worker_edit.load_error": "Could not load this profile. Please try again.",
    "ops.worker_edit.display_name": "Display name",
    "ops.worker_edit.form_title": "Correct display name",
    "ops.worker_edit.scope_note": "This correction does not change status, capacity, or service neighborhoods.",
    "ops.worker_edit.save_error": "The correction was not saved. Please try again.",
    "ops.worker_edit.save": "Save",
    "ops.worker_directory.search": "Name or ID",
    "ops.worker_directory.status": "Status",
    "ops.worker_directory.all_statuses": "All statuses",
    "ops.worker_directory.more_filters": "More filters",
    "ops.worker_directory.neighborhood": "Service neighborhood",
    "ops.worker_directory.absence_filter": "Recorded absence today",
    "ops.worker_directory.any": "All",
    "ops.worker_directory.absence_recorded": "Absence recorded",
    "ops.worker_directory.absence_not_recorded": "No absence recorded",
    "ops.worker_directory.capacity_filter": "Subscription capacity",
    "ops.worker_directory.at_capacity": "At capacity",
    "ops.worker_directory.below_capacity": "Below capacity",
    "ops.worker_directory.issue_filter": "Open reports",
    "ops.worker_directory.with_open_issue": "With a report",
    "ops.worker_directory.without_open_issue": "Without a report",
    "ops.worker_directory.apply": "Search",
    "ops.worker_directory.clear": "Clear",
    "ops.worker_directory.loading": "Loading workers…",
    "ops.worker_directory.load_error": "Could not load workers.",
    "ops.worker_directory.retry": "Retry",
    "ops.worker_directory.empty": "No workers match these filters.",
    "ops.worker_directory.no_neighborhood": "No neighborhoods recorded",
    "ops.worker_directory.workload": "Active households",
    "ops.worker_directory.open_issues": "Open reports: {count}",
    "ops.worker_directory.pages": "Worker pages",
    "ops.worker_directory.previous": "Previous",
    "ops.worker_directory.page": "Page {count}",
    "ops.worker_directory.next": "Next",
    "ops.worker_directory.availability_note": "No recorded absence does not confirm availability for an assignment. Check the schedule before dispatching.",
    "ops.worker_directory.status.active": "Active",
    "ops.worker_directory.status.applicant": "Applicant",
    "ops.worker_directory.status.inactive": "Inactive",
    "ops.worker_directory.status.onboarding": "Onboarding",
    "ops.worker_directory.status.suspended": "Suspended",
    "ops.worker_overview.back": "← Worker list",
    "ops.worker_overview.no_worker": "Open a worker from the list.",
    "ops.worker_overview.loading": "Loading worker…",
    "ops.worker_overview.not_found": "This worker was not found in this market.",
    "ops.worker_overview.invalid_link": "This worker link is invalid. Open the profile from the list.",
    "ops.worker_overview.load_error": "Could not load this worker.",
    "ops.worker_overview.market": "Market · Togo",
    "ops.worker_overview.correct_name": "Correct name",
    "ops.worker_overview.suspended": "Status: suspended",
    "ops.worker_overview.expiry_unrecorded": "No end date recorded.",
    "ops.worker_overview.suspension_until": "Recorded end: {date}",
    "ops.worker_overview.workload": "Active subscriptions / capacity",
    "ops.worker_overview.zones": "Service neighborhoods",
    "ops.worker_overview.recorded_absence": "Absence on {date}",
    "ops.worker_overview.open_reports": "Unresolved worker reports",
    "ops.worker_overview.eligibility_note": "This view does not determine assignment eligibility. No recorded absence does not prove availability; worker reports are not Case records.",
    "ops.worker_overview.activity": "Recent activity",
    "ops.worker_overview.activity_loading": "Loading activity…",
    "ops.worker_overview.activity_error": "Could not load recent activity.",
    "ops.worker_overview.activity_empty": "No recent activity recorded.",
    "ops.route.profiles.o_10.kicker": "360° PROFILES · O-10",
    "ops.route.profiles.o_10.title": "360° washerwoman profile",
    "ops.route.profiles.o_22.kicker": "360° PROFILES · O-22",
    "ops.route.profiles.o_22.title": "Washerwoman onboarding",
    "ops.route.profiles.o_23.kicker": "360° PROFILES · O-23",
    "ops.route.profiles.o_23.title": "Subscriber verification",
    "ops.route.support.o_11_0.kicker": "SUPPORT · O-11.0",
    "ops.route.support.o_11_0.title": "Tickets empty",
    "ops.route.support.o_11_d.kicker": "SUPPORT · O-11.D",
    "ops.route.support.o_11_d.title": "Ticket detail",
    "ops.route.support.o_11.kicker": "SUPPORT · O-11",
    "ops.route.support.o_11.title": "Tickets",
    "ops.route.support.o_12_g.kicker": "SUPPORT · O-12.G",
    "ops.route.support.o_12_g.title": "Goodwill credit",
    "ops.route.system_states.o_x_a.kicker": "SYSTEM STATE · O-X.A",
    "ops.route.system_states.o_x_a.title": "Account archived",
    "ops.route.system_states.o_x_c.kicker": "SYSTEM STATE · O-X.C",
    "ops.route.system_states.o_x_c.title": "Connection lost",
    "ops.route.system_states.o_x_m.kicker": "SYSTEM STATE · O-X.M",
    "ops.route.system_states.o_x_m.title": "System under maintenance",
    "ops.route.system_states.o_x_rj.kicker": "SYSTEM STATE · O-X.RJ",
    "ops.route.system_states.o_x_rj.title": "Request rejected",
    "ops.route.system_states.o_x_s.kicker": "SYSTEM STATE · O-X.S",
    "ops.route.system_states.o_x_s.title": "You are signed out",
    "ops.route.system_states.o_x_w.kicker": "SYSTEM STATE · O-X.W",
    "ops.route.system_states.o_x_w.title": "Awaiting approval",
    "ops.route.system.o_19_2.kicker": "SYSTEM · O-19.2",
    "ops.route.system.o_19_2.title": "Reset 2FA",
    "ops.route.system.o_19_d.kicker": "SYSTEM · O-19.D",
    "ops.route.system.o_19_d.title": "Active sessions",
    "ops.route.system.o_19_p.kicker": "SYSTEM · O-19.P",
    "ops.route.system.o_19_p.title": "Change password",
    "ops.route.system.o_19.kicker": "SYSTEM · O-19",
    "ops.route.system.o_19.title": "Operator settings",
    "ops.route.triage.o_03.kicker": "TRIAGE · O-03",
    "ops.route.triage.o_03.title": "Matching",
    "ops.route.triage.o_14.kicker": "TRIAGE · O-14",
    "ops.route.triage.o_14.title": "Assignment queue",
    "ops.route.triage.o_15.kicker": "TRIAGE · O-15",
    "ops.route.triage.o_15.title": "Cancellation handling",
    "ops.route.triage.o_20.kicker": "TRIAGE · O-20",
    "ops.route.triage.o_20.title": "Command palette",
    "ops.route.triage.o_24.kicker": "TRIAGE",
    "ops.route.triage.o_24.title": "Extra washes",
    "ops.routes.total": "routes",
    "ops.section.dashboard.label": "Dashboard",
    "ops.section.finances.label": "Finances",
    "ops.section.live.label": "Live",
    "ops.section.profiles.label": "Profiles",
    "ops.section.support.label": "Support",
    "ops.section.system.label": "System",
    "ops.section.triage.label": "Triage",
    "ops.sos.active.kicker": "SOS · ACTIVE INCIDENT",
    "ops.sos.active.lede": "Immediate action required. Call the washerwoman first, then the subscriber if a visit is linked.",
    "ops.sos.active.title_many": "{count} open safety alerts",
    "ops.sos.active.title_one": "1 open safety alert",
    "ops.sos.call_subscriber": "Call the subscriber",
    "ops.sos.call_worker": "Call the washerwoman",
    "ops.sos.contact_subscriber_unavailable": "Subscriber phone number unavailable",
    "ops.sos.contact_worker_unavailable": "Washerwoman phone number unavailable",
    "ops.sos.empty.back": "Back to live ops →",
    "ops.sos.empty.body": "No active SOS. The bureau can focus on visits in progress.",
    "ops.sos.gps": "GPS {lat}, {lng} · accuracy ±{accuracy} m",
    "ops.sos.gps_unknown": "Position unknown — call the worker to ask where they are.",
    "ops.sos.load_error": "SOS alerts could not be loaded. Try again immediately.",
    "ops.sos.loading": "Loading SOS alerts…",
    "ops.sos.opened": "Triggered {time}",
    "ops.sos.reason.client_issue": "Incident involving the subscriber",
    "ops.sos.reason.danger": "Immediate danger or threat",
    "ops.sos.reason.medical": "Medical emergency",
    "ops.sos.resolution.category": "Intervention outcome",
    "ops.sos.resolution.error": "The resolution was not recorded. Check the incident and try again.",
    "ops.sos.resolution.incident": "SOS incident {id}",
    "ops.sos.resolution.notes": "Factual audit report",
    "ops.sos.resolution.notes_placeholder": "Describe the calls, actions taken, and final situation.",
    "ops.sos.resolution.option.emergency_services_contacted": "Emergency services contacted",
    "ops.sos.resolution.option.false_alarm": "False alarm confirmed",
    "ops.sos.resolution.option.follow_up_required": "Bureau follow-up required",
    "ops.sos.resolution.option.worker_safe": "Washerwoman reached and safe",
    "ops.sos.resolution.submit": "Record and close the incident",
    "ops.sos.resolution.submitting": "Saving…",
    "ops.sos.resolve": "Send help or resolve",
    "ops.sos.subscription": "Subscription {id}",
    "ops.sos.view_gps": "View GPS position",
    "ops.sponsor_pay.maintenance.body": "Expires sponsor links that reached their deadline and grace periods that have passed.",
    "ops.sponsor_pay.maintenance.cta": "Run maintenance",
    "ops.sponsor_pay.maintenance.error": "Failed — the server refused Sponsor Pay maintenance.",
    "ops.sponsor_pay.maintenance.result": "{inviteCount} link(s) expired, {graceCount} grace period(s) closed.",
    "ops.sponsor_pay.maintenance.running": "Maintenance running…",
    "ops.sponsor_pay.maintenance.title": "Sponsor Pay — maintenance",
    "ops.suspension.confirmation.body": "The worker account is blocked and the suspension is recorded in the audit log.",
    "ops.suspension.confirmation.cta": "Back to payments",
    "ops.suspension.confirmation.title": "Account blocked",
    "ops.suspension.cta": "Suspend",
    "ops.suspension.duration_label": "Duration (days)",
    "ops.suspension.error": "Failed — the suspension was not applied.",
    "ops.suspension.reason_label": "Reason",
    "ops.suspension.title": "Suspension details",
    "ops.suspension.warning": "Punitive action — the account will be blocked and the audit record is immutable.",
    "ops.suspension.worker_id_label": "Worker ID",
    "ops.settings.checks_label": "Checks",
    "ops.settings.cta_check": "Check",
    "ops.settings.cta_toggle": "Toggle",
    "ops.settings.description": "Operational control of the operations center.",
    "ops.settings.failed_payouts": "Failed payouts",
    "ops.settings.features_desc": "Available options",
    "ops.settings.features_label": "Features",
    "ops.settings.forced": "FORCED",
    "ops.settings.last_checked": "Last checked",
    "ops.settings.normal": "READY",
    "ops.settings.readiness_checks": "Readiness checks",
    "ops.settings.readiness_panel": "Readiness center",
    "ops.settings.title": "Settings",
    "ops.status.confirmed": "Confirmed",
    "ops.status.proposal_sent": "Proposal sent",
    "ops.status.unassigned": "Unassigned",
    "ops.table.neighborhood": "Neighborhood",
    "ops.table.open": "Action",
    "ops.table.sla": "SLA",
    "ops.table.state": "State",
    "ops.table.subscriber": "Subscriber",
    "ops.table.time": "Time",
    "ops.table.worker": "Washerwoman",
    "ops.tickets.action.goodwill": "Goodwill credit ({amount} XOF)",
    "ops.tickets.empty": "No open tickets.",
    "ops.tickets.policy.label": "Policy",
    "ops.tickets.priority.high": "HIGH",
    "ops.tickets.priority.normal": "NORMAL",
    "ops.tickets.title": "Tickets",
    "ops.unassigned.label": "Unassigned",
    "pricing.tiers.fc": "Household 2×",
    "pricing.tiers.fe": "Household 1×",
    "push.ops.sla_breach": "SLA breached · {client} {time} unassigned.",
    "push.ops.sos": "🆘 SOS — {worker} at {client}, {neighborhood}",
    "push.sub.visit_done": "Visit finished. Here's how it turned out.",
    "push.sub.visit_started": "{name} has started the visit.",
    "push.sub.visit_today": "{name} arrives today at {time}.",
    "push.sub.visit_tomorrow": "{name} arrives tomorrow at {time}.",
    "push.sub.worker_enroute": "{name} is on the way.",
    "push.work.assignment": "New visit offered: {time} at {name} ({neighborhood}).",
    "push.work.assignment.expires": "Accept before {time} or it'll be reassigned.",
    "push.work.payout_received": "+ {amount} XOF received via {provider}.",
    "sms.sub.payment_failed": "Washed: {amount} XOF collection failed. Mobile Money balance too low. We'll try again tomorrow.",
    "sms.work.cancel_tomorrow": "Washed: your visit at {name} tomorrow {time} is canceled. Your daily plan stays active. Office {phone}.",
    "student.repassage.accept_cta": "I accept this job",
    "student.repassage.accepted_note": "Job accepted. The full address and client contact are below.",
    "student.repassage.completed_note": "Thank you! Your Mobile Money payment is on its way.",
    "student.repassage.expired_note": "This job is no longer available.",
    "student.repassage.fee_line": "{fee} XOF for you — 100%",
    "student.repassage.page_title": "Washed ironing job",
    "student.repassage.photo_cta": "Send the photo of the ironed laundry",
    "student.repassage.sms.offer": "Washed: ironing job on {date} ({window}) in {neighborhood}. {fee} XOF for you (100%). Accept here: {link}",
    "student.repassage.sms.paid": "Washed: thank you! {fee} XOF is on its way to your Mobile Money. See you soon!",
    "subscriber.address_edit.a11y.already_pending_announcement": "Address change request already in progress. The bureau is reviewing your previous request.",
    "subscriber.address_edit.a11y.cta_disabled_hint": "Enter your neighborhood to continue.",
    "subscriber.address_edit.a11y.error_announcement": "Couldn't send the request. Try again.",
    "subscriber.address_edit.a11y.landmark_label": "Landmark, optional",
    "subscriber.address_edit.a11y.neighborhood_label": "Neighborhood, required",
    "subscriber.address_edit.a11y.street_label": "Street or detail, optional",
    "subscriber.address_edit.a11y.submitting": "Submitting your address change",
    "subscriber.address_edit.a11y.success_announcement": "Request sent. The bureau is reviewing your new address.",
    "subscriber.address_edit.already_pending.body": "The bureau is reviewing your previous request. You can edit again once it's resolved.",
    "subscriber.address_edit.already_pending.title": "Request already in progress",
    "subscriber.address_edit.body": "The bureau confirms the new address before updating your upcoming visits.",
    "subscriber.address_edit.cancel.cta": "Keep my address",
    "subscriber.address_edit.current_label": "Current address",
    "subscriber.address_edit.error.already_pending": "An address change request is already in progress. Please wait for the bureau to confirm it.",
    "subscriber.address_edit.error.network": "Couldn't send the request. Try again.",
    "subscriber.address_edit.field.landmark": "Landmark (optional)",
    "subscriber.address_edit.field.landmark.placeholder": "across from the pharmacy",
    "subscriber.address_edit.field.neighborhood": "Neighborhood",
    "subscriber.address_edit.field.neighborhood.placeholder": "Neighborhood (e.g. Bè)",
    "subscriber.address_edit.field.street": "Street / detail (optional)",
    "subscriber.address_edit.field.street.placeholder": "rue 18, yellow building",
    "subscriber.address_edit.header": "Edit address",
    "subscriber.address_edit.keyboard.done": "Done",
    "subscriber.address_edit.kicker": "Edit address",
    "subscriber.address_edit.submit.cta": "Send for validation",
    "subscriber.address_edit.submit.pill": "Send",
    "subscriber.address_edit.submitted.body": "The bureau confirms your new address before updating your next visits.",
    "subscriber.address_edit.submitted.cta": "Back to profile",
    "subscriber.address_edit.submitted.title": "Request sent",
    "subscriber.address_edit.title": "New address",
    "subscriber.address_edit.warn_body": "Your visits keep the current address until approval. Usual turnaround: 24–48 h.",
    "subscriber.address_edit.warn_eyebrow": "Heads up",
    "subscriber.appearance.body": "Choose light, dark, or your phone's system setting.",
    "subscriber.appearance.header": "Appearance",
    "subscriber.appearance.launch.cta": "Continue",
    "subscriber.appearance.launch.header": "Before you start",
    "subscriber.appearance.option.dark": "Dark",
    "subscriber.appearance.option.dark.body": "Keep screens on a dark background.",
    "subscriber.appearance.option.light": "Light",
    "subscriber.appearance.option.light.body": "Keep screens on a light background.",
    "subscriber.appearance.option.system": "System",
    "subscriber.appearance.option.system.body": "Follow your phone setting.",
    "subscriber.appearance.title": "Choose appearance",
    "subscriber.booking.day_group.label": "Preferred day",
    "subscriber.booking.day.body": "Choose a weekday or weekend day.",
    "subscriber.booking.day.friday": "Friday",
    "subscriber.booking.day.monday": "Monday",
    "subscriber.booking.day.saturday": "Saturday",
    "subscriber.booking.day.sunday": "Sunday",
    "subscriber.booking.day.thursday": "Thursday",
    "subscriber.booking.day.title": "Which day works for you?",
    "subscriber.booking.day.tuesday": "Tuesday",
    "subscriber.booking.day.wednesday": "Wednesday",
    "subscriber.booking.header": "Book",
    "subscriber.booking.home.body": "Tell us your preference for a weekday or weekend. The office confirms with your washerwoman.",
    "subscriber.booking.home.cta": "Book a visit",
    "subscriber.booking.home.eyebrow": "Need laundry washed?",
    "subscriber.booking.home.title": "Book a visit",
    "subscriber.booking.notice": "This is a preference, not a confirmation yet. We'll call you if the washerwoman is not available.",
    "subscriber.booking.selected_day.label": "Chosen day",
    "subscriber.booking.submit.cta": "Send request",
    "subscriber.booking.submitted.body": "The office confirms your slot by call or WhatsApp before the visit.",
    "subscriber.booking.submitted.header": "Booking",
    "subscriber.booking.submitted.home_cta": "Back to home",
    "subscriber.booking.submitted.title": "Request sent.",
    "subscriber.booking.time_group.label": "Preferred time",
    "subscriber.booking.time.afternoon.detail": "1–5 pm",
    "subscriber.booking.time.afternoon.label": "Afternoon",
    "subscriber.booking.time.body": "{day} is noted. Choose the time that works for you.",
    "subscriber.booking.time.morning.detail": "8 am–12 pm",
    "subscriber.booking.time.morning.label": "Morning",
    "subscriber.booking.time.title": "What time on {day}?",
    "subscriber.change_number.code_body_template": "Code sent to {number}.",
    "subscriber.change_number.code_title": "Enter the code",
    "subscriber.change_number.confirm_cta": "Confirm change",
    "subscriber.change_number.eyebrow": "Phone number",
    "subscriber.change_number.number_body": "We'll text a code to this number to confirm it's really yours.",
    "subscriber.change_number.number_label": "New number",
    "subscriber.change_number.number_title": "New number",
    "subscriber.change_number.send_cta": "Send the code",
    "subscriber.change_number.success_body": "You'll sign in with this number from now on.",
    "subscriber.change_number.success_cta": "Done",
    "subscriber.change_number.success_title": "Number updated",
    "subscriber.client_insights.body": "These answers are optional. They help us understand who uses the service and improve the plans.",
    "subscriber.client_insights.field.age_band": "Age range",
    "subscriber.client_insights.field.current_laundry_solution": "Current laundry solution",
    "subscriber.client_insights.field.gender": "Gender",
    "subscriber.client_insights.field.household_role": "Role in the household",
    "subscriber.client_insights.field.household_size": "People in the household",
    "subscriber.client_insights.field.join_reason": "Why join Washed?",
    "subscriber.client_insights.field.referral_source": "How did you hear about Washed?",
    "subscriber.client_insights.header": "Profile",
    "subscriber.client_insights.household_size.placeholder": "E.g. 4",
    "subscriber.client_insights.option.age.18_24": "18-24",
    "subscriber.client_insights.option.age.25_34": "25-34",
    "subscriber.client_insights.option.age.35_44": "35-44",
    "subscriber.client_insights.option.age.45_54": "45-54",
    "subscriber.client_insights.option.age.55_plus": "55+",
    "subscriber.client_insights.option.gender.female": "Woman",
    "subscriber.client_insights.option.gender.male": "Man",
    "subscriber.client_insights.option.gender.non_binary": "Non-binary",
    "subscriber.client_insights.option.laundry.family_help": "Family / help at home",
    "subscriber.client_insights.option.laundry.laundromat": "Laundry shop",
    "subscriber.client_insights.option.laundry.laveuse": "Independent washerwoman",
    "subscriber.client_insights.option.laundry.self_wash": "I wash myself",
    "subscriber.client_insights.option.other": "Other",
    "subscriber.client_insights.option.prefer_not_to_say": "Prefer not to say",
    "subscriber.client_insights.option.reason.price": "Clear price",
    "subscriber.client_insights.option.reason.quality": "Laundry quality",
    "subscriber.client_insights.option.reason.reliability": "Reliable service",
    "subscriber.client_insights.option.reason.save_time": "Save time",
    "subscriber.client_insights.option.reason.trusted_worker": "Trusted washerwoman",
    "subscriber.client_insights.option.referral.field_team": "Field team",
    "subscriber.client_insights.option.referral.friend_family": "Friend or family",
    "subscriber.client_insights.option.referral.neighborhood": "Neighborhood",
    "subscriber.client_insights.option.referral.social_media": "Social media",
    "subscriber.client_insights.option.referral.worker": "Washerwoman",
    "subscriber.client_insights.option.role.household_manager": "Household manager",
    "subscriber.client_insights.option.role.parent": "Parent",
    "subscriber.client_insights.option.role.professional": "Professional",
    "subscriber.client_insights.option.role.student": "Student",
    "subscriber.client_insights.placeholder": "Choose an answer",
    "subscriber.client_insights.privacy_note": "No full date of birth. You can skip every question.",
    "subscriber.client_insights.save_cta": "Save",
    "subscriber.client_insights.title": "Adapt Washed better",
    "subscriber.dashboard.cta_detail": "Details",
    "subscriber.dashboard.cta_report": "Reschedule",
    "subscriber.dashboard.cta_visits": "See visits",
    "subscriber.dashboard.empty_visit.body": "Choose the day and time you want. The office confirms before assigning your washerwoman.",
    "subscriber.dashboard.empty_visit.cta": "Schedule my first visit",
    "subscriber.dashboard.empty_visit.eyebrow": "First visit",
    "subscriber.dashboard.empty_visit.title": "Schedule your first visit",
    "subscriber.dashboard.greeting.afternoon": "Good afternoon, {name}.",
    "subscriber.dashboard.greeting.evening": "Good evening, {name}.",
    "subscriber.dashboard.greeting.generic": "Hello",
    "subscriber.dashboard.greeting.morning": "Good morning, {name}.",
    "subscriber.dashboard.last_visit.label": "Last visit · {date}",
    "subscriber.dashboard.next_visit.countdown": "In {days} days · {hours} h",
    "subscriber.dashboard.next_visit.day": "{weekday}",
    "subscriber.dashboard.next_visit.label": "Next visit",
    "subscriber.dashboard.next_visit.status.in_progress": "in progress",
    "subscriber.dashboard.next_visit.status.scheduled": "scheduled",
    "subscriber.dashboard.next_visit.time": "{hour}:{min}",
    "subscriber.dashboard.pending_visit.body": "The office confirms your slot by call or WhatsApp before assigning your washerwoman.",
    "subscriber.dashboard.pending_visit.cta": "Edit my request",
    "subscriber.dashboard.pending_visit.eyebrow": "Request sent",
    "subscriber.dashboard.pending_visit.title": "First visit in confirmation",
    "subscriber.dashboard.plan.current_status": "Current",
    "subscriber.dashboard.plan.first_visit_pending_status": "Request in confirmation",
    "subscriber.dashboard.plan.first_visit_status": "Visit to schedule",
    "subscriber.dashboard.plan.ready_label": "Plan",
    "subscriber.dashboard.profile_shortcut.label": "Open profile",
    "subscriber.dashboard.service.arrival": "Arrival planned on {date} · {time}",
    "subscriber.dashboard.service.body": "Washed keeps service continuity even if the assignment changes.",
    "subscriber.dashboard.service.eyebrow": "Visit zone",
    "subscriber.dashboard.service.test_map": "Visit map preview",
    "subscriber.dashboard.service.title": "{neighborhood}",
    "subscriber.dashboard.streak.label": "{count} visits with {name}",
    "subscriber.dashboard.tab.history": "History",
    "subscriber.dashboard.tab.home": "Home",
    "subscriber.dashboard.tab.plan": "Plan",
    "subscriber.dashboard.tab.profile": "Profile",
    "subscriber.dashboard.tab.visits": "Visits",
    "subscriber.dashboard.worker.assignment_pending.body": "The office confirms the person before the visit.",
    "subscriber.dashboard.worker.assignment_pending.title": "Assignment in progress",
    "subscriber.dashboard.worker.ready_chip": "ready",
    "subscriber.dashboard.worker.tenure": "{neighborhood} · managed service",
    "subscriber.dashboard.worker.tenure_first": "First visit confirmed",
    "subscriber.delete.body": "Your request will be reviewed before deletion. The history of {count} visits will be prepared under the legal rules.",
    "subscriber.delete.body_pending": "Your request will be reviewed before deletion. Your history will be prepared according to legal rules.",
    "subscriber.delete.cancel.cta": "Cancel",
    "subscriber.delete.confirm.cta": "Delete permanently",
    "subscriber.delete.confirm.label": "Type \"DELETE\" to confirm",
    "subscriber.delete.confirm.token": "DELETE",
    "subscriber.delete.header": "Delete account",
    "subscriber.delete.reason": "Deletion request from the subscriber app.",
    "subscriber.delete.submitted.body": "The office will review your request before deletion. Reference {requestId}.",
    "subscriber.delete.submitted.cta": "Back to profile",
    "subscriber.delete.submitted.title": "Request sent.",
    "subscriber.delete.title": "This is final.",
    "subscriber.delete.warn_eyebrow": "What will happen",
    "subscriber.delete.warn.cancel_visit": "Visit on {weekday} {date} canceled · no refund",
    "subscriber.delete.warn.cancel_visit_pending": "No confirmed visit to cancel right now",
    "subscriber.delete.warn.legal": "Legal retention: 30 days at the office (invoices)",
    "subscriber.delete.warn.photos": "All your photos deleted permanently",
    "subscriber.delete.warn.reassign": "The office closes the active assignment after review",
    "subscriber.error.otp.already_used": "This code was already used. Request a new code.",
    "subscriber.error.otp.expired": "The code expired. Request a new code.",
    "subscriber.error.otp.invalid_code": "Wrong code. Check and try again.",
    "subscriber.error.otp.not_found": "Link expired. Start again with your number.",
    "subscriber.error.otp.too_many_attempts": "Too many attempts. Start again with your number.",
    "subscriber.family.cap_label": "Maximum 7 people. For a larger household, contact the office.",
    "subscriber.family.grace.age_bucket.adulte": "adult",
    "subscriber.family.grace.age_bucket.enfant": "child",
    "subscriber.family.grace.age_bucket.mixte": "mixed",
    "subscriber.family.grace.refused.body": "{count} item(s) ({ageBucket}) were set aside. Add the missing member to resume full service.",
    "subscriber.family.grace.refused.cta": "Update my household",
    "subscriber.family.grace.refused.title": "Clothes not washed under the contract",
    "subscriber.family.grace.strike_1.body": "We washed {count} extra item(s) ({ageBucket}). If someone is missing from your family, add them for future visits.",
    "subscriber.family.grace.strike_1.cta": "Add a member",
    "subscriber.family.grace.strike_1.title": "Extra clothes washed today",
    "subscriber.family.grace.strike_2.body": "We washed {count} extra item(s) ({ageBucket}) again. At the next visit, they will no longer be washed.",
    "subscriber.family.grace.strike_2.cta": "Add a member now",
    "subscriber.family.grace.strike_2.title": "Out-of-contract clothes: last visit before refusal",
    "subscriber.family.included_members_label": "5 members included",
    "subscriber.family.roster.add_cta": "Add a member",
    "subscriber.family.roster.age_years": "{age} years old",
    "subscriber.family.roster.cap_reached": "Maximum 7 members reached. For a larger household, contact the office.",
    "subscriber.family.roster.edit_cta": "Edit",
    "subscriber.family.roster.edit.cancel_cta": "Cancel",
    "subscriber.family.roster.edit.relationship_locked": "To change the relationship, remove this member and add a new one.",
    "subscriber.family.roster.edit.save_cta": "Save",
    "subscriber.family.roster.edit.title": "Edit this member",
    "subscriber.family.roster.empty": "No members registered.",
    "subscriber.family.roster.error": "Unable to update your household right now. Try again.",
    "subscriber.family.roster.member_count": "{active} / 7 members",
    "subscriber.family.roster.paid_extra_badge": "Paid member",
    "subscriber.family.roster.readd_cta": "Add again",
    "subscriber.family.roster.remove_cta": "Remove",
    "subscriber.family.roster.remove.cancel_cta": "Cancel",
    "subscriber.family.roster.remove.confirm_body": "This resets the grace counter for the next visit. The member will appear as removed in your history.",
    "subscriber.family.roster.remove.confirm_cta": "Remove",
    "subscriber.family.roster.remove.confirm_title": "Remove this member?",
    "subscriber.family.roster.removed_at": "Removed on {date}",
    "subscriber.family.roster.removed_section": "Removed members",
    "subscriber.family.roster.show_removed": "Show removed members",
    "subscriber.family.roster.title": "My household",
    "subscriber.family.seat_upsell.a11y.cta_hint": "Opens the add-member form below.",
    "subscriber.family.seat_upsell.body": "+{price} XOF per month — your whole household covered on every visit.",
    "subscriber.family.seat_upsell.cta": "Add a person",
    "subscriber.family.seat_upsell.title": "A {seat}th person?",
    "subscriber.family.section.headline": "One washerwoman, all the household laundry, in one visit.",
    "subscriber.family.signup.commercial_accord.block": "For 8 people or more, the office offers a price suited to your household: {phone}.",
    "subscriber.family.signup.member.add_cta": "Add this member",
    "subscriber.family.signup.member.add.body": "Register each person whose laundry will be washed. Clothes from anyone not registered are refused.",
    "subscriber.family.signup.member.add.title": "Add a member",
    "subscriber.family.signup.member.birth_year": "Birth year",
    "subscriber.family.signup.member.cap_reached": "Maximum 7 members reached.",
    "subscriber.family.signup.member.count": "{count} / 7 members",
    "subscriber.family.signup.member.edit_cta": "Edit",
    "subscriber.family.signup.member.gender": "Gender",
    "subscriber.family.signup.member.gender_f": "Woman",
    "subscriber.family.signup.member.gender_m": "Man",
    "subscriber.family.signup.member.given_name": "First name",
    "subscriber.family.signup.member.housemaid_notice": "Domestic staff count as paid members, and their clothes will be refused if they are not registered.",
    "subscriber.family.signup.member.list.title": "Members already registered",
    "subscriber.family.signup.member.paid_extra_warning": "This member costs an extra {price} XOF/month beyond the 5 included.",
    "subscriber.family.signup.member.rel.autre": "Other",
    "subscriber.family.signup.member.rel.epouse": "Wife",
    "subscriber.family.signup.member.rel.epoux": "Husband",
    "subscriber.family.signup.member.rel.fille": "Daughter",
    "subscriber.family.signup.member.rel.fils": "Son",
    "subscriber.family.signup.member.rel.parent": "Parent",
    "subscriber.family.signup.member.rel.personnel_domestique": "Domestic staff",
    "subscriber.family.signup.member.relationship": "Relationship",
    "subscriber.family.signup.member.remove_cta": "Remove",
    "subscriber.family.signup.payment.body": "Your first Mobile Money charge will be {amount}, before your first visit. Later months are charged before their first visit.",
    "subscriber.family.signup.payment.cta": "Confirm · {amount}",
    "subscriber.family.signup.payment.error": "Payment could not be confirmed. Check your Mobile Money balance and try again.",
    "subscriber.family.signup.payment.retry_cta": "Try again",
    "subscriber.family.signup.payment.title": "Confirm payment",
    "subscriber.family.signup.review.base": "Base plan",
    "subscriber.family.signup.review.body": "Check each member. You can edit them after signup from your plan.",
    "subscriber.family.signup.review.continue_cta": "Confirm and pay",
    "subscriber.family.signup.review.cta": "Review my family",
    "subscriber.family.signup.review.empty": "Add at least one member.",
    "subscriber.family.signup.review.extras": "Extra seats ({count})",
    "subscriber.family.signup.review.title": "Review your family",
    "subscriber.family.signup.review.total": "Monthly total",
    "subscriber.family.visit.grace_banner.cta": "Update my household",
    "subscriber.family.visit.grace_banner.strike_ge3": "Laundry was refused under the contract: {count} item(s) ({ageBucket}).",
    "subscriber.family.visit.grace_banner.strike_lt3": "This visit included extra laundry: {count} item(s) ({ageBucket}).",
    "subscriber.history.detail.after": "After",
    "subscriber.history.detail.after_photo": "After photo",
    "subscriber.history.detail.arrival": "Arrival",
    "subscriber.history.detail.before": "Before",
    "subscriber.history.detail.before_photo": "Before photo",
    "subscriber.history.detail.completed": "Done",
    "subscriber.history.detail.duration_with_worker": "{duration} of service.",
    "subscriber.history.detail.good_title": "Good visit.",
    "subscriber.history.detail.header": "Visit · {date}",
    "subscriber.history.detail.included": "Visit included in plan",
    "subscriber.history.detail.payment": "Payment",
    "subscriber.history.detail.report.cta": "Report after the fact",
    "subscriber.history.detail.timeline": "Timeline",
    "subscriber.history.empty.body": "Your first visit will show up here as soon as it's done.",
    "subscriber.history.empty.title": "No visits yet.",
    "subscriber.history.entry.duration": "{duration}",
    "subscriber.history.entry.duration_clean": "{duration} · all good",
    "subscriber.history.entry.status_clean": "Visit went well",
    "subscriber.history.entry.status_issue": "Issue reported",
    "subscriber.history.eyebrow": "Your visits",
    "subscriber.history.recent": "Recent",
    "subscriber.history.stats.counter": "Counter",
    "subscriber.history.stats.coverage": "Months covered",
    "subscriber.history.stats.months": "months",
    "subscriber.history.title": "Your Washed service for {months} months.",
    "subscriber.history.title_first": "First Washed visit.",
    "subscriber.history.heading": "Your visits.",
    "subscriber.language.body": "Choose the app language. You can change it in Profile.",
    "subscriber.language.header": "Language",
    "subscriber.language.launch.cta": "Continue",
    "subscriber.language.launch.header": "Before you start",
    "subscriber.language.option.en": "English",
    "subscriber.language.option.en.body": "Interface and messages in English.",
    "subscriber.language.option.fr": "Français",
    "subscriber.language.option.fr.body": "Interface and messages in French.",
    "subscriber.language.title": "Choose language",
    "subscriber.launch.restore.status": "Restoring your session…",
    "subscriber.neighborhood_route.eyebrow": "Neighborhood map",
    "subscriber.neighborhood_route.map_title": "Neighborhood route",
    "subscriber.neighborhood_route.metric_eta": "Landmark",
    "subscriber.neighborhood_route.metric_eta_fallback": "Before visit",
    "subscriber.neighborhood_route.metric_progress": "Route",
    "subscriber.neighborhood_route.metric_stops": "Stops",
    "subscriber.neighborhood_route.offer_activate": "Activate perk",
    "subscriber.neighborhood_route.offer_activated": "Perk activated",
    "subscriber.neighborhood_route.offer_activating": "Activating...",
    "subscriber.neighborhood_route.offer_eyebrow": "Partner perk",
    "subscriber.neighborhood_route.offer_failed": "Can't activate right now.",
    "subscriber.neighborhood_route.offer_valid_until": "Valid until {date}",
    "subscriber.neighborhood_route.open": "View neighborhood route",
    "subscriber.neighborhood_route.partner_frozen_badge": "Frozen",
    "subscriber.neighborhood_route.progress": "Route progress",
    "subscriber.neighborhood_route.progress_value": "{count}%",
    "subscriber.neighborhood_route.signal_lost": "Signal lost · last known location",
    "subscriber.neighborhood_route.sponsor_hidden": "Partner program hidden",
    "subscriber.neighborhood_route.sponsors_frozen": "Partner offers are ready on the product side, but stay hidden while the commercial launch is frozen.",
    "subscriber.neighborhood_route.stops_value": "{count} stops",
    "subscriber.neighborhood_route.story_title": "Route landmarks",
    "subscriber.neighborhood_route.subtitle": "Your visit, placed within the useful landmarks of the neighborhood.",
    "subscriber.neighborhood_route.title_fallback": "Explore the neighborhood",
    "subscriber.neighborhood_route.unavailable": "The neighborhood map isn't available for this visit.",
    "subscriber.notifications.body": "You can turn everything off. The office will call you if it's urgent.",
    "subscriber.notifications.email_recap.sub": "Receipt and stats for the month",
    "subscriber.notifications.email_recap.title": "Monthly email · recap",
    "subscriber.notifications.header": "Notifications",
    "subscriber.notifications.no_marketing": "No marketing notifications — promise.",
    "subscriber.notifications.no_visit": "No confirmed visit",
    "subscriber.notifications.push_reveal.sub": "\"Here's how it turned out\" · 1×",
    "subscriber.notifications.push_reveal.title": "Push · reveal photos",
    "subscriber.notifications.push_route.sub": "\"The visit is on the way\" · \"The washerwoman has arrived\"",
    "subscriber.notifications.push_route.title": "Push · on the way",
    "subscriber.notifications.sms_reminder.sub": "{weekday} {time}, {weekday} {time} in {hours} h",
    "subscriber.notifications.sms_reminder.sub_pending": "WhatsApp reminder as soon as a visit is confirmed.",
    "subscriber.notifications.sms_reminder.title": "WhatsApp · reminders day-1 and day-of",
    "subscriber.notifications.title": "What would you like to receive?",
    "subscriber.payment.action.edit_method": "Change method",
    "subscriber.payment.action.view_history": "See payments",
    "subscriber.payment.cancel.title": "Are you sure?",
    "subscriber.payment.failed.banner.cta": "Fix now",
    "subscriber.payment.failed.banner.message": "Fix your payment to keep your visits.",
    "subscriber.payment.failed.banner.title": "Payment failed",
    "subscriber.plan.tab.status_paused": "Paused",
    "subscriber.plan.tab.status_cancelled": "Cancelled",
    "subscriber.plan.tab.status_payment_overdue": "Payment overdue",
    "subscriber.payment.failed.body": "Mobile Money balance too low. Top up and we'll try again tomorrow.",
    "subscriber.payment.failed.cta": "Try again now",
    "subscriber.payment.failed.title": "Payment didn't go through.",
    "subscriber.payment.history.amount_review": "Amount to review",
    "subscriber.payment.history.count_label": "{count} charges",
    "subscriber.payment.history.covered_label": "Months covered",
    "subscriber.payment.history.current_status": "Current",
    "subscriber.payment.history.detail_eyebrow": "Detail",
    "subscriber.payment.history.download_cta": "Download receipts",
    "subscriber.payment.history.download_error": "Download unavailable. Try again.",
    "subscriber.payment.history.download_selected_cta": "Download {count} receipt(s)",
    "subscriber.payment.history.empty": "No payments yet.",
    "subscriber.payment.history.header": "Payment history",
    "subscriber.payment.history.months_value": "{months} months",
    "subscriber.payment.history.receipt_tools_label": "Receipt selection",
    "subscriber.payment.history.review_status": "Review",
    "subscriber.payment.history.select_receipt": "Include receipt from {date}",
    "subscriber.payment.history.selection_all": "Select all",
    "subscriber.payment.history.selection_clear": "Clear all",
    "subscriber.payment.history.selection_count": "{count} receipt(s) selected",
    "subscriber.payment.history.status_label": "Status",
    "subscriber.payment.history.summary_label": "Payment summary",
    "subscriber.payment.history.title": "{months} months covered.",
    "subscriber.payment.method.active_badge": "Active",
    "subscriber.payment.method.add_flooz": "+ Add a Flooz",
    "subscriber.payment.method.add_mixx": "+ Add a Mixx by Yas",
    "subscriber.payment.method.add.body": "Choose Mixx by Yas or Flooz, then enter the number tied to that Mobile Money account.",
    "subscriber.payment.method.add.cta": "Save",
    "subscriber.payment.method.add.error.invalid_number": "Invalid number. Check the format.",
    "subscriber.payment.method.add.error.network": "Unable to save. Try again.",
    "subscriber.payment.method.add.header": "Add a payment method",
    "subscriber.payment.method.add.success.body": "The next charge will use this account.",
    "subscriber.payment.method.add.success.title": "Payment method added.",
    "subscriber.payment.method.add.title": "Choose your provider.",
    "subscriber.payment.method.available_badge": "Available",
    "subscriber.payment.method.body": "Choose the provider and Mobile Money number to charge each month.",
    "subscriber.payment.method.current_suffix": "current",
    "subscriber.payment.method.field.number": "Mobile Money number",
    "subscriber.payment.method.field.number.placeholder": "07 00 00 00 00",
    "subscriber.payment.method.header": "Payment method",
    "subscriber.payment.method.save_cta": "Save",
    "subscriber.payment.method.sponsor_fallback.a11y.submitting": "Saving the backup Mobile Money method",
    "subscriber.payment.method.sponsor_fallback.a11y.success_announcement": "Backup Mobile Money added.",
    "subscriber.payment.method.sponsor_fallback.body": "This method is used only if the sponsor payment fails or stops.",
    "subscriber.payment.method.sponsor_fallback.cta": "Save backup method",
    "subscriber.payment.method.sponsor_fallback.notice": "The sponsor keeps paying while their card works. Your Mobile Money protects the service during the grace period.",
    "subscriber.payment.method.sponsor_fallback.success.body": "Your plan stays protected if the sponsor needs to fix their card.",
    "subscriber.payment.method.sponsor_fallback.success.title": "Backup Mobile Money added",
    "subscriber.payment.method.sponsor_fallback.title": "Add local Mobile Money",
    "subscriber.payment.method.title": "Mobile Money",
    "subscriber.payment.overdue.banner": "3 failed attempts. Visit paused until payment.",
    "subscriber.payment.overdue.header": "Payment didn't clear",
    "subscriber.payment.overdue.next_visit_eyebrow": "Next visit",
    "subscriber.payment.overdue.waiting": "waiting for payment",
    "subscriber.payment.receipt.amount_label": "Amount",
    "subscriber.payment.receipt.bundle_title": "Washed receipts · {count} payments",
    "subscriber.payment.receipt.client_label": "Client",
    "subscriber.payment.receipt.footer": "Document generated from the Washed app. Each receipt corresponds to one charge or refund.",
    "subscriber.payment.receipt.issued_at": "Issued on {date}",
    "subscriber.payment.receipt.reference_label": "Reference",
    "subscriber.payment.receipt.single_title": "Washed receipt · {date}",
    "subscriber.payment.receipt.status.review": "Review",
    "subscriber.payment.receipt.status.succeeded": "Paid",
    "subscriber.payment.receipt.title": "Receipt",
    "subscriber.payment.receipt.type_charge": "Charge",
    "subscriber.payment.receipt.type_label": "Type",
    "subscriber.payment.receipt.type_refund": "Refund",
    "subscriber.payment.success.toast": "{amount} XOF charged. Reference {ref}.",
    "subscriber.plan.active_card.eyebrow": "Active plan",
    "subscriber.plan.active_card.next_charge_label": "Next charge",
    "subscriber.plan.active_card.next_charge_value": "{date} · auto",
    "subscriber.plan.active_card.payment_setup_pending": "Payment setup pending",
    "subscriber.plan.active_card.tier": "{label} · {amount} / month",
    "subscriber.plan.change.available_badge": "Available",
    "subscriber.plan.change.body": "All available plans are here. The change takes effect next cycle · {date}.",
    "subscriber.plan.change.current_badge": "Current",
    "subscriber.plan.change.header": "Change plan",
    "subscriber.plan.change.increase_label": "Increase / month",
    "subscriber.plan.change.options_label": "Available plans",
    "subscriber.plan.change.reduction_label": "Reduction / month",
    "subscriber.plan.change.select_cta": "Choose a plan",
    "subscriber.plan.change.selected_badge": "Chosen",
    "subscriber.plan.change.title": "Choose your new plan.",
    "subscriber.plan.cta_manage_family": "Manage my household",
    "subscriber.plan.cta_modify": "Change plan",
    "subscriber.plan.cta_pause": "Pause",
    "subscriber.plan.cta_repassage": "Get my laundry ironed",
    "subscriber.plan.detail.choose_slot": "Choose the day and time you want. The office confirms before assigning your washerwoman.",
    "subscriber.plan.eyebrow": "Your plan",
    "subscriber.plan.per_person.label": "Per person",
    "subscriber.plan.per_person.people": "{count} people",
    "subscriber.plan.next_visit.assignment_pending": "Assignment confirmed before the visit",
    "subscriber.plan.next_visit.empty": "No confirmed visit",
    "subscriber.plan.next_visit.eyebrow": "Next visit",
    "subscriber.plan.next_visit.summary": "{weekday} {date} · {time}",
    "subscriber.plan.next_visit.with_worker": "with {name}",
    "subscriber.plan.pause.body": "No visits and no {amount} payment while paused. Resume whenever you like from the Plan tab.",
    "subscriber.plan.pause.confirm.cta": "Pause",
    "subscriber.plan.pause.header": "Pause",
    "subscriber.plan.pause.success.body": "No visits and no payments while paused. Resume whenever you like from the Plan tab.",
    "subscriber.plan.pause.success.changes_eyebrow": "What changes now",
    "subscriber.plan.pause.success.changes.data": "Your data and history kept",
    "subscriber.plan.pause.success.changes.no_charge": "No charge on {date}",
    "subscriber.plan.pause.success.changes.no_charge_pending": "No charge until payment is ready.",
    "subscriber.plan.pause.success.changes.no_visit": "No confirmed visit to cancel right now.",
    "subscriber.plan.pause.success.changes.resume": "Resume any time from Plan",
    "subscriber.plan.pause.success.changes.visit": "Visit on {weekday} {date}: canceled · no fee",
    "subscriber.plan.pause.success.cta": "Got it",
    "subscriber.plan.pause.success.deadline_body": "If you don't resume by {date}, your account will close automatically.",
    "subscriber.plan.pause.success.deadline_body_pending": "The office confirms your resume deadline in your file.",
    "subscriber.plan.pause.success.deadline_eyebrow": "Reminder · max delay",
    "subscriber.plan.pause.success.title": "Pause active",
    "subscriber.plan.pause.title": "Pause your plan?",
    "subscriber.plan.pause.warn_eyebrow": "What's going to happen",
    "subscriber.plan.pause.warn.cancel_visit": "Visit on {weekday} {date} canceled · you keep the credit",
    "subscriber.plan.pause.warn.no_charge": "No charge on {date}",
    "subscriber.plan.pause.warn.no_charge_pending": "No charge until payment is ready.",
    "subscriber.plan.pause.warn.no_visit_cancel": "Your history and preferences are kept. Your usual slot is not guaranteed when you resume.",
    "subscriber.plan.pause.warn.resume": "Resume any time",
    "subscriber.plan.paused.deadline_body": "The pause ends automatically after 3 months (on {date}). After that, your account closes and the slot can be given to another household.",
    "subscriber.plan.paused.deadline_body_pending": "Your pause stays temporary. The office confirms the resume deadline in your file.",
    "subscriber.plan.paused.deadline_eyebrow": "Heads up · max delay",
    "subscriber.plan.paused.extend_cta": "Extend pause · contact office",
    "subscriber.plan.paused.eyebrow": "Plan paused",
    "subscriber.plan.paused.headline": "No visits until you resume.",
    "subscriber.plan.paused.resume_cta": "Resume now",
    "subscriber.plan.paused.since": "Paused since {date} · day {day} of 90 max.",
    "subscriber.plan.paused.since_pending": "Pause active. The exact date is confirmed in your file.",
    "subscriber.plan.paused.title": "Your account is paused",
    "subscriber.plan.paused.worker_eyebrow": "Your service",
    "subscriber.plan.paused.worker_line": "The office keeps your file ready.",
    "subscriber.plan.paused.worker_sub": "History kept · {months} months managed",
    "subscriber.plan.paused.worker_sub_ready": "History kept · resume whenever you like",
    "subscriber.plan.pending.card_eyebrow": "Plan ready",
    "subscriber.plan.pending.request_body": "The office confirms your slot by call or WhatsApp before assigning your washerwoman.",
    "subscriber.plan.pending.request_title": "Your first visit is being confirmed.",
    "subscriber.plan.pending.title": "Your plan is ready.",
    "subscriber.plan.sponsor.billing_note": "Billed every month. Cancel anytime.",
    "subscriber.plan.sponsor.creating": "Creating Sponsor Pay link",
    "subscriber.plan.sponsor.eyebrow": "Sponsor Pay",
    "subscriber.plan.sponsor.fallback.cta": "Add local Mobile Money",
    "subscriber.plan.sponsor.fallback.notice": "Add a local Mobile Money method before the grace period ends to avoid service stopping.",
    "subscriber.plan.sponsor.grace_ends_label": "Grace period",
    "subscriber.plan.sponsor.invite.body": "Send a private link. The sponsor sees only the plan, amounts, payment status, and your first name.",
    "subscriber.plan.sponsor.invite.cta": "Create Sponsor Pay link",
    "subscriber.plan.sponsor.invite.title": "Let someone close pay this plan",
    "subscriber.plan.sponsor.link.body": "Share this link with the person who will pay the plan.",
    "subscriber.plan.sponsor.link.title": "Link ready",
    "subscriber.plan.sponsor.next_renewal_label": "Next renewal",
    "subscriber.plan.sponsor.plan_label": "Plan",
    "subscriber.plan.sponsor.privacy_note": "The sponsor cannot see the laveuse, address, photos, or disputes unless you explicitly share them.",
    "subscriber.plan.sponsor.revoke.cta": "Stop Sponsor Pay",
    "subscriber.plan.sponsor.revoked.body": "Add local Mobile Money to keep the plan active.",
    "subscriber.plan.sponsor.revoked.title": "Sponsor Pay stopped",
    "subscriber.plan.sponsor.revoking": "Stopping Sponsor Pay",
    "subscriber.plan.sponsor.share.cta": "Share",
    "subscriber.plan.sponsor.status.active": "Sponsor active",
    "subscriber.plan.sponsor.status.payment_failed": "Sponsor payment failed",
    "subscriber.plan.sponsor.status.pending": "Waiting for sponsor",
    "subscriber.plan.sponsor.status.revoked": "Sponsor Pay stopped",
    "subscriber.plan.sponsor.total_label": "Sponsor total",
    "subscriber.plan.title.active": "All set until {date}.",
    "subscriber.plan.title.active_payment_setup": "Plan ready, payment setup pending.",
    "subscriber.plan.upgrade.cancel.cta": "Keep my plan",
    "subscriber.plan.upgrade.changes_eyebrow": "What changes",
    "subscriber.plan.upgrade.confirm.cta": "Confirm · {amount} / month",
    "subscriber.plan.upgrade.current_label": "Current plan",
    "subscriber.plan.upgrade.effect_eyebrow": "Effect",
    "subscriber.plan.upgrade.effect.charge": "{date} · charge of {amount}",
    "subscriber.plan.upgrade.effect.charge_pending": "Next cycle confirmed before the {amount} charge",
    "subscriber.plan.upgrade.effect.same_worker": "The office keeps service continuity",
    "subscriber.plan.upgrade.error.network": "Unable to change plan. Try again.",
    "subscriber.plan.upgrade.new_label": "New plan",
    "subscriber.plan.upgrade.savings_label": "Savings / month",
    "subscriber.plan.upgrade.success.body": "The change starts next cycle. The office will contact you if an adjustment is needed.",
    "subscriber.plan.upgrade.success.cta": "Got it",
    "subscriber.plan.upgrade.success.title": "Plan updated",
    "subscriber.privacy.account.body": "Name · phone · address · Mobile Money number · optional profile answers. Kept while your account is active.",
    "subscriber.privacy.account.title": "Account data",
    "subscriber.privacy.delete.cta": "Delete my account",
    "subscriber.privacy.export.cta": "Download my data",
    "subscriber.privacy.export.reason": "Export request from the subscriber app.",
    "subscriber.privacy.export.submitted": "Request received. Reference {requestId}.",
    "subscriber.privacy.header": "Privacy & data",
    "subscriber.privacy.location.body": "Used only for on-the-way tracking (X-12). Encrypted samples are deleted after 30 min.",
    "subscriber.privacy.location.title": "Location",
    "subscriber.privacy.photos.body": "Before / after — encrypted, accessible to you and the office. Deleted after 12 months.",
    "subscriber.privacy.photos.title": "Visit photos",
    "subscriber.privacy.rights.body": "Request export, correction, or deletion of your data at any time.",
    "subscriber.privacy.rights.title": "Your rights",
    "subscriber.privacy.title": "What we keep about you.",
    "subscriber.profile.account_ready": "Active account",
    "subscriber.profile.cta_signout": "Sign out",
    "subscriber.profile.cta_support": "Help & support",
    "subscriber.profile.detail.address": "Address",
    "subscriber.profile.detail.address_missing": "Address to complete",
    "subscriber.profile.detail.adult": "Age",
    "subscriber.profile.detail.adult_confirmed": "18 or older confirmed",
    "subscriber.profile.detail.email": "Email",
    "subscriber.profile.detail.email_missing": "Not provided",
    "subscriber.profile.detail.first_name": "First name",
    "subscriber.profile.detail.last_name": "Last name",
    "subscriber.profile.detail.missing": "To complete",
    "subscriber.profile.detail.phone": "Phone",
    "subscriber.profile.details.title": "Account information",
    "subscriber.profile.edit.body": "Update the displayed name and account email.",
    "subscriber.profile.edit.change_number_cta": "Change number",
    "subscriber.profile.edit.cta": "Edit profile",
    "subscriber.profile.edit.header": "Profile",
    "subscriber.profile.edit.phone_note": "Your number changes after SMS verification.",
    "subscriber.profile.edit.save_cta": "Save",
    "subscriber.profile.edit.title": "Edit your information",
    "subscriber.profile.eyebrow": "Profile",
    "subscriber.profile.identity.pending_name": "Washed account",
    "subscriber.profile.member_since": "Subscriber since {date}",
    "subscriber.profile.menu.address": "Address",
    "subscriber.profile.menu.appearance": "Appearance",
    "subscriber.profile.menu.client_insights": "Get to know you",
    "subscriber.profile.menu.client_insights_sub": "Age, household, habits",
    "subscriber.profile.menu.label": "Settings",
    "subscriber.profile.menu.language": "Language",
    "subscriber.profile.menu.notifications": "Notifications",
    "subscriber.profile.menu.personal_info": "Personal information",
    "subscriber.profile.menu.personal_info_sub": "Name, email, photo",
    "subscriber.profile.menu.privacy": "Privacy & data",
    "subscriber.profile.photo.change": "Change photo",
    "subscriber.profile.photo.input_label": "Profile photo",
    "subscriber.referral.code_label": "Your code",
    "subscriber.referral.cta_share": "Share my code",
    "subscriber.referral.post_visit_reveal_body": "Introduce a friend to Washed and be there for her first wash.",
    "subscriber.referral.post_visit_reveal_title": "Tell someone close to you about Washed.",
    "subscriber.referral.share_message": "I use Washed to get my laundry washed at home in Lomé. Install the app and enter my code {code}: {link}",
    "subscriber.referral.signup_field_hint": "Were you invited? Enter the code your friend sent you.",
    "subscriber.referral.signup_field_label": "Referral code",
    "subscriber.referral.stats_pending": "Pending",
    "subscriber.referral.stats_qualified": "Confirmed",
    "subscriber.referral.status_merci": "Thank you! Your friend had her first wash thanks to you.",
    "subscriber.referral.subtitle": "Give Washed to a friend: share your code and be there for her first wash.",
    "subscriber.referral.title": "Refer a friend",
    "subscriber.repassage.a11y.success_announcement": "Ironing request sent.",
    "subscriber.repassage.basket_hint": "1 basket ≈ 20 garments (tops, trousers, dresses, boubous)",
    "subscriber.repassage.basket_label": "Laundry baskets",
    "subscriber.repassage.charge_timing_note": "You are only charged once a student accepts the job.",
    "subscriber.repassage.cta_submit": "Request ironing",
    "subscriber.repassage.date_label": "Visit date",
    "subscriber.repassage.fee_service_label": "Mixx/Flooz + SMS fees",
    "subscriber.repassage.fee_service_note": "Washed keeps nothing",
    "subscriber.repassage.fee_student_label": "Student's pay",
    "subscriber.repassage.fee_student_note": "100% goes to your student",
    "subscriber.repassage.fee_total_label": "Total",
    "subscriber.repassage.history_badge": "Ironing",
    "subscriber.repassage.impact_note": "Every ironing job supports a Lomé student. Washed takes no margin.",
    "subscriber.repassage.status.accepted": "Accepted — visit scheduled",
    "subscriber.repassage.status.cancelled": "Cancelled",
    "subscriber.repassage.status.completed": "Ironed and folded",
    "subscriber.repassage.status.declined": "Declined",
    "subscriber.repassage.status.expired": "Expired",
    "subscriber.repassage.status.no_show": "Missed visit",
    "subscriber.repassage.status.offered": "Offered to a student",
    "subscriber.repassage.status.paid": "Student paid",
    "subscriber.repassage.status.requested": "Requested",
    "subscriber.repassage.subtitle": "A Lomé student comes tomorrow to iron and fold your clean laundry.",
    "subscriber.repassage.success_body": "We're contacting a student. You'll be notified as soon as your ironing is accepted.",
    "subscriber.repassage.success_title": "Request sent",
    "subscriber.repassage.title": "Ironing at home",
    "subscriber.repassage.window_afternoon": "Afternoon",
    "subscriber.repassage.window_label": "Time window",
    "subscriber.repassage.window_morning": "Morning",
    "subscriber.signup.address.body": "Neighborhood, then details (street, landmark).",
    "subscriber.signup.address.field.neighborhood": "Neighborhood",
    "subscriber.signup.address.field.street": "Street / details",
    "subscriber.signup.address.location.captured": "Location captured ✓",
    "subscriber.signup.address.location.cta": "Use my current location",
    "subscriber.signup.address.location.denied": "Use my current location",
    "subscriber.signup.address.location.note": "Helps your washerwoman find you faster.",
    "subscriber.signup.address.location.requesting": "Locating…",
    "subscriber.signup.address.neighborhood.placeholder": "Choose a neighborhood",
    "subscriber.signup.address.street.placeholder": "street 254, blue house",
    "subscriber.signup.address.title": "Where will the washerwoman come?",
    "subscriber.signup.auth.error_generic": "Action unavailable. Try again.",
    "subscriber.signup.auth.error_network": "No connection. Check the network, then try again.",
    "subscriber.signup.auth.error_not_subscriber": "This number is not linked to a subscriber account.",
    "subscriber.signup.continue.cta": "Continue",
    "subscriber.signup.identity.adult": "I confirm I am 18 or older.",
    "subscriber.signup.identity.body": "The office uses this information for your account and receipts.",
    "subscriber.signup.identity.email.placeholder": "afi@email.com",
    "subscriber.signup.identity.field.email": "Email (optional)",
    "subscriber.signup.identity.field.first_name": "First name",
    "subscriber.signup.identity.field.last_name": "Last name",
    "subscriber.signup.identity.first_name.placeholder": "Afi",
    "subscriber.signup.identity.last_name.placeholder": "Mensah",
    "subscriber.signup.identity.title": "Your information",
    "subscriber.signup.otp.body": "Six digits sent to {phone}.",
    "subscriber.signup.otp.call_office.cta": "Call the office",
    "subscriber.signup.otp.digit_label": "Digit {index}",
    "subscriber.signup.otp.edit_phone.cta": "Edit",
    "subscriber.signup.otp.help_prefix": "Not received after 30 s?",
    "subscriber.signup.otp.resend": "Resend in {seconds} s",
    "subscriber.signup.otp.resend_now.cta": "Resend code",
    "subscriber.signup.otp.title": "The code we just sent.",
    "subscriber.signup.payment.body": "Choose Mixx by Yas or Flooz, then enter the number tied to that provider.",
    "subscriber.signup.payment.note": "First charge before your first visit.",
    "subscriber.signup.payment.phone_error": "Check your {provider} number.",
    "subscriber.signup.payment.phone_help": "Your 8-digit {provider} number.",
    "subscriber.signup.payment.phone_label": "Mobile Money number",
    "subscriber.signup.payment.provider_label": "Provider",
    "subscriber.signup.payment.title": "Payment method.",
    "subscriber.signup.phone.body": "We'll text you a code to confirm.",
    "subscriber.signup.phone.cta": "Send the code",
    "subscriber.signup.phone.input_label": "Number",
    "subscriber.signup.phone.placeholder": "90 12 34 56",
    "subscriber.signup.phone.privacy_note": "Your number stays private. Never shared with your washerwoman.",
    "subscriber.signup.phone.title": "Your phone number.",
    "subscriber.signup.review.consent.connector": "and the",
    "subscriber.signup.review.consent.prefix": "I accept the",
    "subscriber.signup.review.consent.privacy": "privacy policy",
    "subscriber.signup.review.consent.terms": "terms",
    "subscriber.signup.review.cta": "Confirm subscription",
    "subscriber.signup.review.eyebrow": "Recap",
    "subscriber.signup.review.field.address": "Address",
    "subscriber.signup.review.field.identity": "Account",
    "subscriber.signup.review.field.payment": "Payment",
    "subscriber.signup.review.field.tier": "Plan",
    "subscriber.signup.review.field.total": "Monthly total",
    "subscriber.signup.review.next_step.body": "Your washerwoman will call you to schedule the first visit.",
    "subscriber.signup.review.title": "Everything good?",
    "subscriber.signup.step_indicator": "Step {current} of {total}",
    "subscriber.signup.tier.available_badge": "available",
    "subscriber.signup.tier.body": "You can change later, with no fee.",
    "subscriber.signup.tier.cta_continue_amount": "Continue · {amount}",
    "subscriber.signup.tier.pricing_note": "Price confirmed before each Mobile Money charge.",
    "subscriber.signup.tier.selected_badge": "selected",
    "subscriber.signup.tier.t1.label": "1 visit / month · 1 person",
    "subscriber.signup.tier.t1.price": "4,500 XOF / month",
    "subscriber.signup.tier.t2.label": "2 visits / month · 1 person",
    "subscriber.signup.tier.t2.price": "8,500 XOF / month",
    "subscriber.signup.tier.title": "How many visits a month?",
    "subscriber.signup.welcome.body": "Your subscription is ready. Now choose the day and time for your first visit.",
    "subscriber.signup.welcome.cta": "Schedule my first visit",
    "subscriber.signup.welcome.skip_cta": "Skip for now",
    "subscriber.signup.welcome.title": "Welcome to Washed.",
    "subscriber.splash.cta_continue": "Continue",
    "subscriber.splash.cta_existing": "I already have an account",
    "subscriber.splash.tagline": "The washerwoman app for Lomé.",
    "subscriber.support.contact.category.other": "Other",
    "subscriber.support.contact.category.payment": "Mobile Money payment",
    "subscriber.support.contact.category.plan": "My plan · pause, change, end",
    "subscriber.support.contact.category.visit": "A visit · cancel, reschedule, problem",
    "subscriber.support.contact.category.worker": "My washerwoman · change, return, other",
    "subscriber.support.contact.header": "Contact the office",
    "subscriber.support.contact.message.label": "Your message",
    "subscriber.support.contact.message.placeholder": "Describe in a few words…",
    "subscriber.support.contact.subject.label": "Subject",
    "subscriber.support.contact.subject.placeholder": "Summarize your request",
    "subscriber.support.contact.submit.cta": "Send to office",
    "subscriber.support.contact.submit.error": "Couldn't send. Check your connection and try again.",
    "subscriber.support.contact.submitted.body": "Ticket #{ticketId} created. The answer will arrive in Your requests.",
    "subscriber.support.contact.submitted.body_pending": "Your request has been received. The answer will arrive in Your requests.",
    "subscriber.support.contact.submitted.card_eyebrow": "Your request · #{ticketId}",
    "subscriber.support.contact.submitted.card_eyebrow_pending": "Your request",
    "subscriber.support.contact.submitted.card_status": "Open · waiting for the office",
    "subscriber.support.contact.submitted.created_label": "Ticket created",
    "subscriber.support.contact.submitted.home_cta": "Back to home",
    "subscriber.support.contact.submitted.tickets_cta": "See my tickets",
    "subscriber.support.contact.submitted.title": "Message sent",
    "subscriber.support.contact.title": "What would you like to talk about?",
    "subscriber.support.help.call.detail": "{phone} · Mon-Sat 7am-7pm",
    "subscriber.support.help.call.title": "Call the office",
    "subscriber.support.help.eyebrow": "Help",
    "subscriber.support.help.faq.cancel.answer": "From the visit detail, choose Reschedule. The office will confirm the new slot.",
    "subscriber.support.help.faq.cancel.question": "How do I cancel a visit?",
    "subscriber.support.help.faq.damage.answer": "Report an issue from the visit. Add photos if you can.",
    "subscriber.support.help.faq.damage.question": "Laundry was damaged. What should I do?",
    "subscriber.support.help.faq.eyebrow": "Frequently asked",
    "subscriber.support.help.contact.eyebrow": "Contact the office",
    "subscriber.support.help.faq.missed.answer": "Call the office. We'll check the route and call you back.",
    "subscriber.support.help.faq.missed.question": "What if the washerwoman doesn't come?",
    "subscriber.support.help.faq.payment.answer": "In Plan, open Payment method and save the new number.",
    "subscriber.support.help.faq.payment.question": "How do I change Mobile Money?",
    "subscriber.support.help.faq.worker.answer": "Yes — the office reviews the request without canceling your next visit.",
    "subscriber.support.help.faq.worker.question": "Can I change washerwoman?",
    "subscriber.support.help.tickets.cta": "My tickets · {openCount} open",
    "subscriber.support.help.title": "We're listening",
    "subscriber.support.help.whatsapp.detail": "{phone}",
    "subscriber.support.help.whatsapp.title": "Message us on WhatsApp",
    "subscriber.support.help.write.cta": "Message the office",
    "subscriber.support.retry.cta": "Try again",
    "subscriber.support.ticket.detail.header": "Ticket #{ticketId}",
    "subscriber.support.ticket.detail.load.error": "Couldn't load this ticket. Try again.",
    "subscriber.support.ticket.detail.message_office_label": "Office message",
    "subscriber.support.ticket.detail.message_subscriber_label": "Subscriber message",
    "subscriber.support.ticket.detail.not_found.body": "This request isn't linked to your account.",
    "subscriber.support.ticket.detail.not_found.cta": "See my tickets",
    "subscriber.support.ticket.detail.not_found.title": "Request not found",
    "subscriber.support.ticket.detail.office_label": "Office · {timeAgo}",
    "subscriber.support.ticket.detail.photo.pull": "Sweater · 1",
    "subscriber.support.ticket.detail.photo.shirts": "Shirts · 2",
    "subscriber.support.ticket.detail.reply.cta": "Send",
    "subscriber.support.ticket.detail.reply.error": "Couldn't send your reply. Try again.",
    "subscriber.support.ticket.detail.reply.just_now": "just now",
    "subscriber.support.ticket.detail.reply.label": "Reply",
    "subscriber.support.ticket.detail.reply.placeholder": "Reply…",
    "subscriber.support.ticket.detail.status.open": "In progress",
    "subscriber.support.ticket.detail.status.resolved": "Resolved",
    "subscriber.support.ticket.detail.user_label": "You · {timeAgo}",
    "subscriber.support.tickets.empty.body": "Your messages to the office will appear here.",
    "subscriber.support.tickets.empty.title": "No requests yet",
    "subscriber.support.tickets.header": "My tickets",
    "subscriber.support.tickets.load.error": "Couldn't load your tickets. Try again.",
    "subscriber.support.tickets.open_request.cta": "Open a request",
    "subscriber.support.tickets.open.progress": "{agentName} is looking into it",
    "subscriber.support.tickets.status.open": "#{ticketId} · Open",
    "subscriber.support.tickets.status.resolved": "#{ticketId} · Resolved",
    "subscriber.support.tickets.title": "Your requests",
    "subscriber.system.maintenance.body": "We're improving something for you. The app comes back in about {minutes} minutes.",
    "subscriber.system.maintenance.emergency": "If urgent, call the office at {phone}.",
    "subscriber.system.maintenance.next_visit": "Your next visit",
    "subscriber.system.maintenance.next_visit_line": "{date} · {time} · {name}",
    "subscriber.system.maintenance.next_visit_line_assignment": "{date} · {time} · assignment in progress",
    "subscriber.system.maintenance.no_impact": "Still on · no impact.",
    "subscriber.system.maintenance.title": "Maintenance in progress.",
    "subscriber.system.offline.greeting": "Hi {name}",
    "subscriber.system.offline.next_visit": "Next visit",
    "subscriber.system.offline.retry_cta": "Try again",
    "subscriber.system.offline.retry_hint": "We check the network every 30 seconds.",
    "subscriber.system.offline.status": "Offline · last update {time}",
    "subscriber.system.offline.worker_cache_label": "Cached washerwoman",
    "subscriber.system.offline.worker_hidden": "info hidden locally",
    "subscriber.system.update.body": "Important security updates. The current version stops working as of today.",
    "subscriber.system.update.cta": "Update",
    "subscriber.system.update.item.reveal": "Faster reveal photos",
    "subscriber.system.update.item.security": "Security fixes",
    "subscriber.system.update.item.tracking": "Better on-the-way tracking",
    "subscriber.system.update.title_prefix": "A new version",
    "subscriber.system.update.title_suffix": "is available.",
    "subscriber.system.update.whats_new": "What's new",
    "subscriber.toast.booking.success": "Request sent",
    "subscriber.toast.notification.disabled": "Notification disabled",
    "subscriber.toast.notification.enabled": "Notification enabled",
    "subscriber.toast.notification.error": "Update failed",
    "subscriber.toast.pause.error": "Pause failed",
    "subscriber.toast.pause.success": "Subscription paused",
    "subscriber.toast.payment_method.success": "Payment method updated",
    "subscriber.toast.repassage.error": "Could not send the ironing request.",
    "subscriber.toast.resume.error": "Resume failed",
    "subscriber.toast.resume.success": "Subscription resumed",
    "subscriber.toast.tier_change.error": "Plan change failed",
    "subscriber.toast.tier_change.success": "Plan updated",
    "subscriber.tour.a11y_dismiss": "Close the getting-started guide",
    "subscriber.tour.cta_done": "Start",
    "subscriber.tour.cta_next": "Next",
    "subscriber.tour.eyebrow": "Tour",
    "subscriber.tour.new_chip": "new",
    "subscriber.tour.step_indicator": "{current} / {total}",
    "subscriber.tour.step1.body": "Scheduling, plan, and help stay within reach before the first visit.",
    "subscriber.tour.step1.card_body": "Tap Schedule to choose your first slot.",
    "subscriber.tour.step1.title": "Your home starts here.",
    "subscriber.tour.step2.body": "The office chooses a washerwoman from your neighborhood. You see her here before every visit.",
    "subscriber.tour.step2.card_body": "Tap Washerwoman to see her profile.",
    "subscriber.tour.step2.title": "Your laveuse, chosen for you",
    "subscriber.tour.step3.body": "Change your plan, pause service, or follow payments from the Plan tab.",
    "subscriber.tour.step3.card_body": "Tap Plan to explore your options.",
    "subscriber.tour.step3.title": "Your plan, always in your hands",
    "subscriber.visit.arrived.toast": "{name} is at your door.",
    "subscriber.visit.complete.toast": "Visit done. {name} has left.",
    "subscriber.visit.detail.address.label": "Address",
    "subscriber.visit.detail.body": "The office tracks this visit until the service is done.",
    "subscriber.visit.detail.body_with_worker": "{name} is planned for this visit. Washed keeps tracking it.",
    "subscriber.visit.detail.duration.label": "Expected duration",
    "subscriber.visit.detail.kicker": "Next visit",
    "subscriber.visit.detail.report_note": "You can reschedule until 6 PM the day before.",
    "subscriber.visit.detail.report.cta": "Reschedule",
    "subscriber.visit.detail.tier.label": "Plan",
    "subscriber.visit.detail.title": "{name} arrives at {time}.",
    "subscriber.visit.enroute.distance_label": "Distance",
    "subscriber.visit.enroute.distance_live": "Live tracking",
    "subscriber.visit.enroute.eta_label": "Arrives in",
    "subscriber.visit.enroute.eta_live": "On the way",
    "subscriber.visit.enroute.eyebrow": "On the way · {time}",
    "subscriber.visit.enroute.home_label": "Your home",
    "subscriber.visit.enroute.map_label": "Tracking map",
    "subscriber.visit.enroute.metrics_label": "Trip status",
    "subscriber.visit.enroute.signal_lost": "Signal lost · last known location",
    "subscriber.visit.enroute.status_label": "Status",
    "subscriber.visit.enroute.title": "{name} is on the way.",
    "subscriber.visit.enroute.update_note": "Updated every {cadence}",
    "subscriber.visit.feedback.good": "All good",
    "subscriber.visit.feedback.issue": "Report an issue",
    "subscriber.visit.feedback.prompt": "Did everything go well?",
    "subscriber.visit.in_progress.body": "You can close the app. We'll let you know when it's done.",
    "subscriber.visit.in_progress.close_cta": "Close the app calmly",
    "subscriber.visit.in_progress.started_body": "{name} started the visit at {time}.",
    "subscriber.visit.in_progress.started_body_pending": "The office is tracking the visit start.",
    "subscriber.visit.in_progress.started_title": "Start",
    "subscriber.visit.in_progress.status": "Visit in progress",
    "subscriber.visit.in_progress.title": "Your laundry is being handled",
    "subscriber.visit.issue.header": "Report an issue",
    "subscriber.visit.issue.option.behavior": "Inappropriate behavior",
    "subscriber.visit.issue.option.damaged": "Damaged laundry",
    "subscriber.visit.issue.option.missing": "Missing laundry",
    "subscriber.visit.issue.option.no_show": "The washerwoman did not come",
    "subscriber.visit.issue.option.other": "Other · describe",
    "subscriber.visit.issue.option.poor_wash": "Laundry not clean",
    "subscriber.visit.issue.photo.add.cta": "Add photos",
    "subscriber.visit.issue.photo.body": "Show the laundry or the detail concerned. The office checks them before calling you back.",
    "subscriber.visit.issue.photo.count_many": "{count} photos added",
    "subscriber.visit.issue.photo.count_one": "1 photo added",
    "subscriber.visit.issue.photo.empty": "No photos added",
    "subscriber.visit.issue.photo.required": "Add at least one photo to send the report.",
    "subscriber.visit.issue.photo.submit.cta": "Send report",
    "subscriber.visit.issue.photo.title": "Add photos of the issue.",
    "subscriber.visit.issue.title": "Tell us what went wrong",
    "subscriber.visit.morning.banner": "{name} is coming today at {time}.",
    "subscriber.visit.action_menu.a11y_actions_button_hint": "Opens the actions available for this visit.",
    "subscriber.visit.action_menu.action_cancel": "Cancel the visit",
    "subscriber.visit.action_menu.action_rate": "Rate the washerwoman",
    "subscriber.visit.action_menu.action_report_issue": "Report an issue",
    "subscriber.visit.action_menu.action_reschedule": "Reschedule the visit",
    "subscriber.visit.action_menu.dismiss": "Close",
    "subscriber.visit.action_menu.open_menu": "Actions",
    "subscriber.visit.action_menu.sheet_title": "Actions",
    "subscriber.visit.cancel.a11y.submitting": "Cancelling",
    "subscriber.visit.cancel.body": "We'll let your washer know. This visit won't be replaced or refunded.",
    "subscriber.visit.cancel.confirm.cta": "Confirm cancellation",
    "subscriber.visit.cancel.error.network": "Network error. Try again.",
    "subscriber.visit.cancel.keep.cta": "Keep the visit",
    "subscriber.visit.cancel.kicker": "Cancel",
    "subscriber.visit.cancel.success.body": "The washerwoman has been notified. Your next confirmed visit will appear on the home screen.",
    "subscriber.visit.cancel.success.cta": "Back to home",
    "subscriber.visit.cancel.success.kicker": "Confirmed",
    "subscriber.visit.cancel.success.title": "Visit cancelled.",
    "subscriber.visit.cancel.title": "Cancel this visit?",
    "subscriber.visit.reschedule.a11y.submitting": "Saving the new date",
    "subscriber.visit.reschedule.body": "The office confirms the new slot and adjusts the assignment if the time changes.",
    "subscriber.visit.reschedule.confirm.cta": "Confirm reschedule",
    "subscriber.visit.reschedule.error.network": "Network error. Try again.",
    "subscriber.visit.reschedule.error.past_date": "Choose a future date.",
    "subscriber.visit.reschedule.field.date": "Date",
    "subscriber.visit.reschedule.field.window": "Time window",
    "subscriber.visit.reschedule.field.window.afternoon": "Afternoon (1–5 pm)",
    "subscriber.visit.reschedule.field.window.morning": "Morning (8 am–12 pm)",
    "subscriber.visit.reschedule.header": "Reschedule a visit",
    "subscriber.visit.reschedule.kicker": "RESCHEDULE",
    "subscriber.visit.reschedule.note": "None of these work? The office will call you back.",
    "subscriber.visit.reschedule.option.same_zone": "{time} · same zone slot",
    "subscriber.visit.reschedule.option.usual": "{time} · usual time",
    "subscriber.visit.reschedule.option.worker_available": "{time} · proposed slot",
    "subscriber.visit.reschedule.options_label": "Proposed slots",
    "subscriber.visit.reschedule.title": "Choose a new time slot",
    "subscriber.visit.return_home.cta": "Back to home",
    "subscriber.visit.reveal.after": "After — {hour}:{min}",
    "subscriber.visit.reveal.before": "Before — {hour}:{min}",
    "subscriber.visit.reveal.completed_note": "{name} left at {time}. Duration {duration}.",
    "subscriber.visit.reveal.completed_note_generic": "Visit finished at {time}. Duration {duration}.",
    "subscriber.visit.reveal.completed_title": "Visit done.",
    "subscriber.visit.reveal.photo_unavailable": "Photo unavailable",
    "subscriber.visit.reveal.photos_label": "Before and after photos",
    "subscriber.visit.reveal.recap_title": "Recap",
    "subscriber.visit.reveal.timeline_unavailable": "Unavailable",
    "subscriber.visit.reveal.timeline.end": "End",
    "subscriber.visit.reveal.timeline.start": "Start",
    "subscriber.visit.reveal.timeline.wash": "Washing",
    "subscriber.visit.reveal.title": "Here's how it turned out.",
    "subscriber.visit.status.cancelled": "Canceled",
    "subscriber.visit.status.completed": "Completed",
    "subscriber.visit.status.en_route": "On the way",
    "subscriber.visit.status.in_progress": "In progress",
    "subscriber.visit.status.no_show": "Missed visit",
    "subscriber.visit.status.pending_review": "Pending review",
    "subscriber.visit.status.scheduled": "Scheduled",
    "subscriber.visit.status.unknown": "Unknown status",
    "subscriber.visit.support.body": "The office calls you back today. The washerwoman does not see this report.",
    "subscriber.visit.support.submit.cta": "Next · add photos",
    "subscriber.visit.support.submitted.body": "Report #0421 created. The answer will show on the visit page.",
    "subscriber.visit.support.submitted.body_live": "Report #{ticketId} created. The answer will show on the visit page.",
    "subscriber.visit.support.submitted.ticket_cta": "See my ticket",
    "subscriber.visit.support.submitted.title": "Report received.",
    "subscriber.visit.thanks.body": "Thank you. The office keeps your feedback with the service history.",
    "subscriber.visit.thanks.counter_line": "Washed service since {since}",
    "subscriber.visit.thanks.counter_title": "Your counter",
    "subscriber.visit.thanks.title": "Thank you.",
    "subscriber.visit.window.afternoon": "Afternoon",
    "subscriber.visit.window.morning": "Morning",
    "subscriber.worker.change.a11y.description_label": "Request details, optional",
    "subscriber.worker.change.a11y.reason_required": "Choose a reason to send the request",
    "subscriber.worker.change.a11y.submitting": "Sending the change request",
    "subscriber.worker.change.a11y.success_announcement": "Change request sent",
    "subscriber.worker.change.body": "The office will call you today to understand. {name} doesn't see this request.",
    "subscriber.worker.change.description.label": "Useful detail for the bureau (optional)",
    "subscriber.worker.change.description.not_sent_notice": "For this first version, only the selected reason is sent. The detail below helps us improve the next version.",
    "subscriber.worker.change.description.placeholder": "Add anything useful for the bureau.",
    "subscriber.worker.change.error.network": "Unable to send. Try again.",
    "subscriber.worker.change.keyboard.done": "Done",
    "subscriber.worker.change.note.body": "Usual delay for changes: 1-2 weeks. The next visit is kept with {name}.",
    "subscriber.worker.change.note.title": "Heads up",
    "subscriber.worker.change.reason.availability": "Availability",
    "subscriber.worker.change.reason.availability.sub": "my schedule has changed",
    "subscriber.worker.change.reason.behavior": "Behavior issue",
    "subscriber.worker.change.reason.incident": "Incident",
    "subscriber.worker.change.reason.incident.sub": "unresolved problem",
    "subscriber.worker.change.reason.other": "Other",
    "subscriber.worker.change.reason.personal": "Personal preference",
    "subscriber.worker.change.reason.preference": "Preference",
    "subscriber.worker.change.reason.preference.sub": "I'd like to try someone else",
    "subscriber.worker.change.reason.quality": "Work quality issue",
    "subscriber.worker.change.reason.schedule": "{name} moved / changed schedule",
    "subscriber.worker.change.submit.cta": "Send request",
    "subscriber.worker.change.submitted.body": "The office will call you today. The next visit stays with {name}.",
    "subscriber.worker.change.submitted.cta": "Got it",
    "subscriber.worker.change.submitted.title": "Request sent",
    "subscriber.worker.change.title": "Why change?",
    "subscriber.worker.profile.change.cta": "Request a change",
    "subscriber.worker.profile.header": "Washerwoman profile",
    "subscriber.worker.profile.location": "{neighborhood} · lives with her family {distance} from you",
    "subscriber.worker.profile.location_live": "{neighborhood} · assigned washerwoman",
    "subscriber.worker.profile.location_live_generic": "Service tracked by Washed",
    "subscriber.worker.profile.path.body": "Washerwoman since {since}. {households} regular households in Lomé. Speaks {languages}.",
    "subscriber.worker.profile.path.body_live": "{name} is the washerwoman assigned to this plan.",
    "subscriber.worker.profile.path.title": "Her path",
    "subscriber.worker.profile.relation.active": "active",
    "subscriber.worker.profile.relation.months": "{months} months",
    "subscriber.worker.profile.relation.title": "Your relationship",
    "subscriber.worker.profile.relation.together": "together",
    "subscriber.worker.profile.relation.visits": "visits",
    "subscriber.worker.profile.reliability.body": "{visits} visits · {cancellations} canceled by her · {onTimeRate}% on time this month.",
    "subscriber.worker.profile.reliability.body_live": "{visits} completed visits on your plan.",
    "subscriber.worker.profile.reliability.rating_pending": "Rating available after more visits",
    "subscriber.worker.profile.reliability.title": "Reliability",
    "survey.confirm": "Confirm →",
    "survey.error.consent": "Please accept to be contacted before leaving your details (or skip this step).",
    "survey.error.email": "Check the email and try again.",
    "survey.error.phone": "Check the number and try again.",
    "survey.error.submit": "Submission failed. Please try again.",
    "survey.eyebrow": "Question {current} / {total}",
    "survey.nav.back": "← Back",
    "survey.nav.back.aria": "Previous question",
    "survey.page.meta": "Help Washed understand laundry habits in Lomé. 2 minutes, 10 questions.",
    "survey.page.title": "Washed · Survey · 2 minutes for Lomé",
    "survey.progress.aria": "Survey progress",
    "survey.q1.option.none": "No, I wash myself",
    "survey.q1.option.regular": "Yes, regularly",
    "survey.q1.option.sometimes": "Yes, sometimes",
    "survey.q1.text": "Do you currently have a laundress who visits your home?",
    "survey.q10.aria.consent": "Consent",
    "survey.q10.aria.email": "Your email address",
    "survey.q10.aria.phone": "Your phone number",
    "survey.q10.consent_label": "If you leave your contact details, I agree that Washed may keep them to reach me when the service is available near me.",
    "survey.q10.optional_hint": "Phone or email — both optional. We'll only write when Washed is available near you.",
    "survey.q10.placeholder.email": "your@email.com",
    "survey.q10.placeholder.phone": "+228 90 12 34 56",
    "survey.q10.submit.no_contact": "Submit my answers →",
    "survey.q10.submit.with_contact": "Finish →",
    "survey.q10.text": "Want Washed to get back to you?",
    "survey.q2.option.biweekly": "Every two weeks",
    "survey.q2.option.monthly": "Once a month",
    "survey.q2.option.on_demand": "When I need it / it varies",
    "survey.q2.option.weekly": "Every week",
    "survey.q2.text": "How often does she come?",
    "survey.q3.option.2_3k": "2,000 – 3,000 XOF",
    "survey.q3.option.3_5k": "3,000 – 5,000 XOF",
    "survey.q3.option.5_10k": "5,000 – 10,000 XOF",
    "survey.q3.option.over_10k": "More than 10,000 XOF",
    "survey.q3.option.under_2k": "Less than 2,000 XOF",
    "survey.q3.option.varies": "It varies",
    "survey.q3.text": "How much do you pay her per month?",
    "survey.q4.option.alone": "Just for me",
    "survey.q4.option.partial": "For several people (but not the whole household)",
    "survey.q4.option.whole_household": "For the whole household",
    "survey.q4.text": "Does she wash for you alone, or for the whole household?",
    "survey.q5.multi_hint": "Select all that apply, then confirm.",
    "survey.q5.option.disappears": "She sometimes vanishes without notice",
    "survey.q5.option.lost_damaged": "Lost or damaged clothes",
    "survey.q5.option.none": "No frustrations",
    "survey.q5.option.price_changes": "The price keeps changing",
    "survey.q5.option.quality": "Quality is inconsistent",
    "survey.q5.option.unreliable": "She's unreliable (comes whenever she wants)",
    "survey.q5.text": "What is your biggest frustration with your current laundress?",
    "survey.q6.option.1": "1 person",
    "survey.q6.option.2_3": "2 or 3 people",
    "survey.q6.option.4_5": "4 or 5 people",
    "survey.q6.option.6_plus": "6 or more people",
    "survey.q6.text": "How many people live in your household?",
    "survey.q7.text": "Would you pay 2,500 XOF/month for one monthly visit from a trained, verified laundress?",
    "survey.q7q8.option.no": "No",
    "survey.q7q8.option.unsure": "I'm not sure",
    "survey.q7q8.option.yes_definitely": "Yes, definitely",
    "survey.q7q8.option.yes_maybe": "Yes, maybe",
    "survey.q8.text": "And 4,500 XOF/month for two visits per month?",
    "survey.q9.aria": "Your neighbourhood",
    "survey.q9.optional_hint": "Optional. Helps us organise visits by neighbourhood.",
    "survey.q9.placeholder": "E.g. Tokoin-Hôpital, Bè-Kpota…",
    "survey.q9.text": "Your neighbourhood in Lomé?",
    "survey.skip": "Skip",
    "survey.submitting": "Sending…",
    "survey.thanks.body": "Your answers help Washed build the service your household deserves.",
    "survey.thanks.home_link": "See the Washed site",
    "survey.thanks.share_button": "Share the survey",
    "survey.thanks.share_message": "Hi 👋 Help Washed understand laundry in Lomé — just 2 minutes: https://washedafrica.com/sondage",
    "survey.thanks.title": "Thank you 🙏",
    "survey.turnstile.error": "Please complete the anti-bot verification before submitting.",
    "worker.app.offline_banner.failed": "{count} action(s) failed. The team will contact you.",
    "worker.app.offline_banner.offline": "Offline — your actions are saved.",
    "worker.app.offline_banner.queued": "{count} action(s) waiting to sync.",
    "worker.app.offline_banner.syncing": "Syncing…",
    "worker.auth.w_01.cta_primary": "Continue",
    "worker.auth.w_01.cta_secondary": "I already have an account",
    "worker.auth.w_01.kicker": "LOADING",
    "worker.auth.w_01.note": "Brand + tag · 2 buttons. Silent background sync.",
    "worker.auth.w_01.tag": "the washer app · lomé",
    "worker.auth.w_01.title": "Washed",
    "worker.auth.w_02_e1.copy": "Check the digits and try again. You have {count} attempts left before lockout.",
    "worker.auth.w_02_e1.copy_one": "Check the digits and try again. You have 1 attempt left before lockout.",
    "worker.auth.w_02_e1.cta": "Try again",
    "worker.auth.w_02_e1.forgot_link": "Forgot PIN?",
    "worker.auth.w_02_e1.kicker": "↩ SIGN IN",
    "worker.auth.w_02_e1.note": "Entry error · remaining attempts shown.",
    "worker.auth.w_02_e1.notice": "After 5 failed attempts, your account will be locked until you call the office.",
    "worker.auth.w_02_e1.title": "Wrong PIN",
    "worker.auth.w_02_e2.copy": "Too many incorrect attempts. For security, only the office can unlock your account.",
    "worker.auth.w_02_e2.countdown": "Automatic unlock in {time}.",
    "worker.auth.w_02_e2.cta_back": "Back",
    "worker.auth.w_02_e2.cta_call": "Call the office",
    "worker.auth.w_02_e2.kicker": "↩ SIGN IN",
    "worker.auth.w_02_e2.note": "5 failed attempts · only the office can unlock.",
    "worker.auth.w_02_e2.title": "Account locked",
    "worker.auth.w_02_e3.copy": "No network connection. Check your signal and try again.",
    "worker.auth.w_02_e3.cta": "Try again",
    "worker.auth.w_02_e3.kicker": "SIGN IN",
    "worker.auth.w_02_e3.note": "No network on startup · degraded mode.",
    "worker.auth.w_02_e3.title": "No network",
    "worker.auth.w_02_r.copy": "Call the office at {phone}. The operator verifies your identity, then triggers the reset. You will then receive a WhatsApp message to set a new PIN.",
    "worker.auth.w_02_r.cta_back": "Back",
    "worker.auth.w_02_r.cta_call": "Call the office",
    "worker.auth.w_02_r.kicker": "RESET",
    "worker.auth.w_02_r.note": "Sub-modal of W-02. Office has confirmed identity.",
    "worker.auth.w_02_r.title": "New PIN",
    "worker.auth.w_02.copy": "Enter your 4-digit PIN to start the day.",
    "worker.auth.w_02.cta": "Start the day",
    "worker.auth.w_02.demo_copy": "Tap a demo account (PIN 1234) to sign in.",
    "worker.auth.w_02.demo_title": "Choose an account",
    "worker.auth.w_02.forgot_link": "Forgot PIN?",
    "worker.auth.w_02.kicker": "SIGN IN",
    "worker.auth.w_02.note": "Local PIN never transmitted. Verified against hash.",
    "worker.auth.w_02.phone_copy": "Enter your number to sign in.",
    "worker.auth.w_02.phone_cta": "Continue",
    "worker.auth.w_02.phone_field_label": "Phone number",
    "worker.auth.w_02.phone_placeholder": "90 12 34 56",
    "worker.auth.w_02.phone_title": "Your number",
    "worker.auth.w_02.title": "Hello.",
    "worker.cancellation.w_18.compensation_label": "Compensation",
    "worker.cancellation.w_18.eligible_no": "Not eligible",
    "worker.cancellation.w_18.eligible_yes": "Eligible",
    "worker.cancellation.w_18.replacement_notice": "The office will replace this slot if possible before noon.",
    "worker.cancellation.w_18.subscriber_line": "{name} canceled the {time} visit.",
    "worker.cancellation.w_18.title": "Visit canceled",
    "worker.earn.balance.label": "Available balance",
    "worker.earn.bonus.regularity": "Regularity bonus · + {amount} XOF",
    "worker.earn.empty": "No earnings yet this week.",
    "worker.earn.this_week": "This week",
    "worker.earn.title": "Your earnings",
    "worker.earn.withdraw.confirmed": "{amount} XOF sent to {provider}",
    "worker.earn.withdraw.cta": "Withdraw",
    "worker.earnings.visits_count": "{count} visit",
    "worker.earnings.w_13_0.kicker": "THIS WEEK",
    "worker.earnings.w_13_0.note": "New washer · week 1 with no visits.",
    "worker.earnings.w_13_0.title": "Your earnings",
    "worker.earnings.w_13_m.amount_label": "Amount (XOF)",
    "worker.earnings.w_13_m.available_hint": "Available: {amount}",
    "worker.earnings.w_13_m.cancel": "Cancel",
    "worker.earnings.w_13_m.confirm": "Confirm",
    "worker.earnings.w_13_m.error_unknown": "Unknown error",
    "worker.earnings.w_13_m.kicker": "↩ EARNINGS",
    "worker.earnings.w_13_m.min_amount_error": "Minimum 1,000 XOF",
    "worker.earnings.w_13_m.note": "Sub-modal of W-13. Amount + number confirmation.",
    "worker.earnings.w_13_m.payout_to": "To",
    "worker.earnings.w_13_m.payout_unset": "Set up in your profile",
    "worker.earnings.w_13_m.queued_toast": "Sending deferred",
    "worker.earnings.w_13_m.title": "Request a withdrawal",
    "worker.earnings.w_13_v.kicker": "↩ EARNINGS",
    "worker.earnings.w_13_v.note": "Sub-modal of W-13 · breakdown by visit.",
    "worker.earnings.w_13_v.title": "Tuesday 5 May",
    "worker.earnings.w_13.advance_cta": "Request an advance",
    "worker.earnings.w_13.advance_cta_aria": "Request an advance on your earnings",
    "worker.earnings.w_13.advance_status.approved": "Approved",
    "worker.earnings.w_13.advance_status.paid": "Paid",
    "worker.earnings.w_13.advance_status.pending": "Requested",
    "worker.earnings.w_13.advance_status.rejected": "Rejected",
    "worker.earnings.w_13.body": "Track your net earnings, completed visits, and payments already sent.",
    "worker.earnings.w_13.breakdown.completed_visits": "Completed visits",
    "worker.earnings.w_13.breakdown.floor": "Guaranteed floor",
    "worker.earnings.w_13.breakdown.month": "Month",
    "worker.earnings.w_13.breakdown.net_due": "Net due",
    "worker.earnings.w_13.breakdown.paid_out": "Already paid",
    "worker.earnings.w_13.breakdown.visit_bonus": "Visit bonus",
    "worker.earnings.w_13.empty_body": "Try again when your network is stable.",
    "worker.earnings.w_13.empty_title": "Earnings unavailable",
    "worker.earnings.w_13.error_message": "Unable to load your earnings. Check your connection.",
    "worker.earnings.w_13.kicker": "THIS WEEK",
    "worker.earnings.w_13.note": "Total + breakdown + payout status.",
    "worker.earnings.w_13.retry": "Try again",
    "worker.earnings.w_13.retry_aria": "Try loading earnings again",
    "worker.earnings.w_13.section.breakdown": "Breakdown",
    "worker.earnings.w_13.section.payout_history": "Payout history",
    "worker.earnings.w_13.title": "Your earnings",
    "worker.end-of-day.w_21_m.kicker": "MAY 2026",
    "worker.end-of-day.w_21_m.note": "Month recap · weekly aggregates.",
    "worker.end-of-day.w_21_m.title": "Your month",
    "worker.end-of-day.w_21_w.kicker": "WEEK 19 · 5–11 MAY",
    "worker.end-of-day.w_21_w.note": "Week recap · earnings, visits, average rating.",
    "worker.end-of-day.w_21_w.title": "Good week.",
    "worker.end-of-day.w_21.kicker": "TUESDAY 5 MAY",
    "worker.end-of-day.w_21.note": "Day recap. Total visits + total earnings + missed visits.",
    "worker.end-of-day.w_21.title": "Good day.",
    "worker.family.grace.cta": "Extra clothes",
    "worker.family.grace.error": "Unable to report right now. Try again.",
    "worker.family.grace.modal.back": "Back",
    "worker.family.grace.modal.cancel": "Cancel",
    "worker.family.grace.modal.close": "Close",
    "worker.family.grace.modal.next": "Next",
    "worker.family.grace.modal.step.age.adulte": "Adult",
    "worker.family.grace.modal.step.age.enfant": "Child",
    "worker.family.grace.modal.step.age.mixte": "Mixed",
    "worker.family.grace.modal.step.age.title": "Who do they seem to belong to?",
    "worker.family.grace.modal.step.count.help": "Approximate number of out-of-contract items found.",
    "worker.family.grace.modal.step.count.title": "How many clothes?",
    "worker.family.grace.modal.step.photo.cta": "Take a photo",
    "worker.family.grace.modal.step.photo.retake": "Retake photo",
    "worker.family.grace.modal.step.photo.skip": "Continue without photo",
    "worker.family.grace.modal.step.photo.title": "Photo of the clothes",
    "worker.family.grace.modal.submit": "Report",
    "worker.family.grace.modal.submitting": "Sending…",
    "worker.family.grace.modal.title": "Report extra clothes",
    "worker.family.grace.permission.denied": "Camera permission required.",
    "worker.family.grace.permission.settings_cta": "Open Settings",
    "worker.family.grace.permission.title": "Camera access denied",
    "worker.family.grace.success.laves": "Clothes washed and reported. The household has been notified.",
    "worker.family.grace.success.refuses": "Clothes refused under the contract. The household has been notified.",
    "worker.family.grace.success.title": "Report recorded",
    "worker.family.roster.age_unit": "yrs",
    "worker.family.roster.error": "Can't load this household right now.",
    "worker.family.roster.head_of_household": "Head of household",
    "worker.family.roster.housemaid_badge": "Staff",
    "worker.family.roster.loading": "Loading household…",
    "worker.family.roster.member_count": "{count} member(s)",
    "worker.family.roster.paid_extra_badge": "Paid seat",
    "worker.family.roster.relationship.autre": "Other",
    "worker.family.roster.relationship.epouse": "Wife",
    "worker.family.roster.relationship.epoux": "Husband",
    "worker.family.roster.relationship.fille": "Daughter",
    "worker.family.roster.relationship.fils": "Son",
    "worker.family.roster.relationship.parent": "Parent",
    "worker.family.roster.relationship.personnel_domestique": "Household staff",
    "worker.family.roster.title": "Household",
    "worker.family.scope.essentiel.checked_count": "{checked} / 9 items checked",
    "worker.family.scope.essentiel.cleared": "Uncheck all",
    "worker.family.scope.essentiel.cleared_confirm": "Uncheck all items?",
    "worker.family.scope.essentiel.cleared_confirm_no": "Cancel",
    "worker.family.scope.essentiel.cleared_confirm_yes": "Uncheck",
    "worker.family.scope.essentiel.excluded.title": "Items outside the plan to leave with the household",
    "worker.family.scope.essentiel.help": "Check off the items you wash. It's a reminder, not a requirement.",
    "worker.family.scope.essentiel.title": "Clothes to wash today",
    "worker.help.faq.app_crash.answer": "Close and reopen the app. Your data is saved. If a visit was in progress, pick up where you left off from the Visits screen.",
    "worker.help.faq.app_crash.question": "The app crashes during a visit — how do I continue?",
    "worker.help.faq.cancellation_policy.answer": "If a subscriber cancels less than 24 hours before, you receive 500 XOF compensation. If you were already on site, you receive your full rate.",
    "worker.help.faq.cancellation_policy.question": "What do I do if a subscriber cancels?",
    "worker.help.faq.device_change.answer": "Download the app on the new phone and sign in with your number. The office validates the change within 24 hours.",
    "worker.help.faq.device_change.question": "I am changing phones — how do I keep my account?",
    "worker.help.faq.payout_delay.answer": "Payouts go out automatically on the 5th of each month. The money arrives on Mixx by Yas or Flooz within minutes. If nothing after 24 hours, contact the office.",
    "worker.help.faq.payout_delay.question": "When do I receive my money?",
    "worker.help.faq.pin_lost.answer": "Contact the office. The office can send you a recovery code by WhatsApp.",
    "worker.help.faq.pin_lost.question": "I forgot my PIN.",
    "worker.help.faq.subscriber_not_home.answer": "Wait 10 minutes, try calling. If still no answer, report 'subscriber absent' in the app. You will be compensated.",
    "worker.help.faq.subscriber_not_home.question": "The subscriber is not home — what do I do?",
    "worker.help.w_22_a.credit": "Designed and built in Lomé.",
    "worker.help.w_22_a.kicker": "↩ HELP",
    "worker.help.w_22_a.legal_link": "Legal notice",
    "worker.help.w_22_a.note": "Sub-modal of W-22. Version, legal, team.",
    "worker.help.w_22_a.privacy_link": "Privacy",
    "worker.help.w_22_a.title": "About",
    "worker.help.w_22_a.version_label": "Version",
    "worker.help.w_22_f.back_link": "Back to help",
    "worker.help.w_22_f.kicker": "↩ HELP · FAQ",
    "worker.help.w_22_f.not_found": "Question not found.",
    "worker.help.w_22_f.note": "Answer to a frequently asked question.",
    "worker.help.w_22_f.title": "How do I cancel a visit?",
    "worker.help.w_22.about_link": "About",
    "worker.help.w_22.call_bureau": "Call the office",
    "worker.help.w_22.kicker": "HELP",
    "worker.help.w_22.note": "Hub help tab. Office numbers + FAQ.",
    "worker.help.w_22.section.faq": "Frequently asked",
    "worker.help.w_22.title": "Help",
    "worker.help.w_x_c.kicker": "↩ HELP · OFFICE MESSAGE",
    "worker.help.w_x_c.note": "Direct conversation with the office · in-app.",
    "worker.help.w_x_c.title": "Office",
    "worker.inbox.w_18.kicker": "NOTIFICATION",
    "worker.inbox.w_18.note": "Cancellation received. Compensation shown if eligible.",
    "worker.inbox.w_18.title": "Visit canceled",
    "worker.inbox.w_20_0.kicker": "NOTIFICATIONS",
    "worker.inbox.w_20_0.note": "Empty inbox · quiet zero state.",
    "worker.inbox.w_20_0.title": "All quiet.",
    "worker.inbox.w_20_d.kicker": "↩ NOTIFICATIONS",
    "worker.inbox.w_20_d.note": "Sub-modal of W-20. Notification detail.",
    "worker.inbox.w_20_d.title": "Visit canceled",
    "worker.inbox.w_20.kicker": "NOTIFICATIONS",
    "worker.inbox.w_20.note": "Central list. Receipts, alerts, office.",
    "worker.inbox.w_20.title": "Notifications",
    "worker.login.cta": "Sign in",
    "worker.login.forgot": "Forgot PIN? Call the office · {phone}",
    "worker.login.greeting": "Hello",
    "worker.login.header": "Sign in",
    "worker.login.help": "The number registered with Washed.",
    "worker.login.phone_label": "Number",
    "worker.login.pin_label": "PIN — 4 digits",
    "worker.login.prompt": "Your number?",
    "worker.nav.gains": "Earnings",
    "worker.nav.planning": "Schedule",
    "worker.nav.profil": "Profile",
    "worker.nav.tournee": "Visits",
    "worker.notifications.bell_aria": "Notifications, {count} unread",
    "worker.notifications.mark_read_cta": "Mark as read",
    "worker.notifications.type.bureau_message": "Office message",
    "worker.notifications.type.payout_settled": "Payout sent",
    "worker.notifications.type.visit_cancelled": "Visit canceled",
    "worker.notifications.w_20_0.kicker": "NOTIFICATIONS",
    "worker.notifications.w_20_0.note": "No unread notifications. The office contacts you here when there is news.",
    "worker.notifications.w_20_0.title": "All quiet.",
    "worker.notifications.w_20_d.back_cta": "Notifications",
    "worker.notifications.w_20_d.error_message": "Can't load this notification. Check your connection.",
    "worker.notifications.w_20_d.error_retry": "Try again",
    "worker.notifications.w_20_d.error_retry_aria": "Try loading the notification again",
    "worker.notifications.w_20_d.loading_aria": "Loading notification…",
    "worker.notifications.w_20.kicker": "NOTIFICATIONS",
    "worker.notifications.w_20.title": "Notifications",
    "worker.offline.banner.failures_link": "View failures ({count})",
    "worker.offline.banner.offline": "Offline — sync pending",
    "worker.offline.banner.syncing": "Syncing · {count} item",
    "worker.onboarding.w_00_a.copy": "The office noted this number when you registered. We will send you a code to confirm.",
    "worker.onboarding.w_00_a.cta": "Get the code",
    "worker.onboarding.w_00_a.field_label": "Phone",
    "worker.onboarding.w_00_a.kicker": "STEP 1 / 8",
    "worker.onboarding.w_00_a.muted": "Number not shared with subscribers. Used by the office only.",
    "worker.onboarding.w_00_a.note": "Number confirmed by the office.",
    "worker.onboarding.w_00_a.phone_placeholder": "90 12 34 56",
    "worker.onboarding.w_00_a.title": "Your number",
    "worker.onboarding.w_00_b.copy": "Six digits sent to {phone}.",
    "worker.onboarding.w_00_b.cta": "Verify",
    "worker.onboarding.w_00_b.error_expired": "Code expired. Start over with a new number.",
    "worker.onboarding.w_00_b.error_generic": "Something went wrong. Try again or call the office.",
    "worker.onboarding.w_00_b.error_invalid_code": "Wrong code. Check the 6 digits.",
    "worker.onboarding.w_00_b.error_network": "No connection. Check the network and try again.",
    "worker.onboarding.w_00_b.field_label": "WhatsApp code",
    "worker.onboarding.w_00_b.kicker": "STEP 2 / 8",
    "worker.onboarding.w_00_b.not_ready_copy": "The office still needs to set up your account. Call {phone} to have them finish your registration.",
    "worker.onboarding.w_00_b.not_ready_copy_whatsapp": "The office still needs to set up your account. Message them on WhatsApp at {phone} to have them finish your registration.",
    "worker.onboarding.w_00_b.not_ready_cta": "Call the office",
    "worker.onboarding.w_00_b.not_ready_title": "Your account is not ready yet",
    "worker.onboarding.w_00_b.note": "Six-digit OTP.",
    "worker.onboarding.w_00_b.title": "The code you received on WhatsApp",
    "worker.onboarding.w_00_c.copy": "The office already entered your first and last name. Check and correct if needed.",
    "worker.onboarding.w_00_c.cta": "Continue",
    "worker.onboarding.w_00_c.field_cni": "National ID number (optional)",
    "worker.onboarding.w_00_c.field_first_name": "First name",
    "worker.onboarding.w_00_c.field_last_name": "Last name",
    "worker.onboarding.w_00_c.kicker": "STEP 3 / 8",
    "worker.onboarding.w_00_c.note": "Pre-filled by the office · to confirm.",
    "worker.onboarding.w_00_c.title": "Your information",
    "worker.onboarding.w_00_d.copy": "The office uses your neighborhood to suggest nearby visits.",
    "worker.onboarding.w_00_d.cta": "Continue",
    "worker.onboarding.w_00_d.field_landmark": "Landmark (optional)",
    "worker.onboarding.w_00_d.field_neighborhood": "Neighborhood",
    "worker.onboarding.w_00_d.field_street": "Street / details",
    "worker.onboarding.w_00_d.kicker": "STEP 4 / 8",
    "worker.onboarding.w_00_d.neighborhood_placeholder": "Choose a neighborhood",
    "worker.onboarding.w_00_d.note": "Where the washer lives — used for routing.",
    "worker.onboarding.w_00_d.title": "Where do you live?",
    "worker.onboarding.w_00_e.copy": "A clear photo of your face. Subscribers see it before each visit — it builds trust.",
    "worker.onboarding.w_00_e.cta_capture": "Take a selfie",
    "worker.onboarding.w_00_e.cta_continue": "Continue",
    "worker.onboarding.w_00_e.cta_retake": "Retake",
    "worker.onboarding.w_00_e.hint": "You can change it later from settings.",
    "worker.onboarding.w_00_e.kicker": "STEP 5 / 8",
    "worker.onboarding.w_00_e.map_consent_label": "Allow this photo to show on the live map for subscribers.",
    "worker.onboarding.w_00_e.note": "Selfie · visible to subscribers (X-18 Worker Profile).",
    "worker.onboarding.w_00_e.placeholder_label": "No photo yet.",
    "worker.onboarding.w_00_e.title": "Your photo",
    "worker.onboarding.w_00_e.uploading": "Uploading…",
    "worker.onboarding.w_00_f.copy": "The office activates your account within 24 h. You will receive a WhatsApp message as soon as your first visits are ready.",
    "worker.onboarding.w_00_f.cta": "Set my PIN",
    "worker.onboarding.w_00_f.kicker": "WELCOME",
    "worker.onboarding.w_00_f.note": "Account waiting for office validation.",
    "worker.onboarding.w_00_f.status_badge": "Account created",
    "worker.onboarding.w_00_f.title": "Welcome to Washed",
    "worker.onboarding.w_00_g.copy": "We need it to confirm you are at the subscriber's address before starting the visit. Without it, check-in cannot happen.",
    "worker.onboarding.w_00_g.cta_activate": "Allow location",
    "worker.onboarding.w_00_g.cta_skip": "Continue without",
    "worker.onboarding.w_00_g.denied_copy": "Without location, check-in at the subscriber's will need to be done manually by the office. You can enable the permission later from your phone's settings.",
    "worker.onboarding.w_00_g.kicker": "STEP 6 / 8",
    "worker.onboarding.w_00_g.note": "iOS/Android permission · geofence depends on it.",
    "worker.onboarding.w_00_g.title": "Enable location",
    "worker.onboarding.w_00_h.copy": "The office alerts you by notification when a new visit is proposed or a subscriber cancels. Without notifications, you risk missing an assignment.",
    "worker.onboarding.w_00_h.cta_activate": "Allow notifications",
    "worker.onboarding.w_00_h.cta_skip": "Continue without",
    "worker.onboarding.w_00_h.denied_copy": "Without notifications, the office will reach you by WhatsApp for assignments and cancellations. You can enable the permission later from your phone's settings.",
    "worker.onboarding.w_00_h.kicker": "STEP 7 / 8",
    "worker.onboarding.w_00_h.note": "Push for assignments, cancellations, emergencies.",
    "worker.onboarding.w_00_h.title": "Receive notifications",
    "worker.onboarding.w_00_i.copy": "Each visit requires two photos — before washing and after. This protects both the subscriber and you in case of any doubt.",
    "worker.onboarding.w_00_i.cta_activate": "Allow camera",
    "worker.onboarding.w_00_i.cta_skip": "Continue without",
    "worker.onboarding.w_00_i.denied_copy": "Without camera access, you cannot close a visit on your own — the office will need to validate manually. You can enable the permission later from your phone's settings.",
    "worker.onboarding.w_00_i.kicker": "STEP 8 / 8",
    "worker.onboarding.w_00_i.note": "Before/after photos required to close a visit.",
    "worker.onboarding.w_00_i.title": "Enable camera",
    "worker.onboarding.w_01_o1.already_set_error": "A PIN is already set. Call the office to reset it.",
    "worker.onboarding.w_01_o1.copy_confirm": "Re-enter the same PIN to confirm.",
    "worker.onboarding.w_01_o1.copy_enter": "4 digits that are easy to remember. The office cannot see it.",
    "worker.onboarding.w_01_o1.cta": "Continue",
    "worker.onboarding.w_01_o1.invalid_format_error": "Invalid format. PIN must be 4 digits.",
    "worker.onboarding.w_01_o1.kicker": "SETUP · 1 / 3",
    "worker.onboarding.w_01_o1.mismatch_error": "PINs do not match. Try again.",
    "worker.onboarding.w_01_o1.note": "Onboarding. PIN chosen at registration.",
    "worker.onboarding.w_01_o1.security_note": "You can reset it by calling the office.",
    "worker.onboarding.w_01_o1.title": "Choose a PIN",
    "worker.onboarding.w_01_o2.copy": "Choose where Washed sends your payments each Friday.",
    "worker.onboarding.w_01_o2.cta": "Continue",
    "worker.onboarding.w_01_o2.field_account": "Mobile Money number",
    "worker.onboarding.w_01_o2.field_provider": "Provider",
    "worker.onboarding.w_01_o2.invalid_account_error": "Invalid number. Check and try again.",
    "worker.onboarding.w_01_o2.invalid_provider_error": "Choose a valid Mobile Money provider.",
    "worker.onboarding.w_01_o2.kicker": "SETUP · 2 / 3",
    "worker.onboarding.w_01_o2.note": "Onboarding. Payout number.",
    "worker.onboarding.w_01_o2.notice": "The number must be in the name registered with Washed.",
    "worker.onboarding.w_01_o2.option_flooz": "Flooz",
    "worker.onboarding.w_01_o2.option_mixx": "Mixx by Yas",
    "worker.onboarding.w_01_o2.title": "Receive your earnings",
    "worker.onboarding.w_01_o3.copy": "Three essential things before your first visits.",
    "worker.onboarding.w_01_o3.cta_next": "Next",
    "worker.onboarding.w_01_o3.cta_start": "Get started",
    "worker.onboarding.w_01_o3.error_generic": "Unable to complete. Try again or contact the office.",
    "worker.onboarding.w_01_o3.error_prerequisites": "Your account is not ready yet. Contact the office at {phone}.",
    "worker.onboarding.w_01_o3.kicker": "SETUP · 3 / 3",
    "worker.onboarding.w_01_o3.note": "Onboarding. 3-step spotlight.",
    "worker.onboarding.w_01_o3.tip_1_body": "Your visits for the day show up as soon as you open the app. All your visits, in order.",
    "worker.onboarding.w_01_o3.tip_1_title": "Your visits",
    "worker.onboarding.w_01_o3.tip_2_body": "Your earnings are paid every Friday to your Mobile Money account. Track the total in the Earnings tab.",
    "worker.onboarding.w_01_o3.tip_2_title": "Your earnings",
    "worker.onboarding.w_01_o3.tip_3_body": "If you are in danger during a visit, the SOS button calls the office directly. Available on every visit.",
    "worker.onboarding.w_01_o3.tip_3_title": "SOS",
    "worker.onboarding.w_01_o3.tip_progress": "{current} / {total}",
    "worker.onboarding.w_01_o3.title": "How it works",
    "worker.planning.empty_day": "No visits",
    "worker.planning.time_window.afternoon": "Afternoon",
    "worker.planning.time_window.morning": "Morning",
    "worker.planning.visits_count": "{count} visit",
    "worker.planning.w_14_m.cancel": "Cancel",
    "worker.planning.w_14_m.confirm": "Confirm",
    "worker.planning.w_14_m.end_date_error": "End date must be after the start date",
    "worker.planning.w_14_m.end_date_label": "End date",
    "worker.planning.w_14_m.kicker": "↩ SCHEDULE",
    "worker.planning.w_14_m.note": "Sub-modal of W-14. Date range + reason.",
    "worker.planning.w_14_m.queued_toast": "Sending deferred",
    "worker.planning.w_14_m.reason_label": "Reason",
    "worker.planning.w_14_m.reason_max_error": "Reason must not exceed 500 characters",
    "worker.planning.w_14_m.reason_min_error": "Reason must be at least 5 characters",
    "worker.planning.w_14_m.start_date_label": "Start date",
    "worker.planning.w_14_m.title": "Request time off",
    "worker.planning.w_14.body": "Your week confirmed by the office, with every scheduled visit.",
    "worker.planning.w_14.empty_body": "Try again when your network is stable.",
    "worker.planning.w_14.empty_title": "Schedule unavailable",
    "worker.planning.w_14.kicker": "WEEK 19",
    "worker.planning.w_14.leave_cta": "Request time off",
    "worker.planning.w_14.note": "Week view. Time-off request via modal.",
    "worker.planning.w_14.title": "Schedule",
    "worker.preferences.family_routes.confirm.body": "Family routes earn more on average than individual routes.",
    "worker.preferences.family_routes.confirm.cancel": "Cancel",
    "worker.preferences.family_routes.confirm.refuse": "Decline Family routes",
    "worker.preferences.family_routes.confirm.title": "Are you sure?",
    "worker.preferences.family_routes.help": "Family visits earn more but take longer.",
    "worker.preferences.family_routes.section_title": "Family routes",
    "worker.preferences.family_routes.toggle_label": "Accept Family visits",
    "worker.profile.aide_link": "Help",
    "worker.profile.payout.unset": "To set up",
    "worker.profile.settings_link": "Settings",
    "worker.profile.settings_placeholder.coming_soon": "Coming soon",
    "worker.profile.sos_chip": "SOS",
    "worker.profile.w_15_0.kicker": "PROFILE",
    "worker.profile.w_15_0.note": "New washer · no regular households yet.",
    "worker.profile.w_15_0.title": "Your profile",
    "worker.profile.w_15_d_r.kicker": "↩ MRS ADJOA K.",
    "worker.profile.w_15_d_r.no_reviews": "No reviews yet",
    "worker.profile.w_15_d_r.note": "Sub-modal of W-15.D. Subscriber comments.",
    "worker.profile.w_15_d_r.title": "Ratings & reviews",
    "worker.profile.w_15_d.kicker": "↩ MY HOUSEHOLDS",
    "worker.profile.w_15_d.note": "Sub-modal of W-15. History of a regular household.",
    "worker.profile.w_15_d.title": "Mrs Adjoa K.",
    "worker.profile.w_15_s_a.field_landmark": "Landmark (optional)",
    "worker.profile.w_15_s_a.field_neighborhood": "Neighborhood",
    "worker.profile.w_15_s_a.field_street": "Street / avenue",
    "worker.profile.w_15_s_a.kicker": "SETTINGS",
    "worker.profile.w_15_s_a.neighborhood_placeholder": "Choose a neighborhood",
    "worker.profile.w_15_s_a.note": "Washer's personal address.",
    "worker.profile.w_15_s_a.pending_banner": "Pending office validation · submitted on {date}",
    "worker.profile.w_15_s_a.save": "Save",
    "worker.profile.w_15_s_a.saving": "Saving…",
    "worker.profile.w_15_s_a.title": "Your address",
    "worker.profile.w_15_s_appearance.kicker": "PREFERENCES",
    "worker.profile.w_15_s_appearance.option.dark": "Dark",
    "worker.profile.w_15_s_appearance.option.dark_desc": "Night mode",
    "worker.profile.w_15_s_appearance.option.light": "Light",
    "worker.profile.w_15_s_appearance.option.light_desc": "Day mode",
    "worker.profile.w_15_s_appearance.option.system": "System",
    "worker.profile.w_15_s_appearance.option.system_desc": "Follows your phone",
    "worker.profile.w_15_s_appearance.title": "Appearance",
    "worker.profile.w_15_s_i.field_date_of_birth": "Date of birth",
    "worker.profile.w_15_s_i.field_first_name": "Legal first name",
    "worker.profile.w_15_s_i.field_last_name": "Legal last name",
    "worker.profile.w_15_s_i.kicker": "SETTINGS",
    "worker.profile.w_15_s_i.note": "Editable identity · office validation required.",
    "worker.profile.w_15_s_i.pending_banner": "Pending office validation · submitted on {date}",
    "worker.profile.w_15_s_i.save": "Save",
    "worker.profile.w_15_s_i.saving": "Saving…",
    "worker.profile.w_15_s_i.title": "Your information",
    "worker.profile.w_15_s_l.kicker": "SETTINGS",
    "worker.profile.w_15_s_l.note": "FR/EN picker.",
    "worker.profile.w_15_s_l.option.en": "English",
    "worker.profile.w_15_s_l.option.en.body": "Interface and messages in English.",
    "worker.profile.w_15_s_l.option.fr": "Français",
    "worker.profile.w_15_s_l.option.fr.body": "Current language",
    "worker.profile.w_15_s_l.title": "App language",
    "worker.profile.w_15_s_m.kicker": "SETTINGS",
    "worker.profile.w_15_s_m.note": "Payout number.",
    "worker.profile.w_15_s_m.phone_error": "Number must be exactly 8 digits.",
    "worker.profile.w_15_s_m.phone_label": "Account number (8 digits)",
    "worker.profile.w_15_s_m.phone_placeholder": "e.g. 90123456",
    "worker.profile.w_15_s_m.provider_label": "Mobile Money provider",
    "worker.profile.w_15_s_m.queued_toast": "Change saved · will send on reconnection.",
    "worker.profile.w_15_s_m.save": "Save",
    "worker.profile.w_15_s_m.saving": "Saving…",
    "worker.profile.w_15_s_m.title": "Mobile Money",
    "worker.profile.w_15_s_n.kicker": "SETTINGS",
    "worker.profile.w_15_s_n.note": "Toggles by category.",
    "worker.profile.w_15_s_n.row.push_assignments": "Visit reminders",
    "worker.profile.w_15_s_n.row.push_cancellations": "Cancellations",
    "worker.profile.w_15_s_n.row.push_payouts": "Payouts",
    "worker.profile.w_15_s_n.row.push_urgent": "Office messages",
    "worker.profile.w_15_s_n.row.sms_fallback": "Tips and news",
    "worker.profile.w_15_s_n.title": "Notifications",
    "worker.profile.w_15_s_n.toggle_error": "Change not saved. Try again.",
    "worker.profile.w_15_s_o.kicker": "SETTINGS",
    "worker.profile.w_15_s_o.note": "Network behavior picker.",
    "worker.profile.w_15_s_o.option.auto": "Automatic",
    "worker.profile.w_15_s_o.option.auto.body": "Syncs as soon as you are connected",
    "worker.profile.w_15_s_o.option.manual": "Manual",
    "worker.profile.w_15_s_o.option.manual.body": "Sync manually whenever you want",
    "worker.profile.w_15_s_o.option.wifi_only": "Wi-Fi only",
    "worker.profile.w_15_s_o.option.wifi_only.body": "Saves mobile data",
    "worker.profile.w_15_s_o.title": "Offline mode",
    "worker.profile.w_15_s_p.cta_capture": "Take a photo",
    "worker.profile.w_15_s_p.cta_retake": "Retake photo",
    "worker.profile.w_15_s_p.deferred_toast": "Sending deferred",
    "worker.profile.w_15_s_p.error_capture_failed": "Couldn't take a photo. Try again.",
    "worker.profile.w_15_s_p.kicker": "SETTINGS",
    "worker.profile.w_15_s_p.note": "Sub-modal of W-15.S. Repeats W-00.E flow.",
    "worker.profile.w_15_s_p.saving": "Saving…",
    "worker.profile.w_15_s_p.selfie_alt": "Your current profile photo",
    "worker.profile.w_15_s_p.success_toast": "Photo updated",
    "worker.profile.w_15_s_p.title": "Edit your photo",
    "worker.profile.w_15_s_p.uploading": "Uploading…",
    "worker.profile.w_15_s_pin.confirm_mismatch": "PINs do not match.",
    "worker.profile.w_15_s_pin.current_pin_error": "Current PIN is incorrect.",
    "worker.profile.w_15_s_pin.kicker": "SETTINGS",
    "worker.profile.w_15_s_pin.network_error": "Connect to change your PIN.",
    "worker.profile.w_15_s_pin.next_cta": "Continue",
    "worker.profile.w_15_s_pin.note": "Voluntary change (vs reset W-02.R).",
    "worker.profile.w_15_s_pin.step1_label": "Current PIN",
    "worker.profile.w_15_s_pin.step2_label": "New PIN",
    "worker.profile.w_15_s_pin.step3_label": "Confirm new PIN",
    "worker.profile.w_15_s_pin.submit_cta": "Change my PIN",
    "worker.profile.w_15_s_pin.title": "New PIN",
    "worker.profile.w_15_s_x.body": "Are you sure you want to sign out? You will need to sign in again with your number and PIN.",
    "worker.profile.w_15_s_x.cta_cancel": "Cancel",
    "worker.profile.w_15_s_x.cta_confirm": "Sign out",
    "worker.profile.w_15_s_x.kicker": "SETTINGS",
    "worker.profile.w_15_s_x.logging_out": "Signing out…",
    "worker.profile.w_15_s_x.note": "Confirmation. Clears local session.",
    "worker.profile.w_15_s_x.title": "Sign out?",
    "worker.profile.w_15_s.kicker": "↩ PROFILE",
    "worker.profile.w_15_s.note": "Sub-modal of W-15. Edit all profile details.",
    "worker.profile.w_15_s.row.address": "Edit my address",
    "worker.profile.w_15_s.row.appearance": "Appearance",
    "worker.profile.w_15_s.row.identity": "Edit my details",
    "worker.profile.w_15_s.row.language": "Language",
    "worker.profile.w_15_s.row.logout": "Sign out",
    "worker.profile.w_15_s.row.notifications": "Notifications",
    "worker.profile.w_15_s.row.offline_mode": "Offline mode",
    "worker.profile.w_15_s.row.payout": "Mobile Money",
    "worker.profile.w_15_s.row.photo": "Edit my photo",
    "worker.profile.w_15_s.row.pin": "Change my PIN",
    "worker.profile.w_15_s.section.account": "ACCOUNT",
    "worker.profile.w_15_s.section.payment": "PAYMENT",
    "worker.profile.w_15_s.section.preferences": "PREFERENCES",
    "worker.profile.w_15_s.section.profile": "PROFILE",
    "worker.profile.w_15_s.section.security": "SECURITY",
    "worker.profile.w_15_s.title": "Settings",
    "worker.profile.w_15.body": "Your neighborhoods, your capacity, and your active payment account.",
    "worker.profile.w_15.field.capacity": "Max capacity",
    "worker.profile.w_15.field.name": "Name",
    "worker.profile.w_15.field.neighborhoods": "Neighborhoods",
    "worker.profile.w_15.field.payout": "Payment",
    "worker.profile.w_15.field.status": "Status",
    "worker.profile.w_15.kicker": "PROFILE",
    "worker.profile.w_15.note": "Hub profile tab. Identity + address + payout + links.",
    "worker.profile.w_15.payout_value": "%1$s · **** %2$s",
    "worker.profile.w_15.status.active": "Active",
    "worker.profile.w_15.status.blocked": "Blocked",
    "worker.profile.w_15.status.onboarding": "In review",
    "worker.profile.w_15.status.suspended": "Suspended",
    "worker.profile.w_15.title": "Your profile",
    "worker.recap.average_rating": "{rating} ★ average",
    "worker.recap.missed_visits": "{count} missed",
    "worker.recap.total_earnings_line": "{amount} earned",
    "worker.recap.visit_status_cancelled": "cancelled",
    "worker.recap.visit_status_completed": "completed",
    "worker.recap.visit_status_no_show": "no-show",
    "worker.recap.visits_completed": "{count} visit{plural} completed",
    "worker.safety.w_16.kicker": "↩ VISITS",
    "worker.safety.w_16.note": "Full red button. 6 reasons. Direct office call.",
    "worker.safety.w_16.title": "Emergency",
    "worker.safety.w_19_s.back_cta": "Back to profile",
    "worker.safety.w_19_s.kicker": "SENT",
    "worker.safety.w_19_s.note": "Confirmation after W-19 submit.",
    "worker.safety.w_19_s.title": "Received",
    "worker.safety.w_19.add_photo_cta": "Add a photo",
    "worker.safety.w_19.body_label": "Describe the issue",
    "worker.safety.w_19.body_max_error": "Maximum 2,000 characters.",
    "worker.safety.w_19.body_min_error": "Minimum 10 characters.",
    "worker.safety.w_19.body_placeholder": "Explain what happened…",
    "worker.safety.w_19.cancel_cta": "Cancel",
    "worker.safety.w_19.kicker": "↩ VISIT",
    "worker.safety.w_19.note": "Free-form. Optional photo.",
    "worker.safety.w_19.offline_hint": "Sending deferred",
    "worker.safety.w_19.remove_photo_cta": "Remove",
    "worker.safety.w_19.submit_cta": "Send",
    "worker.safety.w_19.title": "Report a concern",
    "worker.sos.call_in_progress": "Calling…",
    "worker.sos.callback": "Choose what is happening. The alert goes to the office, with your position if available.",
    "worker.sos.cancel": "Cancel",
    "worker.sos.confirm_cta": "Call the office",
    "worker.sos.dismiss": "Done",
    "worker.sos.sending_title": "Sending the alert…",
    "worker.sos.sent_title": "Alert sent to the office",
    "worker.sos.sent_body": "The office will call you back. If you can, call them now.",
    "worker.sos.queued_title": "Alert saved",
    "worker.sos.queued_body": "No network: it will be sent as soon as possible. Call the office now if you can.",
    "worker.sos.failed_title": "The alert was not sent",
    "worker.sos.failed_body": "Call the office now.",
    "worker.sos.safety": "Get to safety. If you are in danger now, call the police: 161 from a mobile (117 from a landline), or the fire service: 118.",
    "worker.sos.call_police": "Call the police · 161",
    "worker.sos.no_location": "No GPS position: tell the office where you are.",
    "worker.sos.option.client_issue": "Issue with the subscriber",
    "worker.sos.option.client_issue_detail": "Refusal, aggression, misunderstanding",
    "worker.sos.option.danger": "I am in danger",
    "worker.sos.option.danger_detail": "Immediate alert + GPS shared",
    "worker.sos.option.medical": "Accident / injury",
    "worker.sos.option.medical_detail": "Medical · transport",
    "worker.sos.panic": "SOS",
    "worker.sos.title": "What is happening?",
    "worker.splash.sync": "Syncing…",
    "worker.splash.tagline": "The washer app",
    "worker.system-states.w_17.kicker": "CONNECTION",
    "worker.system-states.w_17.note": "Degraded state. Pending sync visible everywhere.",
    "worker.system-states.w_17.title": "No network",
    "worker.system-states.w_x_nf.action_kind.advance.request": "Advance request",
    "worker.system-states.w_x_nf.action_kind.concern.report": "Concern report",
    "worker.system-states.w_x_nf.action_kind.leave.request": "Leave request",
    "worker.system-states.w_x_nf.action_kind.notification.mark_read": "Mark as read",
    "worker.system-states.w_x_nf.action_kind.settings.notification_preferences.update": "Notification settings update",
    "worker.system-states.w_x_nf.action_kind.settings.payout_destination.update": "Mobile Money update",
    "worker.system-states.w_x_nf.action_kind.settings.personal_details.update": "Profile update",
    "worker.system-states.w_x_nf.action_kind.settings.selfie.update": "Photo update",
    "worker.system-states.w_x_nf.action_kind.sos.event": "SOS alert",
    "worker.system-states.w_x_nf.action_kind.unknown": "Pending action",
    "worker.system-states.w_x_nf.action_kind.visit.after_photo": "After photo",
    "worker.system-states.w_x_nf.action_kind.visit.before_photo": "Before photo",
    "worker.system-states.w_x_nf.action_kind.visit.check_in": "Check-in",
    "worker.system-states.w_x_nf.action_kind.visit.check_out": "Check-out",
    "worker.system-states.w_x_nf.action_kind.visit.issue": "Visit issue",
    "worker.system-states.w_x_nf.attempts_count": "{count} attempts",
    "worker.system-states.w_x_nf.delete_confirm_body": "The action will be lost.",
    "worker.system-states.w_x_nf.delete_confirm_no": "Cancel",
    "worker.system-states.w_x_nf.delete_confirm_title": "Delete permanently?",
    "worker.system-states.w_x_nf.delete_confirm_yes": "Yes, delete",
    "worker.system-states.w_x_nf.delete_cta": "Delete",
    "worker.system-states.w_x_nf.empty": "No failures — everything's in sync.",
    "worker.system-states.w_x_nf.kicker": "↩ CHECK-OUT",
    "worker.system-states.w_x_nf.note": "Action failed offline · saved for sync.",
    "worker.system-states.w_x_nf.retry_cta": "Retry",
    "worker.system-states.w_x_nf.screen_kicker": "SYNC FAILURES",
    "worker.system-states.w_x_nf.screen_title": "Failed actions",
    "worker.system-states.w_x_nf.title": "Sending pending",
    "worker.system-states.w_x_r.kicker": "PROPOSED HOUSEHOLD",
    "worker.system-states.w_x_r.note": "Algorithmic recommendation · 1 proposed visit.",
    "worker.system-states.w_x_r.title": "Mrs Akouwa, near you",
    "worker.system-states.w_x_s.body": "Your account is temporarily suspended by the office. You can't start new visits during the suspension.",
    "worker.system-states.w_x_s.contact_bureau_cta": "Call the office",
    "worker.system-states.w_x_s.expires_on_label": "Lifted on",
    "worker.system-states.w_x_s.kicker": "ACCOUNT SUSPENDED",
    "worker.system-states.w_x_s.note": "Full-page state · access blocked.",
    "worker.system-states.w_x_s.reason_default": "Discuss with the office",
    "worker.system-states.w_x_s.reason_label": "Reason",
    "worker.system-states.w_x_s.sign_out_cta": "Sign out",
    "worker.system-states.w_x_s.suspended_on_label": "Suspended on",
    "worker.system-states.w_x_s.title": "Access blocked",
    "worker.system-states.w_x_t.kicker": "TIP RECEIVED",
    "worker.system-states.w_x_t.note": "Optional tip from a subscriber · gratitude state.",
    "worker.system-states.w_x_t.title": "Mrs Adjoa thanks you",
    "worker.system-states.w_x_u.body": "An app update is required to continue. It takes less than a minute.",
    "worker.system-states.w_x_u.current_version_label": "Your version",
    "worker.system-states.w_x_u.kicker": "UPDATE",
    "worker.system-states.w_x_u.note": "Version too old · forced update.",
    "worker.system-states.w_x_u.required_version_label": "Required version",
    "worker.system-states.w_x_u.title": "New version",
    "worker.system-states.w_x_u.update_cta": "Update",
    "worker.toast.address.success": "Address saved",
    "worker.toast.checkout.error": "Couldn't end the visit",
    "worker.toast.checkout.success": "Visit completed",
    "worker.toast.identity.success": "Identity saved",
    "worker.toast.issue.error": "Couldn't send",
    "worker.toast.issue.success": "Issue reported",
    "worker.toast.photo_after.success": "After photo sent",
    "worker.toast.photo_before.success": "Before photo sent",
    "worker.toast.pin.success": "PIN changed",
    "worker.today.plan.cta": "Start the day",
    "worker.today.plan.greeting": "Good morning {name}. {count} visits today.",
    "worker.today.plan.map_label": "Map of today's visits",
    "worker.today.plan.stats.km": "km total",
    "worker.today.plan.stats.visits": "visits",
    "worker.today.plan.stats.xof": "XOF estimated",
    "worker.today.session.cta": "Check in at {name}",
    "worker.today.session.cta_hint": "Swipe on arrival to start the visit",
    "worker.today.session.distance_label": "distance",
    "worker.today.session.eta_label": "arrival",
    "worker.today.session.eyebrow": "Visit {current} of {total} · to",
    "worker.today.session.window_label": "window",
    "worker.today.w_03_0.kicker": "THURSDAY 7 MAY",
    "worker.today.w_03_0.note": "No visit today · rest state.",
    "worker.today.w_03_0.title": "Rest day.",
    "worker.today.w_03_session.kicker": "Visit 2 of 4 · to",
    "worker.today.w_03_session.title": "On the way",
    "worker.today.w_03.cta_start": "Start",
    "worker.today.w_03.error_body": "Check your connection. Your route will reload automatically.",
    "worker.today.w_03.error_retry": "Try again",
    "worker.today.w_03.error_title": "Route unavailable.",
    "worker.today.w_03.kicker": "TUESDAY 5 MAY",
    "worker.today.w_03.loading": "Loading…",
    "worker.today.w_03.note": "Default hub. Chronological order. 1st = active state.",
    "worker.today.w_03.status_completed": "Completed",
    "worker.today.w_03.status_en_route": "On the way",
    "worker.today.w_03.status_in_progress": "In progress",
    "worker.today.w_03.status_no_show": "No-show",
    "worker.today.w_03.status_scheduled": "Upcoming",
    "worker.today.w_03.subscriber_unknown": "Subscriber",
    "worker.today.w_03.summary_count": "{count} visit{plural}",
    "worker.today.w_03.summary_window": "{first} → {last}",
    "worker.today.w_03.title": "Hello Akouvi.",
    "worker.tour.day_label": "{weekday} {day} {month}",
    "worker.tour.detail.back": "Visits · visit {index} / {count}",
    "worker.tour.detail.call_office": "Call office",
    "worker.tour.detail.client_note": "\"The gate is open on Tuesday mornings, come straight in.\"",
    "worker.tour.detail.cta_start": "Start route",
    "worker.tour.detail.first_visit": "First visit",
    "worker.tour.detail.itinerary": "Itinerary",
    "worker.tour.detail.note_label": "Subscriber note",
    "worker.tour.detail.tenure": "Month {months}",
    "worker.tour.detail.tier_label": "Rate T{n}",
    "worker.tour.detail.when_label": "When",
    "worker.tour.detail.where_label": "Where",
    "worker.tour.empty.body": "The office will let you know as soon as a subscriber confirms.",
    "worker.tour.empty.title": "No visits today",
    "worker.tour.greeting": "Hello {name}",
    "worker.tour.next_label": "Next",
    "worker.tour.summary.earn_label": "To earn",
    "worker.tour.summary.visits": "{count} visits",
    "worker.visit-lifecycle.w_04_p.kicker": "NEW VISIT",
    "worker.visit-lifecycle.w_04_p.note": "Blocking modal. Accept/decline a visit.",
    "worker.visit-lifecycle.w_04_p.title": "Mrs Komi K.",
    "worker.visit-lifecycle.w_04_pr.kicker": "↩ ASSIGNMENT",
    "worker.visit-lifecycle.w_04_pr.note": "Sub-modal of W-04.P. List of short reasons.",
    "worker.visit-lifecycle.w_04_pr.title": "Why decline?",
    "worker.visit-lifecycle.w_04.kicker": "↩ VISITS · 1 / 5",
    "worker.visit-lifecycle.w_04.note": "Before departure. Subscriber notes visible.",
    "worker.visit-lifecycle.w_04.title": "Mrs Adjoa K.",
    "worker.visit-lifecycle.w_05.kicker": "↩ MRS ADJOA K.",
    "worker.visit-lifecycle.w_05.note": "ETA + remaining distance. Continuous GPS.",
    "worker.visit-lifecycle.w_05.title": "On the way",
    "worker.visit-lifecycle.w_06.kicker": "↩ MRS ADJOA K.",
    "worker.visit-lifecycle.w_06.note": "GPS within 50m → CTA activates.",
    "worker.visit-lifecycle.w_06.title": "Are you there?",
    "worker.visit-lifecycle.w_07.kicker": "VISIT 1 / 5",
    "worker.visit-lifecycle.w_07.note": "Presence confirmation. Before photo.",
    "worker.visit-lifecycle.w_07.title": "Check-in",
    "worker.visit-lifecycle.w_08_o.kicker": "IN PROGRESS · OVERTIME",
    "worker.visit-lifecycle.w_08_o.note": "Timer past target · attention state.",
    "worker.visit-lifecycle.w_08_o.title": "Washing",
    "worker.visit-lifecycle.w_08.kicker": "IN PROGRESS",
    "worker.visit-lifecycle.w_08.note": "Counting timer. Phase = contextual label.",
    "worker.visit-lifecycle.w_08.title": "Washing",
    "worker.visit-lifecycle.w_09.kicker": "↩ WASHING",
    "worker.visit-lifecycle.w_09.note": "End capture before check-out.",
    "worker.visit-lifecycle.w_09.title": "After photo",
    "worker.visit-lifecycle.w_10.kicker": "VISIT 1 / 5",
    "worker.visit-lifecycle.w_10.note": "End confirmation. GPS + after photo valid.",
    "worker.visit-lifecycle.w_10.title": "Check-out",
    "worker.visit-lifecycle.w_11.kicker": "VISIT 1 / 5",
    "worker.visit-lifecycle.w_11.note": "Recap + transition to next visit.",
    "worker.visit-lifecycle.w_11.title": "Well done.",
    "worker.visit-lifecycle.w_12.kicker": "ON PAUSE",
    "worker.visit-lifecycle.w_12.note": "Sub-modal of W-08. Timer in yellow.",
    "worker.visit-lifecycle.w_12.title": "Break",
    "worker.visit.checkout.body": "Choose what best describes the visit.",
    "worker.visit.checkout.cta_send": "Complete visit",
    "worker.visit.checkout.kicker": "CHECK-OUT",
    "worker.visit.checkout.mismatch": "More people than registered",
    "worker.visit.checkout.no_surcharge_hint": "No surcharge is billed here. The office confirms with the customer.",
    "worker.visit.checkout.option_good": "All good",
    "worker.visit.checkout.option_major": "Major issue",
    "worker.visit.checkout.option_minor": "Minor issue",
    "worker.visit.checkout.resolution_remainder": "Remaining laundry left",
    "worker.visit.checkout.third_party": "Laundry from another home",
    "worker.visit.checkout.commercial_use": "Laundry from a business (hotel, restaurant…)",
    "worker.visit.checkout.title": "Did everything go well?",
    "worker.visit.checkout.volume_exceptional": "Much more laundry than usual",
    "worker.visit.checkout.volume_normal": "Usual volume",
    "worker.visit.enroute.cta_arrived": "I am here",
    "worker.visit.enroute.cta_report_problem": "Wrong address?",
    "worker.visit.enroute.distance_far": "{meters} m to go. Keep heading to the subscriber.",
    "worker.visit.enroute.distance_near": "You are at the address. Tap \"I am here\" to confirm.",
    "worker.visit.enroute.label": "EN ROUTE · {time} — {name}",
    "worker.visit.enroute.signal_lost": "Signal lost · last known position",
    "worker.visit.geofence.body": "GPS confirmed within {meters} m. You can start the visit.",
    "worker.visit.geofence.body_far": "GPS estimates you are {meters} m away. Confirm anyway?",
    "worker.visit.geofence.cta_anyway": "Confirm anyway",
    "worker.visit.geofence.cta_check_in": "Confirm my arrival",
    "worker.visit.geofence.error_body": "Check your connection. The visit will reload automatically.",
    "worker.visit.geofence.error_retry": "Try again",
    "worker.visit.geofence.error_title": "Visit unavailable.",
    "worker.visit.geofence.kicker": "ARRIVAL",
    "worker.visit.geofence.loading": "Checking GPS…",
    "worker.visit.geofence.title": "You have arrived",
    "worker.visit.geofence.wrong_place": "Wrong place? Report",
    "worker.visit.issue.category_cancelled_on_arrival": "Canceled on arrival",
    "worker.visit.issue.category_no_subscriber": "Subscriber absent",
    "worker.visit.issue.category_other": "Other",
    "worker.visit.issue.category_unsafe": "Unsafe situation",
    "worker.visit.issue.category_wrong_address": "Wrong address",
    "worker.visit.issue.cta_cancel": "Back",
    "worker.visit.issue.cta_send": "Send report",
    "worker.visit.issue.error_send": "Unable to send. Please try again.",
    "worker.visit.issue.kicker": "REPORT",
    "worker.visit.issue.notes_label": "Details (optional)",
    "worker.visit.issue.notes_placeholder": "Describe the situation in a few words…",
    "worker.visit.issue.title": "What is wrong?",
    "worker.visit.next_visit.all_done_body": "Well done. Rest up and see you tomorrow!",
    "worker.visit.next_visit.all_done_title": "Visits done",
    "worker.visit.next_visit.cta_continue": "Prepare next visit",
    "worker.visit.next_visit.cta_home": "Back to home",
    "worker.visit.next_visit.error_body": "Check your connection. The list will reload automatically.",
    "worker.visit.next_visit.error_retry": "Try again",
    "worker.visit.next_visit.error_title": "Next visit unavailable.",
    "worker.visit.next_visit.kicker": "UP NEXT",
    "worker.visit.next_visit.title": "Next subscriber",
    "worker.visit.photo_after.body": "Take a photo of the clean laundry, folded and ready for the subscriber.",
    "worker.visit.photo_after.cta_capture": "Take photo",
    "worker.visit.photo_after.cta_confirm": "Confirm and send",
    "worker.visit.photo_after.cta_retake": "Retake",
    "worker.visit.photo_after.error_capture": "Camera unavailable. Please try again.",
    "worker.visit.photo_after.kicker": "AFTER PHOTO",
    "worker.visit.photo_after.title": "After photo of the laundry",
    "worker.visit.photo_before.body": "Take a photo of the dirty laundry basket, placed next to the basin.",
    "worker.visit.photo_before.cta_capture": "Take photo",
    "worker.visit.photo_before.cta_confirm": "Confirm and send",
    "worker.visit.photo_before.cta_retake": "Retake",
    "worker.visit.photo_before.error_capture": "Camera unavailable. Please try again.",
    "worker.visit.photo_before.kicker": "BEFORE PHOTO",
    "worker.visit.photo_before.title": "Before photo of the laundry",
    "worker.visit.recap.completed": "VISIT {n} / {total} DONE",
    "worker.visit.recap.credited": "added to your balance",
    "worker.visit.recap.cta_next": "See next visit",
    "worker.visit.recap.earn": "+ {amount} XOF",
    "worker.visit.recap.kicker": "RECAP",
    "worker.visit.w_04_p.cta_continue": "Continue",
    "worker.visit.w_04_p.item_bag": "Carry bag",
    "worker.visit.w_04_p.item_phone": "Charged phone",
    "worker.visit.w_04_p.item_supplies": "Soap and supplies",
    "worker.visit.w_04_p.kicker": "CHECKLIST",
    "worker.visit.w_04_p.title": "Before you leave",
    "worker.visit.w_04_pr.body": "Tap start as soon as you are on your way to the subscriber.",
    "worker.visit.w_04_pr.cta_start": "Start visits",
    "worker.visit.w_04_pr.kicker": "READY TO GO",
    "worker.visit.w_04_pr.title": "Safe travels!",
    "worker.visit.w_04.address_label": "Address",
    "worker.visit.w_04.cta_prepare": "Prepare my visits",
    "worker.visit.w_04.kicker": "VISIT BRIEFING",
    "worker.visit.w_04.subscriber_label": "Subscriber",
    "worker.visit.w_04.title": "Preparation",
    "worker.visit.w_04.window_afternoon": "Afternoon · 1–5 pm",
    "worker.visit.w_04.window_label": "Time slot",
    "worker.visit.w_04.window_morning": "Morning · 8 am–12 pm",
    "worker.visit.washing.body": "No need to watch the screen. The app runs in the background.",
    "worker.visit.washing.cta_done": "Laundry ready — after photo",
    "worker.visit.washing.cta_issue": "Report an issue",
    "worker.visit.washing.kicker": "WASHING",
    "worker.visit.washing.timer_label": "Time elapsed",
    "worker.visit.washing.title": "Washing in progress",
    "marketing.hero.photo.alt": "A Washed laundress hangs white laundry in the sun on a Lomé rooftop.",
    "marketing.compare.head.note": "Plans for one person, a couple or a family.",
    "marketing.compare.summary.label": "Organisation",
    "marketing.compare.summary.sans": "On you",
    "marketing.compare.summary.avec": "Handled by Washed",
    "marketing.interlude.claim": "A familiar face. A rhythm that lasts.",
    "marketing.interlude.body": "Washed connects Lomé households with vetted independent laundresses and handles scheduling and payment. Your laundry stays in your home.",
    "marketing.interlude.tagline": "Your home. Your routine. A regular helping hand.",
    "marketing.interlude.alt": "Morning light on clean laundry.",
    "marketing.service.after.head": "Laundry done. Life goes on.",
    "marketing.service.after.body": "When the visit is complete, you can review it in the app. Your laundry stays right at home.",
    "marketing.service.photo.alt": "A Washed laundress hands clean laundry to a customer at home.",
    "marketing.worker.apply": "See the work and apply",
    "marketing.worker.photo.alt": "A Washed laundress in a courtyard in Lomé.",
    "marketing.technology.eyebrow": "Stay in the picture",
    "marketing.technology.head": "Know who is coming. See how the visit is going.",
    "marketing.technology.body": "Your appointment, payment and visit details, together in the app. A clear record from the start of the visit to the finish.",
    "marketing.technology.preview": "Example visit",
    "marketing.technology.feature.continuity.title": "Continuity",
    "marketing.technology.feature.continuity.body": "Your regular washerwoman stays assigned to the household by default.",
    "marketing.technology.feature.schedule.title": "Scheduling",
    "marketing.technology.feature.schedule.body": "The day and time window are visible before every visit.",
    "marketing.technology.feature.payment.title": "Payment",
    "marketing.technology.feature.payment.body": "Mixx by Yas or Flooz, processed through the platform.",
    "marketing.technology.feature.proof.title": "Visit proof",
    "marketing.technology.feature.proof.body": "GPS check-in and before/after photos document service delivery.",
    "marketing.technology.sample.status": "Upcoming",
    "marketing.technology.sample.nextVisit": "Next visit",
    "marketing.technology.sample.day": "Tuesday",
    "marketing.technology.sample.washerRole": "Your regular washerwoman",
    "marketing.technology.sample.confirmed": "Visit confirmed",
    "marketing.technology.sample.confirmedDetail": "Time window reserved",
    "marketing.technology.sample.paid": "Payment received",
    "marketing.technology.sample.arrival": "Arrival on the day",
    "marketing.technology.sample.arrivalDetail": "GPS check-in",
    "marketing.technology.sample.photos": "Finish photos",
    "marketing.technology.sample.photosDetail": "Visit proof",
    "pricing.tiers.s1": "Solo 1×",
    "pricing.tiers.s2": "Solo 2×",
    "pricing.tiers.d1": "Duo 1×",
    "pricing.tiers.d2": "Duo 2×",
    "pricing.tiers.f1": "Household 1×",
    "pricing.tiers.f2": "Household 2×",
    "subscriber.signup.tier.d1.label": "1 visit / month · 2 people",
    "subscriber.signup.tier.d1.price": "6,000 XOF / month",
    "subscriber.signup.tier.d2.label": "2 visits / month · 2 people",
    "subscriber.signup.tier.d2.price": "11,500 XOF / month",
    "subscriber.signup.tier.f1.label": "1 visit / month · 3 to 5 people",
    "subscriber.signup.tier.f1.price": "9,500 XOF / month",
    "subscriber.signup.tier.f2.label": "2 visits / month · 3 to 5 people",
    "subscriber.signup.tier.f2.price": "18,000 XOF / month",
    "pricing.tiers.t1": "Solo 1×",
    "pricing.tiers.t2": "Solo 2×",
    "subscriber.signup.plan.title": "Your plan",
    "subscriber.signup.plan.household_question": "How many people live in your home?",
    "subscriber.signup.plan.household_help": "Everyone whose laundry is washed, including you.",
    "subscriber.signup.plan.unit_one": "person",
    "subscriber.signup.plan.unit_many": "people",
    "subscriber.signup.plan.eight_or_more": "8 people or more?",
    "subscriber.signup.plan.frequency_question": "How many visits a month?",
    "subscriber.signup.plan.visits_row_one": "1 visit",
    "subscriber.signup.plan.visits_row_two": "2 visits",
    "subscriber.signup.plan.continue_with": "Continue with {plan}",
    "subscriber.signup.plan.currency_spoken": "CFA francs",
    "subscriber.signup.plan.a_month": "a month",
    "subscriber.signup.plan.selected": "Your plan · {plan}",
    "subscriber.signup.plan.per_month": "F CFA a month",
    "subscriber.signup.plan.covers.foyer_extra": "5 people included, then {price} F CFA a month for each extra person, up to {max} people.",
    "subscriber.signup.plan.value.per_person": "{price} F CFA per person",
    "subscriber.signup.plan.value.per_visit": "{price} F CFA per visit",
    "subscriber.signup.plan.no_payment_today": "Nothing to pay at sign-up. Charged once your washerwoman is confirmed, before the first visit.",
    "subscriber.signup.plan.prices_unavailable": "Prices couldn’t be loaded. Check your connection and try again.",
    "subscriber.signup.retry_cta": "Try again",
    "subscriber.signup.members.title": "Who lives with you?",
    "subscriber.signup.members.range_duo": "Add the other person on your Duo plan.",
    "subscriber.signup.members.range": "Add {min} to {max} people besides you.",
    "subscriber.signup.members.person": "Person {number}",
    "subscriber.family.signup.member.rel.ami": "Friend",
    "subscriber.signup.members.birth_year_error": "Enter a year between 1900 and {year}.",
    "subscriber.signup.members.add_cta": "Add a person",
    "subscriber.signup.wallet.title": "Your Mobile Money",
    "subscriber.signup.confirm.title": "Check your subscription",
    "subscriber.signup.confirm.people": "People",
    "subscriber.signup.confirm.people_solo": "You",
    "subscriber.signup.confirm.people_with": "You, {names}",
    "subscriber.signup.confirm.plan_price": "Plan price",
    "subscriber.signup.confirm.extra_people": "Extra people ({count})",
    "subscriber.signup.confirm.extra_helper": "Household helper ({count})",
    "subscriber.signup.confirm.per_person": "Per person",
    "subscriber.signup.confirm.today": "At sign-up",
    "subscriber.signup.confirm.today_amount": "0 F CFA",
    "subscriber.signup.confirm.first_charge": "First charge when the office confirms your washerwoman, before your first visit. Later months are charged before their first visit.",
    "subscriber.signup.confirm.checking_price": "Checking the price…",
    "subscriber.signup.confirm.price_unavailable": "The price couldn’t be confirmed. Try again before subscribing.",
    "subscriber.signup.confirm.saving_members": "Saving the people in your household…",
    "subscriber.signup.confirm.unknown_title": "We’re checking your subscription",
    "subscriber.signup.confirm.unknown_body": "The connection dropped while sending. Nothing was charged. Check before sending again so nothing is created twice.",
    "subscriber.signup.confirm.check_cta": "Check",
    "subscriber.signup.confirm.failed": "The subscription wasn’t created. Nothing was charged. Please try again.",
    "subscriber.signup.confirm.members_incomplete": "Your subscription is created. Some people in your household aren’t saved yet.",
    "subscriber.signup.confirm.restricted": "Your account can’t take a subscription right now. Contact the office on {phone}.",
    "subscriber.home.greeting": "Hello, {name}",
    "subscriber.home.ready.title": "Choose your first visit",
    "subscriber.home.ready.body": "Tell us the day and time that suit you. The office then chooses a washerwoman from your area.",
    "subscriber.home.ready.cta": "Choose the day",
    "subscriber.home.pending.title": "The office is choosing your washerwoman",
    "subscriber.home.pending.preference": "Your preference: {day}, {window}. We’ll let you know as soon as the washerwoman and the date are confirmed.",
    "subscriber.home.pending.body": "We’ll let you know as soon as the washerwoman and the date are confirmed.",
    "subscriber.home.steps.plan_created": "Subscription created",
    "subscriber.home.steps.choose_day": "Choosing the day and time",
    "subscriber.home.steps.request_sent": "Request sent",
    "subscriber.home.steps.washer": "Choosing your washerwoman",
    "subscriber.home.steps.washer_detail": "By the office, based on your area",
    "subscriber.home.steps.confirmed": "First visit confirmed",
    "subscriber.home.steps.confirmed_detail": "Date, time and washerwoman",
    "subscriber.home.steps.state_done": "done",
    "subscriber.home.steps.state_now": "in progress",
    "subscriber.home.steps.state_todo": "to come",
    "subscriber.home.no_payment_until_confirmed": "Nothing to pay until your washerwoman is confirmed.",
    "subscriber.home.contact_office": "Contact the office",
    "subscriber.home.paused.title": "Plan paused",
    "subscriber.home.paused.body": "Nothing is charged while your plan is paused. You can resume whenever you like.",
    "subscriber.home.cancelled.title": "Plan stopped",
    "subscriber.home.cancelled.body": "No visits or payments are coming up. You can start a plan again whenever you like.",
    "subscriber.home.visit_day.eta": "Arriving in {minutes} min",
    "subscriber.home.visit_day.since": "for {minutes} min",
    "subscriber.home.visit_day.open_cta": "See the visit",
    "subscriber.load_failed.home": "Couldn't show your home",
    "subscriber.load_failed.visits": "Couldn't show your visits",
    "subscriber.load_failed.visit": "Couldn't show this visit",
    "subscriber.load_failed.plan": "Couldn't show your plan",
    "subscriber.load_failed.tickets": "Couldn't show your requests",
    "subscriber.load_failed.retry": "Try again",
    "subscriber.upgrade.price_per_month": "{price} / month",
    "subscriber.load_failed.prices": "Couldn't show the prices",
    "subscriber.loading.a11y": "Loading",
    "subscriber.loading.slow": "Taking longer than usual…",
    "subscriber.status.moved": "Moved, instead of {date}",
    "subscriber.status.moved_spoken": "Visit moved. It was planned for {date}.",
    "subscriber.status.cancelled": "Visit on {date} cancelled.",
    "subscriber.status.rated": "Thank you, your rating has been sent.",
    "subscriber.status.rated_low": "Rating sent. Something wrong with this visit?",
    "subscriber.status.reported": "Problem reported · the office is looking into it",
    "subscriber.status.reported_spoken": "Problem reported. The office is looking into it. Its answer will show here.",
    "subscriber.home.rate_ask.title": "How did the visit go?",
    "subscriber.home.rate_ask.a11y": "Rate the visit on {date}",
    "subscriber.rating.value": "{count} stars out of 5",
    "subscriber.rating.value_one": "1 star out of 5",
    "subscriber.rating.none": "No rating",
    "subscriber.freshness.stale": "Not up to date · last updated at {time}",
    "subscriber.offline.since": "Offline since {time}",
    "subscriber.home.household_incomplete.title": "Add the people on your plan",
    "subscriber.home.household_incomplete.cta": "Add the people",
    "subscriber.home.household_unknown.title": "We couldn’t check the people on your plan.",
    "subscriber.booking.sunday_closed": "We visit Monday to Saturday. Please choose another day.",
    "worker.paid_visit.section_today": "Confirmed visits",
    "worker.paid_visit.section_upcoming": "Upcoming",
    "worker.paid_visit.window_am": "Morning (8 am–12 pm)",
    "worker.paid_visit.window_pm": "Afternoon (1–5 pm)",
    "worker.paid_visit.window_day": "Full day",
    "worker.paid_visit.location_missing": "Address to be confirmed: call the office.",
    "worker.paid_visit.location_unverified": "Location to be confirmed on site",
    "worker.paid_visit.access_label": "Access",
    "worker.paid_visit.cta_directions": "Directions",
    "worker.paid_visit.cta_call": "Call the customer",
    "worker.paid_visit.cta_whatsapp": "Message on WhatsApp",
    "worker.paid_visit.cta_door": "I knocked at the door",
    "worker.paid_visit.cta_check_in": "I have arrived",
    "worker.paid_visit.cta_start": "Start washing",
    "worker.paid_visit.cta_complete": "Finish the visit",
    "worker.paid_visit.flags_title": "Anything to report?",
    "worker.paid_visit.cta_no_show": "Customer not there",
    "worker.paid_visit.cta_safety": "I'm leaving for my safety",
    "worker.paid_visit.safety_note": "One tap is enough. No photo, no waiting: the team takes over.",
    "worker.paid_visit.check_in_far": "You are {meters} m from the address (100 m at most). Move closer and try again.",
    "worker.office.whatsapp_cta": "Call the office on WhatsApp",
    "worker.office.sms_cta": "Text the office (SMS)",
    "worker.visit.closed_by_office": "The office has closed this visit. There is nothing left to do here.",
    "worker.paid_visit.check_in_far_office": "Your phone still places you {meters} m from the address. If you are at the door, call the office: they can confirm your arrival. Then tap “I have arrived” again.",
    "worker.paid_visit.arrival_by_office": "Arrival confirmed by the office.",
    "worker.paid_visit.check_in_no_location": "No address on file: call the office. Once the address is added, tap “I have arrived” again.",
    "worker.paid_visit.location_needed": "Turn on location to confirm your arrival.",
    "worker.paid_visit.no_show_wait": "“Customer not there” is possible at {time}, after a contact attempt.",
    "worker.paid_visit.contacts": "Contact attempts: {count}",
    "worker.paid_visit.state_upcoming": "Upcoming",
    "worker.paid_visit.state_due": "To do",
    "worker.paid_visit.state_arrived": "Arrival confirmed",
    "worker.paid_visit.state_in_service": "Washing in progress",
    "worker.paid_visit.state_completed": "Completed",
    "worker.paid_visit.state_no_show": "Customer not there",
    "worker.paid_visit.state_under_review": "Under review by the team",
    "worker.paid_visit.state_on_hold": "On hold: do not travel",
    "worker.paid_visit.state_closed": "Closed",
    "worker.paid_visit.done_body": "Thank you. The visit is recorded and counts toward your earnings.",
    "worker.paid_visit.safety_body": "The team will contact you and look into it. Get somewhere safe.",
    "worker.paid_visit.error": "This can't be done right now. Try again or call the office.",
    "worker.visit.recap.queued_title": "Visit end saved",
    "worker.visit.recap.queued_body": "No network: it will be sent as soon as possible. Everything is saved; you can carry on with your day.",
    "subscriber.hub.change_until": "Possible until {date}, 6 p.m.",
    "launch.spot30.sunday.1": "Sunday.",
    "launch.spot30.sunday.2": "2 p.m.",
    "launch.spot30.sunday.3": "Laundry again?",
    "launch.spot30.promise.1": "Laundry done.",
    "launch.spot30.promise.2": "Without you.",
    "launch.spot30.knots.1": "A vetted laundress.",
    "launch.spot30.knots.2": "At your home.",
    "launch.spot30.knots.3": "Your water, your soap.",
    "launch.spot30.price.1": "From {price} / month.",
    "launch.spot30.price.2": "Solo · Duo · Foyer",
    "launch.spot30.track.1": "Subscribe on WhatsApp.",
    "launch.spot30.track.2": "Paid in advance with Mixx by Yas or Flooz.",
    "launch.spot30.tie.1": "Across Lomé.",
    "launch.spot30.tie.2": "Subscribe on WhatsApp",
    "launch.explainer60.weekend.1": "The weekend",
    "launch.explainer60.weekend.2": "is short.",
    "launch.explainer60.weekend.3": "And laundry takes up all of Sunday.",
    "launch.explainer60.doubt.1": "Will she come?",
    "launch.explainer60.doubt.2": "On time?",
    "launch.explainer60.doubt.3": "Next month?",
    "launch.explainer60.promise.1": "Laundry done.",
    "launch.explainer60.promise.2": "Without you.",
    "launch.explainer60.promise.3": "Washed, in Lomé.",
    "launch.explainer60.rhythm.1": "You choose the rhythm.",
    "launch.explainer60.rhythm.2": "One or two visits a month.",
    "launch.explainer60.rhythm.3": "The day and time slot that suit you.",
    "launch.explainer60.prepare.1": "You get the basics ready.",
    "launch.explainer60.prepare.2": "Water, soap, bucket.",
    "launch.explainer60.prepare.3": "Your laundry stays at home.",
    "launch.explainer60.relay.1": "A vetted laundress takes over.",
    "launch.explainer60.relay.2": "Your regular laundress comes back.",
    "launch.explainer60.relay.3": "If she is unavailable, Washed arranges a replacement.",
    "launch.explainer60.vetted.1": "Identity.",
    "launch.explainer60.vetted.2": "References.",
    "launch.explainer60.vetted.3": "Interview.",
    "launch.explainer60.vetted.4": "Every laundress is vetted.",
    "launch.explainer60.prices.1": "Six plans.",
    "launch.explainer60.prices.2": "From {price} / month.",
    "launch.explainer60.track.1": "Subscribe on WhatsApp, pay before the visit.",
    "launch.explainer60.track.2": "Mixx by Yas or Flooz. Never in cash.",
    "launch.explainer60.tie.1": "Free pause, cancel anytime.",
    "launch.explainer60.tie.2": "Across Lomé: washedafrica.com",
    "launch.video.rhythm.visits_1": "1 visit",
    "launch.video.rhythm.visits_2": "2 visits",
    "launch.video.rhythm.per_month": "a month",
    "launch.video.rhythm.day": "Tuesday",
    "launch.video.rhythm.slot": "Morning",
    "launch.video.prices.visits_1": "1 visit / month",
    "launch.video.prices.visits_2": "2 visits / month",
    "launch.video.prices.unit": "F CFA / month",
    "launch.video.phone.request": "Hello, I’d like a laundress. Just me.",
    "launch.story.cta": "Subscribe on WhatsApp",
    "launch.story.price_from": "{plan}: from {price} / month",
    "launch.story.agenda.today": "Today",
    "launch.story.agenda.laundry": "Laundry",
    "launch.story.agenda.laundry_length": "3 hours",
    "launch.story.day.monday": "Monday",
    "launch.story.day.tuesday": "Tuesday",
    "launch.story.day.wednesday": "Wednesday",
    "launch.story.day.thursday": "Thursday",
    "launch.story.day.friday": "Friday",
    "launch.story.day.saturday": "Saturday",
    "launch.story.day.sunday": "Sunday",
    "launch.story.assistant.status": "Assistant · WhatsApp",
    "launch.story.assistant.hello_day": "Hello",
    "launch.story.assistant.hello_evening": "Good evening",
    "launch.story.assistant.greet": "{hello}! Welcome to Washed 👋 {question}",
    "launch.story.assistant.ask_household": "How many of you are at home?",
    "launch.story.assistant.people_solo": "one person",
    "launch.story.assistant.people_duo": "two people",
    "launch.story.assistant.people_foyer": "3 to 5 people",
    "launch.story.assistant.menu_intro": "For {people}, the {plan} plan:",
    "launch.story.assistant.menu_one": "• 1 visit a month: {price}",
    "launch.story.assistant.menu_two": "• 2 visits a month: {price}",
    "launch.story.assistant.menu_question": "Would you like 1 or 2 visits?",
    "launch.story.assistant.ask_day": "Very good. Which day suits you, Monday to Saturday?",
    "launch.story.assistant.held": "Held for 30 minutes: {day} {window}. Pay the first month with Mixx by Yas or Flooz; we confirm as soon as the payment is checked.",
    "launch.story.assistant.window_morning": "morning (8am–12pm)",
    "launch.story.assistant.window_afternoon": "afternoon (1pm–5pm)",
    "launch.story.amivi.caption_sunday": "Meet Amivi. On Sunday, she has everything planned.",
    "launch.story.amivi.event_mass": "Mass",
    "launch.story.amivi.event_baptism": "Kafui’s baptism",
    "launch.story.amivi.event_birthday": "Auntie Ama’s birthday",
    "launch.story.amivi.caption_pile": "Except the laundry.",
    "launch.story.amivi.contact_mum": "Mum",
    "launch.story.amivi.mum_dress": "Is your dress for the baptism clean?",
    "launch.story.amivi.reply_not_yet": "Not yet…",
    "launch.story.amivi.mum_calls": "Amivi!",
    "launch.story.amivi.caption_who": "Who’s going to do it?",
    "launch.story.amivi.caption_whatsapp": "On Thursday, Amivi wrote to Washed on WhatsApp.",
    "launch.story.amivi.msg_hello": "Hello, I live alone and I no longer have time for my laundry.",
    "launch.story.amivi.msg_choice": "One visit.",
    "launch.story.amivi.msg_day": "Tuesday morning.",
    "launch.story.amivi.caption_tuesday": "On Tuesday morning, Akouvi came to wash at her home. With her water and her soap.",
    "launch.story.amivi.caption_ready": "On Sunday, everything is ready.",
    "launch.story.amivi.ready_note": "Laundry ready since Tuesday",
    "launch.story.amivi.caption_party": "On Sunday, Amivi only had the party on her mind.",
    "launch.story.amivi.mum_beautiful": "You look beautiful this morning.",
    "launch.story.amivi.reply_ready": "The laundry was ready on Tuesday.",
    "launch.story.amivi.end_line": "A vetted laundress, at your home.",
    "launch.story.amivi.end_price": "From {price} / month",
    "launch.story.kossi.caption_port": "Kossi gets home from the port at 9 p.m.",
    "launch.story.kossi.caption_week": "All week, a clean shirt every day.",
    "launch.story.kossi.shirts": "clean shirts",
    "launch.story.kossi.caption_saturday": "Saturday, the match at 4 p.m. And a tub of washing waiting for him.",
    "launch.story.kossi.tag_match": "The match",
    "launch.story.kossi.tag_match_when": "Saturday, 4 p.m.",
    "launch.story.kossi.tag_tub": "The tub",
    "launch.story.kossi.tag_tub_when": "Saturday, all day",
    "launch.story.kossi.caption_whatsapp": "On Monday evening, Kossi wrote to Washed on WhatsApp.",
    "launch.story.kossi.msg_hello": "Good evening. I live alone and my shirts pile up all week.",
    "launch.story.kossi.msg_choice": "Two visits. A shirt a day adds up.",
    "launch.story.kossi.msg_day": "Saturday morning.",
    "launch.story.kossi.caption_match": "On Saturday at 4 p.m., Kossi watches the match.",
    "launch.story.kossi.end_line": "A vetted laundress, at your home.",
    "launch.story.akossiwa.caption_family": "The laundry of a family of five.",
    "launch.story.akossiwa.tag_uniforms": "uniforms",
    "launch.story.akossiwa.tag_wrappers": "wrappers",
    "launch.story.akossiwa.tag_towels": "towels",
    "launch.story.akossiwa.tag_sheets": "sheets",
    "launch.story.akossiwa.caption_saturday": "And just one Saturday to wash it all.",
    "launch.story.akossiwa.saturday": "Saturday",
    "launch.story.akossiwa.caption_whatsapp": "Maman Akossiwa wrote to Washed on WhatsApp.",
    "launch.story.akossiwa.msg_hello": "Hello, there are five of us at home: my husband, our three children and me.",
    "launch.story.akossiwa.msg_choice": "Two visits. With five of us, we need it.",
    "launch.story.akossiwa.msg_day": "Thursday mornings.",
    "launch.story.akossiwa.caption_visit": "Her vetted laundress washes the whole household’s laundry. If she is unavailable, Washed arranges a replacement.",
    "launch.story.akossiwa.tag_market": "The market",
    "launch.story.akossiwa.tag_children": "The children",
    "launch.story.akossiwa.tag_nap": "A nap",
    "launch.story.akossiwa.caption_free": "Saturday is hers again.",
    "launch.story.akossiwa.end_line": "The whole household’s laundry, at home.",
    "launch.story.edem_sena.contact": "Edem",
    "launch.story.edem_sena.fight_1": "It’s your turn to do the laundry.",
    "launch.story.edem_sena.fight_2": "I did the dishes.",
    "launch.story.edem_sena.fight_3": "Last Tuesday.",
    "launch.story.edem_sena.fight_4": "That counts.",
    "launch.story.edem_sena.fight_5": "Edem.",
    "launch.story.edem_sena.caption_fight": "Edem and Sena. It’s been going on for three weeks.",
    "launch.story.edem_sena.caption_whatsapp": "The next day, Edem wrote to Washed on WhatsApp.",
    "launch.story.edem_sena.msg_hello": "Hello, there are two of us at home, my wife and me.",
    "launch.story.edem_sena.msg_choice": "One visit, to start with.",
    "launch.story.edem_sena.msg_day": "Saturday morning, we’ll both be home.",
    "launch.story.edem_sena.deal_1": "I asked Washed. A laundress at our place, {price} a month for both of us.",
    "launch.story.edem_sena.deal_2": "You put in {half}, I put in {half}?",
    "launch.story.edem_sena.deal_3": "Deal ❤️",
    "launch.story.edem_sena.caption_deal": "Half each. No more arguing.",
    "launch.story.edem_sena.end_line": "Laundry for two, no arguing.",
    "launch.story.yawa.caption_open": "Yawa opens her shop at the Grand Marché at 6 a.m.",
    "launch.story.yawa.place": "Assigamé",
    "launch.story.yawa.caption_days": "Tuesday to Saturday at the market. Sunday is for family.",
    "launch.story.yawa.at_market": "at the market",
    "launch.story.yawa.caption_none": "Her Monday off goes on laundry.",
    "launch.story.yawa.tag_laundry": "Laundry?",
    "launch.story.yawa.caption_whatsapp": "On Wednesday, between two customers, Yawa wrote to Washed.",
    "launch.story.yawa.msg_hello": "Hello, I live alone and I’m at the market Tuesday to Saturday.",
    "launch.story.yawa.msg_choice": "One visit.",
    "launch.story.yawa.msg_day": "Monday mornings, I’m at home.",
    "launch.story.yawa.caption_monday": "On Monday morning, her laundress takes care of the laundry.",
    "launch.story.yawa.end_line": "You run your business. She takes care of the laundry.",
    "launch.story.dzifa.caption_weekend": "Dzifa’s weekend, in Lomé.",
    "launch.story.dzifa.wake": "wake",
    "launch.story.dzifa.wedding": "wedding",
    "launch.story.dzifa.funeral": "funeral",
    "launch.story.dzifa.caption_outfits": "Three ceremonies, three outfits to wash.",
    "launch.story.dzifa.caption_whatsapp": "On Monday, Dzifa wrote to Washed on WhatsApp.",
    "launch.story.dzifa.msg_hello": "Hello! I live alone, and I have ceremonies almost every weekend.",
    "launch.story.dzifa.msg_choice": "Two visits, with all these outfits.",
    "launch.story.dzifa.msg_day": "Thursday morning, before the weekend.",
    "launch.story.dzifa.caption_ready": "On Thursday morning, her laundress came. All three outfits are ready.",
    "launch.story.dzifa.tag_wake": "Wake",
    "launch.story.dzifa.tag_wedding": "Wedding",
    "launch.story.dzifa.tag_funeral": "Funeral",
    "launch.story.dzifa.end_line": "A vetted laundress, at your home.",
    "launch.story.ablavi.contact": "Laundress",
    "launch.story.ablavi.no_show": "Good morning madam, I won’t be able to come today.",
    "launch.story.ablavi.caption_dates": "For Ablavi: the 3rd, the 12th, the 21st. The same message.",
    "launch.story.ablavi.caption_waiting": "The laundry waits. And she looks for someone else.",
    "launch.story.ablavi.caption_whatsapp": "Ablavi wrote to Washed on WhatsApp.",
    "launch.story.ablavi.msg_hello": "Hello, there are three of us: my husband, our son and me. I’m looking for a regular laundress.",
    "launch.story.ablavi.msg_choice": "One visit.",
    "launch.story.ablavi.msg_day": "Friday morning.",
    "launch.story.ablavi.caption_continuity": "Your regular laundress comes back. If she is unavailable, Washed arranges a replacement.",
    "launch.story.ablavi.tag_regular": "Your laundress",
    "launch.story.ablavi.tag_regular_sub": "comes back every month",
    "launch.story.ablavi.tag_unavailable": "Unavailable?",
    "launch.story.ablavi.tag_unavailable_sub": "Washed replaces her",
    "launch.story.ablavi.caption_pay": "You pay before the visit. Never in cash.",
    "launch.story.ablavi.end_line": "A vetted laundress, every month.",
    "launch.story.afi.caption_exam": "Monday. Afi’s exam is in 3 days.",
    "launch.story.afi.countdown": "3 days",
    "launch.story.afi.subject": "constitutional law",
    "launch.story.afi.caption_piling": "The laundry piles up. So does the revision.",
    "launch.story.afi.tag_tshirts": "T-shirts",
    "launch.story.afi.tag_jeans": "Jeans",
    "launch.story.afi.tag_sheets": "Sheets",
    "launch.story.afi.caption_whatsapp": "Afi wrote to Washed on WhatsApp.",
    "launch.story.afi.msg_hello": "Hello, I’m a student, I live alone and I’m revising for my exams.",
    "launch.story.afi.msg_choice": "One visit.",
    "launch.story.afi.msg_day": "Wednesday morning?",
    "launch.story.afi.caption_done": "On Thursday, Afi had revised. The laundry was done.",
    "launch.story.afi.tag_exam": "Exam",
    "launch.story.afi.tag_laundry": "Laundry",
    "launch.story.afi.end_line": "A vetted laundress, at your home.",
    "series.lacour.label": "La Cour · S{season}·E{episode}",
    "series.lacour.price_from": "From {price} / month",
    "series.lacour.price_month": "{price} / month",
    "series.lacour.group": "La Cour",
    "series.lacour.typing": "{name} is typing…",
    "series.lacour.name.komla": "Uncle Komla",
    "series.lacour.name.amivi": "Amivi",
    "series.lacour.name.kossi": "Kossi",
    "series.lacour.name.edem": "Edem",
    "series.lacour.name.sena": "Sena",
    "series.lacour.name.akossiwa": "Maman Akossiwa",
    "series.lacour.name.akouvi": "Akouvi",
    "series.lacour.akouvi_door": "Is the bucket ready?",
    "series.lacour.fil_stop": "Let’s stop for a second.",
    "series.lacour.fil_rewind": "Let’s rewind.",
    "series.lacour.panier_line": "Water, soap, bucket!",
    "series.lacour.gardienne_line": "I keep watch.",
    "series.lacour.komla_line": "In my day, we did our own washing.",
    "series.lacour.komla_line_cut": "In my day…",
    "series.lacour.dots": "…",
    "series.lacour.assistant_paid": "Your payment of {amount} is recorded: you’re confirmed for {day} {window}. Thank you!",
    "series.s0e1.caption_cour": "A courtyard in Lomé. One week.",
    "series.s0e1.caption_line": "The line was never empty.",
    "series.s0e1.caption_basins": "And nobody touched a basin.",
    "series.s0e1.fil_intro": "I’m the line.",
    "series.s0e1.fil_hold": "I hold the whole courtyard’s laundry.",
    "series.s0e1.komla_who": "All week the line was full. Who did the washing?",
    "series.s0e1.not_me": "Not me.",
    "series.s0e1.not_us": "Not us.",
    "series.s0e1.akossiwa_ask": "Ask Akouvi.",
    "series.s0e1.komla_akouvi": "Who’s Akouvi?",
    "series.s0e1.caption_arrived": "Uncle Komla arrived three weeks ago.",
    "series.s0e1.caption_questions": "He asks a lot of questions.",
    "series.s0e1.teaser": "Who is Akouvi? Part 2 tomorrow.",
    "series.s0e1.end_line": "A vetted laundress, at your home.",
    "series.s0e2.caption_part": "Part 2 · Door 1",
    "series.s0e2.komla_tuesday": "Tuesday, your laundry was on the line. When did you wash?",
    "series.s0e2.amivi_not_me": "I didn’t wash, Tonton.",
    "series.s0e2.komla_by_itself": "The laundry washed itself?",
    "series.s0e2.amivi_akouvi": "Akouvi came.",
    "series.s0e2.caption_sundays": "Last month. Her Sundays were already full.",
    "series.s0e2.msg_hello": "Hello, I live alone and my Sundays are full.",
    "series.s0e2.msg_choice": "One visit, Tuesday morning.",
    "series.s0e2.msg_paid": "Paid, with Mixx by Yas.",
    "series.s0e2.caption_whatsapp": "One visit a month. The day she chose.",
    "series.s0e2.caption_tuesday": "Tuesday morning, at her place. With her water and her soap.",
    "series.s0e2.komla_sunday": "And on Sunday, what were you doing?",
    "series.s0e2.amivi_baptism": "A baptism. I only stopped by for five minutes.",
    "series.s0e2.caption_three_hours": "(Three hours.)",
    "series.s0e2.teaser": "Part 3 tomorrow.",
    "series.s0e2.end_line": "Solo: one person, one laundress.",
    "series.s0e3.caption_part": "Part 3 · Door 3",
    "series.s0e3.komla_who": "Is it Sena who does the washing at yours?",
    "series.s0e3.edem_no": "Certainly not.",
    "series.s0e3.sena_no": "Nor him.",
    "series.s0e3.akouvi": "It’s Akouvi.",
    "series.s0e3.caption_rewind": "Two months ago, Door 3.",
    "series.s0e3.fight_turn": "It’s your turn.",
    "series.s0e3.fight_dishes": "I did the dishes.",
    "series.s0e3.fight_when": "Last Tuesday.",
    "series.s0e3.fight_counts": "It counts.",
    "series.s0e3.fight_name": "Edem.",
    "series.s0e3.tag_duo": "Duo · 2 people",
    "series.s0e3.caption_duo": "They took Duo. And they split it.",
    "series.s0e3.caption_saturday": "Saturday, 7:50.",
    "series.s0e3.tag_water": "Water",
    "series.s0e3.tag_bucket": "Bucket",
    "series.s0e3.tag_soap": "Soap",
    "series.s0e3.sena_soap": "Edem. The soap.",
    "series.s0e3.edem_going": "On my way.",
    "series.s0e3.tag_shop": "Corner shop",
    "series.s0e3.caption_yours": "The water and soap are yours.",
    "series.s0e3.caption_hers": "The work is hers.",
    "series.s0e3.komla_pay": "You pay a woman to do your washing?",
    "series.s0e3.sena_sub": "We pay the subscription. Before the visit.",
    "series.s0e3.edem_peace": "And we don’t argue any more.",
    "series.s0e3.sena_almost": "Almost.",
    "series.s0e3.teaser": "Part 4 tomorrow.",
    "series.s0e3.end_line": "Duo: laundry for two.",
    "series.s0e4.komla_who": "Akossiwa. Who washes this house’s laundry?",
    "series.s0e4.caption_next_room": "From the next room.",
    "series.s0e4.akossiwa_akouvi": "Akouvi. Two Thursdays a month.",
    "series.s0e4.komla_never": "I’ve never seen her.",
    "series.s0e4.akossiwa_nap": "You nap at 9, Tonton.",
    "series.s0e4.caption_family": "A family of five. One Saturday.",
    "series.s0e4.caption_foyer": "So: Foyer, two visits a month.",
    "series.s0e4.komla_stranger": "A stranger in the house?",
    "series.s0e4.tag_identity": "Identity",
    "series.s0e4.tag_references": "References",
    "series.s0e4.tag_interview": "Interview",
    "series.s0e4.caption_vetted": "Every laundress is vetted before her first visit.",
    "series.s0e4.tag_visit": "Thursday · Akouvi",
    "series.s0e4.caption_returns": "And she’s the one who comes back.",
    "series.s0e4.akossiwa_not_stranger": "She’s not a stranger. She’s Akouvi.",
    "series.s0e4.akossiwa_yes": "Yes, Tonton.",
    "series.s0e4.teaser": "Tomorrow: the ending.",
    "series.s0e4.end_line": "Foyer: the whole family, one laundress.",
    "series.s0e5.caption_part": "Part 5 · The ending",
    "series.s0e5.komla_myself": "Me, at least, I wash my own clothes.",
    "series.s0e5.tag_shirt": "Uncle Komla’s shirt",
    "series.s0e5.tag_arrival": "The day Tonton arrived",
    "series.s0e5.akossiwa_add": "My husband’s uncle is coming to live with us. Add him to the Foyer.",
    "series.s0e5.washed_noted": "Noted. Komla becomes the Foyer’s 6th person: {price} more a month.",
    "series.s0e5.akossiwa_ok": "All right.",
    "series.s0e5.caption_added": "The day he arrived, she added him to the Foyer.",
    "series.s0e5.akossiwa_shirt": "Tonton. Your shirt.",
    "series.s0e5.kossi_count": "Clean shirts: Tonton, 1.",
    "series.s0e5.amivi_alone": "Tonton does his own washing, sure.",
    "series.s0e5.komla_good": "She washes well, this Akouvi.",
    "series.s0e5.komla_when": "When is she coming back?",
    "series.s0e5.akossiwa_thursday": "Thursday.",
    "series.s0e5.komla_no_nap": "I won’t take a nap.",
    "series.s0e5.caption_opened": "On Thursday, Uncle Komla opened the door.",
    "series.s0e5.end_line": "Solo, Duo or Foyer. A vetted laundress, at your home.",
    "partner.portal": "Creator dashboard",
    "partner.boundaryUpdated": "The creator dashboard was updated while this tab was open.",
    "partner.boundaryFailed": "This page could not be shown.",
    "partner.boundaryKeep": "Reload to continue; you stay signed in.",
    "partner.reload": "Reload",
    "partner.overview": "Summary",
    "partner.referrals": "Referrals",
    "partner.earnings": "Earnings",
    "partner.share": "My link",
    "partner.logout": "Sign out",
    "partner.welcome": "Every recommendation counts.",
    "partner.intro": "Follow the households you introduce to WASHED, their progress, and your commissions.",
    "partner.attributed": "Referred households",
    "partner.paid": "First paid cycle",
    "partner.qualified": "First wash qualified",
    "partner.retained": "Second paid cycle",
    "partner.active": "Active subscriptions",
    "partner.attributedHelp": "A code recorded on a new household before its first payment.",
    "partner.paidHelp": "At least one fully paid subscription with verified payment.",
    "partner.qualifiedHelp": "A completed first wash, without an open material issue, after 48 hours.",
    "partner.retainedHelp": "At least two distinct activated cycles with verified payment.",
    "partner.activeHelp": "The household currently has an active subscription.",
    "partner.payable": "Awaiting payment",
    "partner.pending": "Awaiting renewal",
    "partner.held": "Under review",
    "partner.paidOut": "Already paid",
    "partner.earned": "Earned commissions",
    "partner.balanceNote": "Lifetime program balances. Pending amounts have not yet been earned.",
    "partner.recent": "Your referrals’ progress",
    "partner.activityIntro": "Anonymous references let you follow each introduction. Household contact details stay private.",
    "partner.reference": "Reference",
    "partner.date": "Attributed on",
    "partner.status": "Stage",
    "partner.amount": "Commission",
    "partner.noReferrals": "No referrals yet",
    "partner.noReferralsBody": "Share your link. A household will appear here once your code is recorded during onboarding.",
    "partner.shareTitle": "Share your link",
    "partner.shareIntro": "Your link carries your code into onboarding. A link visit alone does not count as a referral.",
    "partner.copy": "Copy link",
    "partner.copied": "Copied",
    "partner.code": "Your personal code",
    "partner.terms": "Your terms",
    "partner.termsBody": "You earn F 1,000 once per referred household after its first wash qualifies and its second paid cycle activates. The household receives F 500 in promotional credit after the first wash qualifies. Payouts are made manually by mobile money.",
    "partner.accept": "Accept terms and activate my code",
    "partner.termsTitle": "Welcome to WASHED partners",
    "partner.policy": "Policy version",
    "partner.payouts": "Payout history",
    "partner.noPayouts": "No payouts recorded yet.",
    "partner.provider": "Provider",
    "partner.paidOn": "Payment date",
    "partner.loginTitle": "Your creator dashboard",
    "partner.loginIntro": "Enter the email address WASHED invited. We’ll send you a 6-digit code, valid for 10 minutes.",
    "partner.sendCode": "Send my code",
    "partner.codeTitle": "Enter your code",
    "partner.codeIntro": "If this address is invited, a 6-digit code has just been sent to it. It expires in 10 minutes.",
    "partner.codeLabel": "6-digit code",
    "partner.codeInvalid": "This code doesn’t work. Check it or ask for a new code.",
    "partner.resend": "Send a new code",
    "partner.resent": "If this address is invited, a new code has just been sent to it.",
    "partner.changeEmail": "Use another address",
    "partner.rateLimited": "Too many attempts. Wait 15 minutes before trying again.",
    "partner.passkeySignIn": "Sign in with fingerprint or Face ID",
    "partner.passkeyFailed": "Fingerprint or Face ID sign-in didn’t work. Use your email address.",
    "partner.passkeyOfferTitle": "Faster sign-in",
    "partner.passkeyOfferBody": "Next time, sign in with this phone’s fingerprint or Face ID, without an email code.",
    "partner.passkeyEnable": "Turn on fingerprint or Face ID",
    "partner.passkeyLater": "Later",
    "partner.passkeyEnabled": "Fingerprint or Face ID sign-in is on",
    "partner.passkeyRemove": "Turn off",
    "partner.passkeyAddFailed": "Couldn’t turn it on. Try again later.",
    "partner.email": "Email address",
    "partner.confirm": "Open my dashboard",
    "partner.error": "We couldn’t complete this action. Please try again.",
    "partner.retry": "Retry",
    "partner.loading": "Loading your portal…",
    "partner.refresh": "Refresh",
    "partner.from": "From",
    "partner.to": "To",
    "partner.apply": "Apply",
    "partner.previous": "Previous",
    "partner.next": "Next",
    "partner.page": "Page",
    "partner.updated": "Updated at",
    "partner.demo": "Preview · sample data",
    "partner.demoNormal": "Example",
    "partner.demoWorst": "Worst case",
    "partner.demoEmpty": "Empty",
    "partner.hello": "Hello",
    "partner.join": "Continue on WhatsApp",
    "partner.landing": "Your WASHED referral code",
    "partner.landingBody": "Keep this code and send it to WASHED before your first payment to record your referral.",
    "partner.ATTRIBUTED": "Attribution recorded",
    "partner.HELD_FIRST_SERVICE_ISSUE": "Service issue pending",
    "partner.QUALIFIED_PENDING_REVIEW": "Under review",
    "partner.REWARDED": "First wash qualified",
    "partner.REJECTED": "Not eligible",
    "partner.PENDING_RETENTION": "Awaiting renewal",
    "partner.PAYABLE": "Earned",
    "partner.HELD": "On hold",
    "partner.CANCELLED": "Cancelled",
    "partner.PAID": "Paid",
    "partner.opsTitle": "Partners and commissions",
    "partner.opsIntro": "Invite creators, review referrals, and record mobile-money payouts.",
    "partner.name": "Display name",
    "partner.kind": "Partner type",
    "partner.creator": "Creator",
    "partner.ambassador": "Ambassador",
    "partner.householdId": "Household ID (ambassador)",
    "partner.reason": "Decision reason",
    "partner.invite": "Approve and invite",
    "partner.inspect": "View",
    "partner.suspend": "Suspend new referrals",
    "partner.payout": "Record a completed payout",
    "partner.destination": "Payout destination",
    "partner.evidence": "Payout evidence",
    "partner.fee": "Actual fee (XOF)",
    "partner.amountXof": "Amount paid (XOF)",
    "partner.savePayout": "Confirm completed payout",
    "partner.success": "Action recorded.",
    "partner.opsEmpty": "No partners invited yet.",
    "partner.partnerStatus": "Partner status",
    "partner.INVITED": "Invited",
    "partner.ACTIVE": "Active",
    "partner.SUSPENDED": "Suspended",
    "partner.back": "Back to partners",
    "partner.sendInvite": "Send invitation email",
    "partner.emailChangeTitle": "Change sign-in address",
    "partner.emailChangeIntro": "For a partner who no longer has access to their address. Their code, referrals and commissions stay the same. Their open sessions end, the old address is told and the new one gets the invitation email.",
    "partner.newEmail": "New email address",
    "partner.emailChangeSubmit": "Change address",
    "partner.emailChangedSilent": "Address changed, but no email could be sent. Tell the partner yourself.",
    "partner.emailInUse": "Another partner already signs in with this address.",
    "partner.emailUnchanged": "The partner already signs in with this address.",
    "partner.budget": "Program budget",
    "partner.budgetIntro": "Reporting signal only: no automatic pause of approvals or earned commissions.",
    "partner.revenue": "Verified cycle revenue",
    "partner.cost": "Program commissions, credits and discounts",
    "partner.ratio": "Share of revenue",
    "partner.dashboardIntro": "Your referrals, commissions and payouts in one place.",
    "partner.performance": "Referral activity",
    "partner.performanceNote": "Attributions and payment milestones recorded during the selected period.",
    "partner.conversion": "From introduction to renewal",
    "partner.conversionNote": "Households attributed during the selected period, based on their current status.",
    "partner.conversionRate": "have paid a first cycle",
    "partner.retentionRate": "have paid a second cycle",
    "partner.ofReferred": "of referred households",
    "partner.conversionFootnote": "Each fully paid and verified first subscription earns a commission. Washes and renewals are shown for information.",
    "partner.yourEarnings": "Your commissions",
    "partner.earningsIntro": "Track your earned commissions and payouts.",
    "partner.readyToShare": "Share your code",
    "partner.shareHint": "Every household that gives this code before its first payment is credited to you.",
    "partner.allActivity": "View all referrals",
    "partner.chartTable": "Show daily figures",
    "partner.period": "Period",
    "partner.last30": "Last 30 days",
    "partner.last90": "Last 90 days",
    "partner.custom": "Custom dates",
    "partner.cohort": "Household progress",
    "partner.allTime": "Since you joined",
    "partner.payoutNote": "The office records payouts after sending them by mobile money.",
    "partner.noActivity": "Activity will appear after your first referrals.",
    "partner.earnedInPeriod": "Earned during the period",
    "partner.paymentsInPeriod": "Paid during the period",
    "partner.earningsHistory": "Your earnings over time",
    "partner.volumeReview": "More than 10 bounties this month: review the volume. This signal does not cap earnings.",
    "partner.operatorPerformance": "Partner performance",
    "partner.partnersActive": "Active partners",
    "partner.reviewsNeeded": "Reviews to address",
    "partner.programPayable": "Unpaid earned commissions",
    "partner.partnersCount": "Enrolled partners",
    "partner.performanceUnavailable": "No activity for this period.",
    "partner.termsCreatorBody": "You earn F 2,000 once per referred household (F 1,500 if its first month is Solo 1× or Duo 1×) as soon as its first subscription payment is fully verified. Neither a first wash nor a second payment is required to earn this commission. The referred household pays less for its first month: F 500 off Solo 2×, F 1,000 off Duo 2× and F 1,500 off Foyer 2×; 1× plans are at full price. It does not receive referral credit. Payouts are made manually by mobile money and tracked separately from earned commissions.",
    "partner.creatorAccessOnly": "This dashboard is for creators and influencers. For your customer friend code, contact the WASHED bureau.",
    "partner.copyCode": "Copy code",
    "partner.contactPending": "Keep this code. The WhatsApp link will be available once the bureau confirms its contact number.",
    "partner.customTitle": "Personalise my code",
    "partner.customIntro": "Choose a code that is easy to say and type, such as INF-AMA or INF-KOFI228. Households already registered stay yours. Your current code keeps working for 90 days after the change; after that it is no longer accepted, but it is never given to anyone else.",
    "partner.customLabel": "Your new code",
    "partner.customHint": "3 to 12 letters or digits, starting with a letter. The digits 0 and 1 are not accepted because they look like O and I. One change every 30 days.",
    "partner.customPreview": "Your code will be",
    "partner.customChecking": "Checking…",
    "partner.customAvailable": "Available",
    "partner.customSubmit": "Use this code",
    "partner.customDone": "Your new code is active. Share this code and link from now on.",
    "partner.customPrevious": "Previous code",
    "partner.customPreviousUntil": "still works until",
    "partner.customTooSoon": "Next change possible on",
    "partner.customUnavailable": "This code cannot be personalised. Contact the WASHED office.",
    "partner.customTOO_SHORT": "At least 3 characters after INF-.",
    "partner.customTOO_LONG": "At most 12 characters after INF-.",
    "partner.customINVALID_CHARACTERS": "Letters A to Z and digits 2 to 9 only, with no spaces or symbols.",
    "partner.customAMBIGUOUS_CHARACTERS": "The digits 0 and 1 are not accepted because they look like O and I.",
    "partner.customMUST_START_WITH_LETTER": "The code must start with a letter.",
    "partner.customRESERVED": "This code is not allowed. Choose another one.",
    "partner.customTAKEN": "This code is already taken. Try a variant, for example with digits.",
    "partner.customCURRENT": "This is already your code.",
    "partner.codeChangeTitle": "Change the creator’s code",
    "partner.codeChangeIntro": "When the creator asks, or when their code is misleading. Households already registered keep their creator. Unless you end it now, the previous code keeps working for 90 days.",
    "partner.codeChangeNew": "New code, without INF-",
    "partner.codeChangeEndNow": "End the previous code now (abusive or misleading code)",
    "partner.codeChangeSubmit": "Change the code",
    "subscriber.plan.sheet.title": "Change plan",
    "subscriber.plan.sheet.close": "Close",
    "subscriber.plan.sheet.today": "Today: {plan}, {price} F CFA a month.",
    "subscriber.plan.sheet.household_question": "How many of you are there?",
    "subscriber.plan.sheet.current": "Your current plan",
    "subscriber.plan.sheet.scheduled_note": "Scheduled change",
    "subscriber.plan.sheet.cta": "Switch to {plan}",
    "subscriber.plan.sheet.cta_idle": "Choose another plan",
    "subscriber.plan.sheet.timing_immediate": "{plan} applies right away. Your first payment will be {price} F CFA.",
    "subscriber.plan.sheet.timing_next": "This month stays on {current}. From {date}: {plan}, {price} F CFA a month.",
    "subscriber.plan.sheet.timing_next_undated": "This month stays on {current}. From your next payment: {plan}, {price} F CFA a month.",
    "subscriber.plan.sheet.scheduled": "Change scheduled: {plan} from {date}. Until then you stay on {current}.",
    "subscriber.plan.sheet.scheduled_undated": "Change scheduled: {plan} from your next payment. Until then you stay on {current}.",
    "subscriber.plan.sheet.keep": "Cancel this change",
    "subscriber.plan.sheet.kept": "You’re keeping {plan}.",
    "subscriber.plan.sheet.who_stays_title": "Who stays on your plan?",
    "subscriber.plan.sheet.who_stays_body": "Duo covers two people: you and one other. Choose who stays.",
    "subscriber.plan.sheet.solo_leaves": "Solo covers only you.",
    "subscriber.plan.sheet.leaves_one": "{names} will then no longer be on your plan.",
    "subscriber.plan.sheet.leaves_many": "{names} will then no longer be on your plan.",
    "subscriber.plan.sheet.and": "and",
    "subscriber.plan.sheet.prices_loading": "Loading prices",
    "subscriber.plan.sheet.sending": "Sending",
    "subscriber.plan.sheet.extra_wash_question": "One more wash this month?",
    "subscriber.plan.sheet.extra_wash_link": "Add a {plan} wash",
    "subscriber.auth.phone.title": "Your phone number",
    "subscriber.auth.otp.title": "The code sent by SMS",
    "subscriber.home.upcoming_visit.between_body": "Your next visit will appear here as soon as the office schedules it.",
    "subscriber.booking.request.title": "Which day for your first visit?",
    "subscriber.booking.request.subtitle": "Your visits then come back on the same weekday, and you can move one until 6 pm the day before. We confirm the date as soon as a washerwoman accepts.",
    "subscriber.booking.request.slot.morning_full": "Morning · 8 am–12 pm",
    "subscriber.booking.request.slot.morning_hours": "8 am–12 pm",
    "subscriber.booking.request.slot.afternoon_full": "Afternoon · 1–5 pm",
    "subscriber.booking.request.slot.afternoon_hours": "1–5 pm",
    "subscriber.booking.request.cancel": "Cancel",
    "subscriber.booking.confirmed.title": "Request sent",
    "subscriber.payment.failed.hero_title": "The payment failed",
    "subscriber.payment.failed.next_step": "Top up your account or change payment method, then tell the office: it will run the payment again.",
    "subscriber.payment.failed.change_label": "Change my payment method",
    "subscriber.payment.failed.whatsapp_cta": "Tell the office on WhatsApp",
    "subscriber.payment.failed.whatsapp_message": "Hello, my Washed payment failed. My account is ready: you can run the payment again.",
    "subscriber.payment.method.swap.notice": "This number will be used for the next payment, including one the office runs again after a failure.",
    "subscriber.payment.method.swap.success.title": "Payment method updated",
    "subscriber.plan.forfait.due_eyebrow": "Next payment",
    "subscriber.plan.forfait.due_cancelled": "Subscription cancelled",
    "subscriber.plan.forfait.method_label": "Payment",
    "subscriber.plan.forfait.addons_title": "Add-ons",
    "subscriber.plan.paused.hold_notice": "Your history and preferences are kept. Your usual slot is not guaranteed when you resume.",
    "subscriber.plan.paused.resume_confirm_title": "Resume your plan?",
    "subscriber.plan.paused.resume_confirm_message": "Your visits and payments restart with the payment method on file.",
    "subscriber.plan.paused.resume_confirm_action": "Resume",
    "subscriber.plan.paused.resume_confirm_change_payment": "Change payment method first",
    "subscriber.plan.upgrade.current_template": "Currently: {plan}",
    "subscriber.plan.upgrade.notice.cycle_effect": "The new price applies from the next payment.",
    "subscriber.plan.upgrade.reactivate.success_title": "Subscription reactivated",
    "subscriber.profile.edit.success.title": "Profile saved",
    "subscriber.privacy.subtitle": "What Washed knows about you, and why.",
    "subscriber.privacy.intro": "Here's the data we collect and why we use it. Retention periods are in the privacy policy.",
    "subscriber.account.deletion.deleted.receipts_kept": "Receipts (kept as accounting law requires)",
    "subscriber.repassage.quote_error": "We can't show the price right now. Check your connection and try again.",
    "subscriber.support.ticket.detail.load_failed.title": "Can't show this request",
    "subscriber.support.ticket.detail.retry": "Try again",
    "subscriber.visit.enroute.title_template": "{name} is on the way",
    "subscriber.visit.in_progress.since_template": "for {minutes} min",
    "subscriber.visit.in_progress.timeline.arrival": "Arrival",
    "subscriber.visit.reschedule.window.morning": "Morning (8 am–12 pm)",
    "subscriber.visit.reschedule.window.afternoon": "Afternoon (1–5 pm)",
    "subscriber.visit.reschedule.error.change_closed": "This visit can no longer be moved in the app: changes close at 6 pm the day before. Call the office.",
    "subscriber.visit.reschedule.error.date_closed": "That day is no longer available: changes close at 6 pm the day before. Choose another day.",
    "subscriber.visit.reveal.duration.minutes_template": "{minutes} min",
    "subscriber.visit.reveal.duration.hours_template": "{hours}h",
    "subscriber.visit.reveal.duration.hours_minutes_template": "{hours}h {minutes}m",
    "subscriber.visit.reveal.dispute_template": "Problem reported · {status}",
    "subscriber.visit.reveal.dispute.status.open": "under review",
    "subscriber.visit.reveal.dispute.status.resolved_subscriber": "resolved in your favour",
    "subscriber.visit.reveal.dispute.status.resolved_worker": "closed after review",
    "subscriber.visit.reveal.your_rating": "Your rating",
    "subscriber.visit.reveal.rate_cta": "Rate the visit",
    "subscriber.plan.extra_wash.lead": "One extra full wash on top of your plan, one per cycle. We confirm a slot with an available washer.",
    "subscriber.plan.extra_wash.price": "{price} F CFA, for your current {plan} plan",
    "subscriber.plan.extra_wash.until": "Choose a date up to {date}.",
    "subscriber.plan.extra_wash.success.plan_unchanged": "Your plan has not changed yet.",
    "subscriber.plan.pause.body_no_amount": "No visits and no payments while paused. Resume whenever you like from the Plan tab.",
    "worker.visit.not_paid": "This household’s payment hasn’t arrived yet. Don’t start: call the office.",
    "worker.visit.payment_unconfirmed_offline": "No network: this household’s payment couldn’t be checked. Don’t start: try again with network or call the office.",
    "worker.onboarding.w_00_b.title_office": "The office’s code",
    "worker.onboarding.w_00_b.copy_office": "Call the office at {phone}: they give it to you.",
    "worker.onboarding.w_00_b.copy_office_whatsapp": "Message the office on WhatsApp at {phone}: they give it to you.",
    "worker.onboarding.w_00_b.title_whatsapp": "The WhatsApp code",
    "worker.onboarding.w_00_b.field_label_code": "Six-digit code",
    "worker.onboarding.w_00_b.field_label_whatsapp": "WhatsApp code",
    "partner.termsCreatorLegacyBody": "You earn F 2,000 once per referred household as soon as its first subscription payment is fully verified. Neither a first wash nor a second payment is required to earn this commission. The referred household pays less for its first month: F 500 off Solo 1×, F 1,000 off Duo 1×, F 1,500 off Solo 2× and Foyer 1×, F 2,000 off Duo 2×, F 3,000 off Foyer 2×. It does not receive referral credit. Payouts are made manually by mobile money and tracked separately from earned commissions.",
    "ops.payout_error.invalid_provider": "Choose Mixx by Yas or Flooz.",
    "ops.payout_error.invalid_account_number": "Invalid number: 8 digits, with or without +228.",
    "ops.payout_error.destination_locked": "A payment to her current number is still in progress: settle it before changing the number.",
    "whatsapp.washer.payout_destination_set": "WASHED: your pay will now be sent to {wallet}. If you did not ask for this, reply FRAUD to this message and the office will contact you."
}
